/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: { input: string; output: string; }
  /** Represents a date, ignoring timezone */
  LocalDate: { input: string; output: string; }
  /** Civil date/time in the format yyyy-MM-dd'T'HH:mm:ss.SSS */
  LocalDateTime: { input: string; output: string; }
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  LocalTime: { input: any; output: any; }
  /**
   * Represents a date and time with explicit timezone information
   * Ex: An RFC-3339 compliant date time scalar that accepts string
   * values like 1996-12-19T16:39:57-08:00
   * See https://github.com/graphql-java/graphql-java-extended-scalars?tab=readme-ov-file#date--time-scalars
   */
  OffsetDateTime: { input: any; output: any; }
  /** A universally unique identifier compliant UUID Scalar */
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type ActivityDefaultPayload = {
  __typename?: 'ActivityDefaultPayload';
  keywords: Array<Maybe<Scalars['String']['output']>>;
  targetActionCount: Scalars['Int']['output'];
};

export type ActivityLevel = {
  __typename?: 'ActivityLevel';
  /** Factor (numeric multiplier) associated with the Activity level */
  activityLevelFactor: Scalars['Float']['output'];
  /** Current activity level */
  activityLevelName: ActivityLevelName;
};

/** ActivityLevel is an enum of available options for the Activity level */
export enum ActivityLevelName {
  Dynamic = 'DYNAMIC',
  SomewhatActive = 'SOMEWHAT_ACTIVE',
  VeryActive = 'VERY_ACTIVE'
}

export type AggregatedBloodGlucoseData = {
  __typename?: 'AggregatedBloodGlucoseData';
  /**
   *  Total number of glucose level measurements in
   *  the aggregation (considering duplicates)
   */
  glucoseLevelsCount: Scalars['Int']['output'];
  /**
   *  Range statistics used in the aggregation to define what is
   *  considered normal
   */
  normalRangeStatistics: AggregatedBloodGlucoseRangeStatisticsData;
  /**
   *  The distinct list of glucose level (in mg/dL) measurements
   *  considered in the aggregation. Only one entry is added for
   *  multiple occurrences of the same glucose level. For example,
   *  in a daily aggregation, if two glucose measurements of '130'
   *  are recorded, only one '130' will be included in the list
   */
  uniqueGlucoseLevelsMgDl: Array<Scalars['Int']['output']>;
};

export type AggregatedBloodGlucoseRangeStatisticsData = {
  __typename?: 'AggregatedBloodGlucoseRangeStatisticsData';
  /**
   *  Total percentage (0-100) of glucose level (in mg/dL)
   *  measurements within the range across the aggregation
   *  period
   */
  percentageInRange: Scalars['Float']['output'];
  /**
   *  The glucose level (in mg/dL) range used to calculate
   *  the percentage
   */
  rangeMgDl: BloodGlucoseRangeData;
};

export type AggregatedLessonsData = {
  __typename?: 'AggregatedLessonsData';
  sumLessonsCompleted: Scalars['Int']['output'];
  sumSecondsRead: Scalars['Int']['output'];
};

export type AggregatedMealData = {
  __typename?: 'AggregatedMealData';
  sumCalories: Scalars['Float']['output'];
  sumCarbohydrateMg: Scalars['Float']['output'];
  sumDietaryFiberMg: Scalars['Float']['output'];
  sumGreenCalories: Scalars['Float']['output'];
  sumOrangeCalories: Scalars['Float']['output'];
  sumOtherCalories: Scalars['Float']['output'];
  sumPotassiumMg: Scalars['Float']['output'];
  sumProteinMg: Scalars['Float']['output'];
  sumSodiumMg: Scalars['Float']['output'];
  sumTotalFatMg: Scalars['Float']['output'];
  sumYellowCalories: Scalars['Float']['output'];
};

export type AggregatedMeasurementData = {
  __typename?: 'AggregatedMeasurementData';
  aggregatedMeasurementDataOneOf: AggregatedMeasurementDataOneOf;
  beginningTimeOfAggregation: Scalars['LocalDateTime']['output'];
  endTimeOfAggregation: Scalars['LocalDateTime']['output'];
};

export type AggregatedMeasurementDataList = {
  __typename?: 'AggregatedMeasurementDataList';
  aggregatedMeasurements: Array<AggregatedMeasurementData>;
};

export type AggregatedMeasurementDataOneOf = {
  __typename?: 'AggregatedMeasurementDataOneOf';
  aggregatedBloodGlucoseData?: Maybe<AggregatedBloodGlucoseData>;
  aggregatedLessonsData?: Maybe<AggregatedLessonsData>;
  aggregatedMealData?: Maybe<AggregatedMealData>;
  aggregatedMedicationData?: Maybe<AggregatedMedicationsData>;
  aggregatedMoodData?: Maybe<AggregatedMoodData>;
  aggregatedStepsData?: Maybe<AggregatedStepsData>;
  aggregatedWaterData?: Maybe<AggregatedWaterData>;
  aggregatedWeightData?: Maybe<AggregatedWeightData>;
};

export type AggregatedMedicationData = {
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
};

export type AggregatedMedicationGData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationGData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseG: Scalars['Float']['output'];
};

export type AggregatedMedicationMcgData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMcgData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMcg: Scalars['Float']['output'];
};

export type AggregatedMedicationMgData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMgData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMg: Scalars['Float']['output'];
};

export type AggregatedMedicationMlData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationMlData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDoseMl: Scalars['Float']['output'];
};

export type AggregatedMedicationPercentData = AggregatedMedicationData & {
  __typename?: 'AggregatedMedicationPercentData';
  /**  Required */
  countDoseTaken: Scalars['Int']['output'];
  medicationExternalId: Scalars['String']['output'];
  /**  Required */
  sumDosePercent: Scalars['Float']['output'];
};

export type AggregatedMedicationsData = {
  __typename?: 'AggregatedMedicationsData';
  medications: Array<AggregatedMedicationData>;
};

export type AggregatedMoodData = {
  __typename?: 'AggregatedMoodData';
  averageMoodLevel: Scalars['Float']['output'];
};

export type AggregatedStepsData = {
  __typename?: 'AggregatedStepsData';
  sumSteps: Scalars['Int']['output'];
};

export type AggregatedWaterData = {
  __typename?: 'AggregatedWaterData';
  sumWaterLiters: Scalars['Float']['output'];
};

export type AggregatedWeightData = {
  __typename?: 'AggregatedWeightData';
  averageWeightLevel: Scalars['Float']['output'];
};

/** AI generated insight based on user activity. */
export type AiInsight = {
  __typename?: 'AiInsight';
  /** Suggested quick replies. */
  actions: Array<InsightCallToAction>;
  /** CTA header */
  ctaHeader?: Maybe<Scalars['String']['output']>;
  /** The user feedback for the insight */
  feedback?: Maybe<InsightFeedback>;
  /** Unique ID of the insight. */
  id: Scalars['ID']['output'];
  /** Text message that contains the main insight. If null, that means nothing was generated by ML. */
  insight?: Maybe<Scalars['String']['output']>;
  /** Subtitle to show to the user for the insight */
  insightSubtitle: Scalars['String']['output'];
  /** Title to show to the user for the insight */
  insightTitle: Scalars['String']['output'];
  /** Welli profile image URL. Excluding Welli from the name on purpose since the name is changeable. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

/** AI generated meal insight based on a user's meal log. */
export type AiMealInsight = {
  __typename?: 'AiMealInsight';
  /** Suggested quick replies. */
  actions: Array<InsightCallToAction>;
  /** CTA header */
  ctaHeader?: Maybe<Scalars['String']['output']>;
  /** The user feedback for the insight */
  feedback?: Maybe<InsightFeedback>;
  /** Unique ID of the meal insight. */
  id: Scalars['ID']['output'];
  /** Text message that contains an insight into the meal. If null, that means nothing was generated. */
  insight?: Maybe<Scalars['String']['output']>;
  /** Subtitle to show to the user for the insight */
  insightSubtitle: Scalars['String']['output'];
  /** Title to show to the user for the insight */
  insightTitle: Scalars['String']['output'];
  /** Welli profile image URL. Excluding Welli from the name on purpose since the name is changeable. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type AiacConfigForUser = {
  __typename?: 'AiacConfigForUser';
  isAiacAvailable?: Maybe<Scalars['Boolean']['output']>;
};

/** Name value pair that marks an analytics property and it's value, to be used in an analytics properties list */
export type AnalyticsProperty = {
  __typename?: 'AnalyticsProperty';
  /** Analytics property name */
  name: Scalars['String']['output'];
  /** Analytics property value */
  value: Scalars['String']['output'];
};

export type AnnotatedMeasurementTrendChart = {
  __typename?: 'AnnotatedMeasurementTrendChart';
  entries: Array<TrendChartEntry>;
  xAxis: LocalDateTimeRange;
  yAxis: FloatRange;
};

export type AnuraConfiguration = {
  __typename?: 'AnuraConfiguration';
  /** UUID generated to be used as an identifier for a user in Anura */
  partnerId: Scalars['UUID']['output'];
  /** Study identifier, study is a set of measurements to be taken for specific scan */
  studyId: Scalars['String']['output'];
};

export enum AnuraGender {
  /** Female */
  Female = 'FEMALE',
  /** Male */
  Male = 'MALE'
}

export type AnuraMeasurement = {
  /** Any notes provided by Anura for a specific measurements */
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of the Anura signal (specific measurement) */
  type: AnuraMeasurementType;
  /** The value of the measurement */
  value: Scalars['String']['input'];
  /** Optional array of measurement values */
  valuesArray?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AnuraMeasurementError = {
  /** Error code from Anura */
  code: Scalars['String']['input'];
  /** Map of errors happened during scan processing */
  errors?: InputMaybe<Array<AnuraMeasurementErrorEntry>>;
};

export type AnuraMeasurementErrorEntry = {
  /** Error messages for a specific signal */
  errors: Array<Scalars['String']['input']>;
  /** Signal type name */
  type: AnuraMeasurementType;
};

export enum AnuraMeasurementType {
  /** Body shape index */
  Absi = 'ABSI',
  /** Skin age in years */
  Age = 'AGE',
  /** Body Mass Index */
  BmiCalc = 'BMI_CALC',
  /** Cardiovascular Disease Risk */
  BpCvd = 'BP_CVD',
  /** Diastolic blood pressure */
  BpDiastolic = 'BP_DIASTOLIC',
  /** Risk of heart attack */
  BpHeartAttack = 'BP_HEART_ATTACK',
  /** Cardiac workload */
  BpRpp = 'BP_RPP',
  /** Risk of stroke */
  BpStroke = 'BP_STROKE',
  /** Systolic blood pressure */
  BpSystolic = 'BP_SYSTOLIC',
  /** Vascular elasticity */
  BpTau = 'BP_TAU',
  /** Breathing rate */
  BrBpm = 'BR_BPM',
  /** Risk of type 2 diabetes */
  DbtRiskProb = 'DBT_RISK_PROB',
  /** Facial body age */
  FacialBodyAge = 'FACIAL_BODY_AGE',
  /** Facial body age index */
  FacialBodyAgeIdx = 'FACIAL_BODY_AGE_IDX',
  /** Risk of fatty liver disease */
  FldRiskProb = 'FLD_RISK_PROB',
  /** Estimated gender */
  Gender = 'GENDER',
  /** Risk of prediabetes */
  Hba1CRiskProb = 'HBA1C_RISK_PROB',
  /** Risk of high cholesterol */
  HdltcRiskProb = 'HDLTC_RISK_PROB',
  /** General Wellness Score */
  HealthScore = 'HEALTH_SCORE',
  /** Estimated height */
  Height = 'HEIGHT',
  /** Risk of high blood pressure */
  HptRiskProb = 'HPT_RISK_PROB',
  /** Heart rate variability */
  HrvSdnn = 'HRV_SDNN',
  /** Heart rate */
  HrBpm = 'HR_BPM',
  /** Irregular heartbeats */
  IhbCount = 'IHB_COUNT',
  /** Mental score */
  MentalScore = 'MENTAL_SCORE',
  /** Fasting blood glucose risk */
  MfbgRiskProb = 'MFBG_RISK_PROB',
  /** Mental stress level */
  Msi = 'MSI',
  /** Overall Metabolic Health Risk */
  OverallMetabolicRiskProb = 'OVERALL_METABOLIC_RISK_PROB',
  /** Physical score */
  PhysicalScore = 'PHYSICAL_SCORE',
  /** Physio score */
  PhysioScore = 'PHYSIO_SCORE',
  /** Risks score */
  RisksScore = 'RISKS_SCORE',
  /** Signal-to-noise ratio */
  Snr = 'SNR',
  /** Risk of high triglycerides */
  TgRiskProb = 'TG_RISK_PROB',
  /** Vital score */
  VitalScore = 'VITAL_SCORE',
  /** Waist circumference */
  WaistCircum = 'WAIST_CIRCUM',
  /** Waist-to-height ratio */
  WaistToHeight = 'WAIST_TO_HEIGHT',
  /** Estimated weight */
  Weight = 'WEIGHT'
}

export type AnuraQuestionnaire = FacialBloodScanQuestionnaire & {
  __typename?: 'AnuraQuestionnaire';
  /** User's age in years */
  age: Scalars['Int']['output'];
  /** Whether the user takes blood pressure medication */
  bloodPressureMedication: Scalars['Boolean']['output'];
  /** User's diabetes type (none, type 1, type 2) */
  diabetesType: AnuraQuestionnaireDiabetesType;
  /** User's sex assigned at birth (from the buyflow) */
  gender: AnuraGender;
  /** User's height value */
  heightInCm: Scalars['Float']['output'];
  /** Server time of when the questionnaire has been saved */
  serverTimeCreated: Scalars['LocalDateTime']['output'];
  /** Whether the user smokes */
  smoking: Scalars['Boolean']['output'];
  /** User's weight value */
  weightInKg: Scalars['Float']['output'];
};

export enum AnuraQuestionnaireDiabetesType {
  /** No diabetes */
  None = 'NONE',
  /** Diabetes of type 1 */
  Type_1 = 'TYPE_1',
  /** Diabetes of type 2 */
  Type_2 = 'TYPE_2'
}

export type AnuraQuestionnaireInput = {
  /** User's date of birth */
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Whether the user takes blood pressure medication */
  bloodPressureMedication: Scalars['Boolean']['input'];
  /** User's diabetes type (none, type 1, type 2) */
  diabetesType: AnuraQuestionnaireDiabetesType;
  /** User's height value */
  heightInCm?: InputMaybe<Scalars['Float']['input']>;
  /**
   * User's sex assigned at birth (from the buyflow). It is mapped to the AnuraGender,
   * named so to be in line with the Anura property name.
   * On Anura side the measurements will be relevant only if we specify MALE or FEMALE sex,
   * so other values are not valid for initiating a scan.
   */
  sexAssignedAtBirth: Sex;
  /** Whether the user smokes */
  smoking: Scalars['Boolean']['input'];
  /** User's weight value */
  weightInKg?: InputMaybe<Scalars['Float']['input']>;
};

export type AnuraTokenInput = {
  /** Mobile application name */
  appName: Scalars['String']['input'];
  /** Mobile application version */
  appVersion: Scalars['String']['input'];
  /** Bundle identifier (e.g. DFX Client) */
  bundleIdentifier: Scalars['String']['input'];
  /** Client platform */
  platform: TargetPlatform;
};

/** Art Break content for creative mindfulness tasks. */
export type ArtBreaksContent = {
  __typename?: 'ArtBreaksContent';
  /** Text to overlay on top of the hero image, e.g. 'Mountain majesty' */
  galleryTitle?: Maybe<Scalars['String']['output']>;
  /** Cover image URL for the art break UI */
  primaryImageUrl?: Maybe<Scalars['String']['output']>;
  /** Image URL for completion state */
  secondaryImageUrl?: Maybe<Scalars['String']['output']>;
};

/** An art gallery that groups a set of curated art pieces and supporting metadata. */
export type ArtGallery = {
  __typename?: 'ArtGallery';
  /** The list of art pieces that belong to this gallery */
  artPieces?: Maybe<Array<ArtPiece>>;
  /** URL to background music for the gallery experience */
  backgroundMusicUrl?: Maybe<Scalars['String']['output']>;
  /** URL to the cover photo for the gallery (larger image used for the gallery cover) */
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the art gallery */
  id: Scalars['ID']['output'];
  /** Reflection question associated with the gallery */
  reflectionQuestion?: Maybe<Scalars['String']['output']>;
  /** URL to the thumbnail image for the gallery (cropped smaller image for task cards) */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the art gallery */
  title?: Maybe<Scalars['String']['output']>;
};

/** Art gallery content implementation */
export type ArtGalleryContent = SchedulableContent & {
  __typename?: 'ArtGalleryContent';
  /** Unique identifier for the art gallery */
  id: Scalars['ID']['output'];
  /** URL or path to the art gallery thumbnail */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Title of the art gallery */
  title: Scalars['String']['output'];
};

/** An individual art piece within a gallery. */
export type ArtPiece = {
  __typename?: 'ArtPiece';
  /** Names of the artists who created this piece */
  artistNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Description of the art piece */
  description?: Maybe<Scalars['String']['output']>;
  /** Display time period for the art piece (e.g. "early 17th century") */
  displayTimePeriod?: Maybe<Scalars['String']['output']>;
  /** Location hosting the art */
  hostedAt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the art piece */
  id: Scalars['ID']['output'];
  /** URL to the image of the art piece */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Medium/type of the artwork */
  medium?: Maybe<ArtPieceMedium>;
  /** Title of the art piece */
  title?: Maybe<Scalars['String']['output']>;
  /** Year the art piece was created */
  yearCreated?: Maybe<Scalars['Int']['output']>;
};

/** Medium/type of the artwork. */
export enum ArtPieceMedium {
  Ceramic = 'CERAMIC',
  Digital = 'DIGITAL',
  Drawing = 'DRAWING',
  Installation = 'INSTALLATION',
  MixedMedia = 'MIXED_MEDIA',
  Painting = 'PAINTING',
  Performance = 'PERFORMANCE',
  Photography = 'PHOTOGRAPHY',
  Print = 'PRINT',
  Sculpture = 'SCULPTURE',
  Textile = 'TEXTILE',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO'
}

export type ArticleAssignment = {
  __typename?: 'ArticleAssignment';
  articleDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  articleTriggers: Array<Maybe<ArticleTrigger>>;
  audioResource?: Maybe<AudioResource>;
  contentId: Scalars['String']['output'];
  contentUrl: Scalars['String']['output'];
  feedbackText: Scalars['String']['output'];
  hideMenuButton?: Maybe<Scalars['Boolean']['output']>;
  moduleId?: Maybe<Scalars['String']['output']>;
  repeatable?: Maybe<Scalars['Boolean']['output']>;
  targetPlatform?: Maybe<TargetPlatform>;
  title: Scalars['String']['output'];
  titleCompleted?: Maybe<Scalars['String']['output']>;
};

export enum ArticleTrigger {
  Autoopen = 'AUTOOPEN',
  BrainDump = 'BRAIN_DUMP',
  ColorSystem = 'COLOR_SYSTEM',
  CreatePositiveExperiences = 'CREATE_POSITIVE_EXPERIENCES',
  CreateSpace = 'CREATE_SPACE',
  DefuseThoughts = 'DEFUSE_THOUGHTS',
  FeelFeelings = 'FEEL_FEELINGS',
  FreeFeelings = 'FREE_FEELINGS',
  Gametime = 'GAMETIME',
  GenerateTasks = 'GENERATE_TASKS',
  GetGrounded = 'GET_GROUNDED',
  GratitudeRemix = 'GRATITUDE_REMIX',
  GuidedBreathing = 'GUIDED_BREATHING',
  HideFromCurriculum = 'HIDE_FROM_CURRICULUM',
  Intro = 'INTRO',
  MeetYourGroup = 'MEET_YOUR_GROUP',
  Move = 'MOVE',
  NoomCoinIntro = 'NOOM_COIN_INTRO',
  Practice = 'PRACTICE',
  PromptToContinueOrStop = 'PROMPT_TO_CONTINUE_OR_STOP',
  Reframe = 'REFRAME',
  RefreshProgramProgress = 'REFRESH_PROGRAM_PROGRESS',
  Retro = 'RETRO',
  RideWaves = 'RIDE_WAVES',
  SelfCompassionBreak = 'SELF_COMPASSION_BREAK',
  SetUp = 'SET_UP',
  SharpenToolkit = 'SHARPEN_TOOLKIT',
  ShowInMyLibrary = 'SHOW_IN_MY_LIBRARY',
  Sleep = 'SLEEP',
  Soothe = 'SOOTHE',
  Tool = 'TOOL',
  UnlockFoodLogging = 'UNLOCK_FOOD_LOGGING',
  WaterGoal = 'WATER_GOAL',
  WaterLoggingIntro = 'WATER_LOGGING_INTRO',
  WeightLossZoneIntro = 'WEIGHT_LOSS_ZONE_INTRO',
  WeighIn = 'WEIGH_IN',
  Welcome = 'WELCOME'
}

export type Assessment = {
  __typename?: 'Assessment';
  assessmentId?: Maybe<Scalars['String']['output']>;
  assessmentType?: Maybe<HealthMetricSource>;
  /** Whether this assessment's report has been viewed by the user. */
  hasReportBeenViewed?: Maybe<Scalars['Boolean']['output']>;
};

export type Assignment = ArticleAssignment | ContentSectionAssignment | StandaloneContentSectionAssignment | TrackerAssignment;

/**
 * Attribution data is used by any action with an external source. This data
 * model is a contracted version of the Attribution Data model in CoachServer,
 * with the difference being that here, we use a one-of to model polymorphism,
 * while there, a special `type` field is used.
 */
export type AttributionDataInput = {
  bodyTrace?: InputMaybe<BodyTraceAttributionDataInput>;
  googleFit?: InputMaybe<GoogleFitAttributionDataInput>;
  healthConnect?: InputMaybe<HealthConnectAttributionDataInput>;
  healthKit?: InputMaybe<HealthKitAttributionDataInput>;
  noom?: InputMaybe<NoomAppAttributionDataInput>;
  prismBodyScan?: InputMaybe<PrismBodyScanAttributionDataInput>;
  sHealth?: InputMaybe<SHealthAttributionDataInput>;
  validic?: InputMaybe<ValidicAttributionDataInput>;
  validicV2?: InputMaybe<ValidicV2AttributionDataInput>;
};

export type AudioResource = {
  __typename?: 'AudioResource';
  url: Scalars['String']['output'];
};

/**  Address structure for autocomplete address responses  */
export type AutocompleteAddress = {
  __typename?: 'AutocompleteAddress';
  /** The first address line, typically street number and street. */
  addressLine1: Scalars['String']['output'];
  /** The second address line, often for an apartment or house number. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The city or town */
  city: Scalars['String']['output'];
  /** A 2-character country code using ISO 3166-1 alpha-2 */
  countryCode: Scalars['String']['output'];
  /** The county for the address. Only populated for international addresses. */
  county?: Maybe<Scalars['String']['output']>;
  /** A full address concatenated and formatted as a single string. */
  fullAddress: Scalars['String']['output'];
  /** The full state, region or province (e.g. Illinois, Virginia, Connecticut) */
  fullZoneCode: Scalars['String']['output'];
  /** The zip code in the U.S. or other postal code */
  postalCode: Scalars['String']['output'];
  /** The state, region, or province. Abbreviated version (e.g. IL, VA, CT) */
  zoneCode: Scalars['String']['output'];
};

/** The response from an address autocomplete request. */
export type AutocompleteAddressResponse = {
  __typename?: 'AutocompleteAddressResponse';
  /** List of address suggestions. */
  addresses: Array<AutocompleteAddress>;
  /** The autocomplete service that was used for this request. */
  autocompleteService: AutocompleteService;
};

/** The external service used to perform the autocomplete. */
export enum AutocompleteService {
  /**
   * Legacy address autocomplete service.
   * https://www.here.com/docs/bundle/geocoding-and-search-api-developer-guide/page/README.html
   */
  HereGeocode = 'HERE_GEOCODE',
  /** https://www.smarty.com/docs/cloud/us-autocomplete-pro-api */
  SmartyUsAutocomplete = 'SMARTY_US_AUTOCOMPLETE'
}

export type AvailableTargetsResponse = {
  __typename?: 'AvailableTargetsResponse';
  /** List of available target values for the goal */
  availableTargets: Array<GoalMetadata>;
  /** Current goal metadata */
  currentGoal: GoalMetadata;
};

export type BatchMeasurementData = {
  __typename?: 'BatchMeasurementData';
  measurement: MeasurementDataOneOf;
  operation: BatchMeasurementOperation;
};

export type BatchMeasurementDataInput = {
  measurement: MeasurementDataInput;
  operation: BatchMeasurementOperation;
};

/**
 *  These values should be aligned with:
 *  - measurement_type.proto (MeasurementTypeProto.Id)
 */
export enum BatchMeasurementOperation {
  Delete = 'DELETE',
  Unknown = 'UNKNOWN',
  Upsert = 'UPSERT'
}

export type BatchMeasurementsData = {
  __typename?: 'BatchMeasurementsData';
  measurements: Array<BatchMeasurementData>;
};

export type BatchMeasurementsDataInput = {
  operations: Array<BatchMeasurementDataInput>;
};

/** Payload added to Biomarkers Tracker Assignments */
export type BiomarkersTrackerPayload = {
  __typename?: 'BiomarkersTrackerPayload';
  /** The date when the user's blood sample was collected */
  collectionDate: Scalars['LocalDate']['output'];
  /** The full URL of the health report */
  reportUrl?: Maybe<Scalars['String']['output']>;
  /** Has the user viewed the health report */
  reportViewed: Scalars['Boolean']['output'];
};

/**
 * Overview data broken down by day. Includes a distinct list of blood
 * glucose level readings (in mg/dL) for a specific day and the range
 * statistics used to calculate the percentage of blood glucose readings
 * within the normal range for that day
 */
export type BloodGlucoseDailyBreakdownData = {
  __typename?: 'BloodGlucoseDailyBreakdownData';
  /** The date to which this breakdown of overview data refers */
  breakdownDay: Scalars['LocalDate']['output'];
  /**
   * Statistics data used to define the percentage of blood glucose
   * level (in mg/dL) readings that fall within a range considered normal
   */
  normalRangeStatistics: BloodGlucoseRangeStatisticsData;
  /**
   * The distinct list of blood glucose level readings (in mg/dL). Only one
   * entry is added for multiple occurrences of the same blood glucose level.
   * For example, if two glucose measurements of '130' were recorded on a day,
   * only one '130' will be included in this list
   */
  uniqueGlucoseLevelsMgDl: Array<Scalars['Int']['output']>;
};

export type BloodGlucoseData = {
  __typename?: 'BloodGlucoseData';
  /**  Glucose level in mg/dL which is a numerical value between 0-800 */
  glucoseLevelMgDl: Scalars['Int']['output'];
  /**  Meal context when blood glucose measurement was taken */
  mealContext: MealContext;
  /**  date_time when blood glucose measurement was taken */
  measurementCivilDateTime: Scalars['LocalDateTime']['output'];
};

export type BloodGlucoseDataInput = {
  /**  Glucose level in mg/dL which is a numerical value between 0-800 */
  glucoseLevelMgDl: Scalars['Int']['input'];
  /**  Meal context when blood glucose measurement was taken */
  mealContext: MealContext;
  /**  date_time when blood glucose measurement was taken */
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
};

/**
 * The overview of a user's blood glucose data for a specified time period,
 * starting from a given date
 */
export type BloodGlucoseOverviewData = {
  __typename?: 'BloodGlucoseOverviewData';
  /**
   * A list of all blood glucose level readings (in mg/dL) along with their
   * respective measurement times for the specified period
   */
  completeGlucoseReadings?: Maybe<Array<Maybe<BloodGlucoseReadingData>>>;
  /**
   * Overview data broken down by day. Includes a distinct list of blood
   * glucose level readings (in mg/dL) for a specific day and the range
   * statistics used to calculate the percentage of blood glucose readings
   * within the normal range for that day
   */
  dailyBreakdown?: Maybe<Array<Maybe<BloodGlucoseDailyBreakdownData>>>;
  /** The end date for the period considered for the overview data */
  endDate: Scalars['LocalDate']['output'];
  /**
   * Statistics data used to define the percentage of blood glucose
   * level (in mg/dL) readings that fall within a range considered normal
   */
  normalRangeStatistics?: Maybe<BloodGlucoseRangeStatisticsData>;
  /** The period considered for the overview data */
  period: BloodGlucoseOverviewPeriod;
  /** The start date for the period considered for the overview data */
  startDate: Scalars['LocalDate']['output'];
};

/**
 * The possible periods that can be considered for the blood
 * glucose overview data
 */
export enum BloodGlucoseOverviewPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type BloodGlucoseRangeData = {
  __typename?: 'BloodGlucoseRangeData';
  /**  Lower bound of the range (inclusive) */
  lower: Scalars['Int']['output'];
  /**  Upper bound of the range (inclusive) */
  upper: Scalars['Int']['output'];
};

/**
 * Statistics data used to define the percentage of blood glucose
 * level (in mg/dL) readings that fall within a range considered normal
 */
export type BloodGlucoseRangeStatisticsData = {
  __typename?: 'BloodGlucoseRangeStatisticsData';
  /**
   * Total number of glucose measurements within the range
   * (optional for backwards compatibility)
   */
  countInRange?: Maybe<Scalars['Int']['output']>;
  /**
   * Total percentage (0-100) of glucose level (in mg/dL) measurements within
   * the range
   */
  percentageInRange: Scalars['Float']['output'];
  /** The glucose level (in mg/dL) range used to calculate the percentage */
  rangeMgDl: BloodGlucoseRangeData;
  /**
   * Total number of glucose measurements considered for the statistics
   * (optional for backwards compatibility)
   */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** The data of a blood glucose reading */
export type BloodGlucoseReadingData = {
  __typename?: 'BloodGlucoseReadingData';
  /** The blood glucose level reading value (in mg/dL) */
  glucoseLevelsMgDl: Scalars['Int']['output'];
  /** The meal context the blood glucose level reading was measured */
  mealContext: MealContext;
  /** The date and time when the blood glucose level reading was measured */
  readingDateTime: Scalars['LocalDateTime']['output'];
};

/** Payload added to Blood Glucose Tracker Assignments */
export type BloodGlucoseTrackerPayload = {
  __typename?: 'BloodGlucoseTrackerPayload';
  /** Indicates whether the minimum number of glucose readings required for the task has been met */
  minGlucoseReadingsCountAchieved: Scalars['Boolean']['output'];
  /** Subtitle of the task card */
  subTitle: Scalars['String']['output'];
  /** Title of the task card */
  title: Scalars['String']['output'];
};

/** Body age analysis comparing biological age to chronological age. */
export type BodyAgeReport = {
  __typename?: 'BodyAgeReport';
  /** Calculated biological age based on health metrics. */
  bodyAge: Scalars['Float']['output'];
  /** User's predicted healthy body age at ideal BMI. */
  healthyBodyAge?: Maybe<Scalars['Float']['output']>;
  /** User's actual chronological age. */
  realAge: Scalars['Float']['output'];
  /**
   * Trend comparison with the previous body scan.
   * Only populated if user has multiple scans.
   */
  trendSinceLastScan?: Maybe<Trend>;
};

/** Response from a successfully deleted body scan */
export type BodyScanDeletionResponse = {
  __typename?: 'BodyScanDeletionResponse';
  /** Unique identifier for the scan that was deleted */
  scanUuid: Scalars['UUID']['output'];
};

export type BodyScanInfo = {
  __typename?: 'BodyScanInfo';
  /** Unique identifier for the body scan */
  scanUuid: Scalars['UUID']['output'];
  /** The current status for the body scan */
  status: BodyScanStatus;
};

/**
 * Indicates what data points (if any) need to be gathered from the user
 * when they enter the body scan flow
 */
export type BodyScanIngressChecks = {
  __typename?: 'BodyScanIngressChecks';
  /**
   * If we need to show additional screen to ask user for a review of a recently
   * made body scan video to ensure everything is ok (legs position, body
   * movement, etc.)
   */
  accuracyReviewRequired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If we don't already have this information recorded, prompt the user to
   * confirm their sex
   */
  assignedSexRequired: Scalars['Boolean']['output'];
  /**
   * If we don't already have the user's birth date in the system,
   * then prompt them to enter it
   */
  birthDateRequired: Scalars['Boolean']['output'];
  /**
   * If we don't already have this information recorded, prompt the user to
   * confirm body scan mode (one of NORMAL/ATHLETE)
   */
  bodyScanModeRequired: Scalars['Boolean']['output'];
  /**
   * If the user doesn't have a recent enough weigh-in then they need
   * to confirm their current weight before creating a new body scan
   */
  currentWeightRequired: Scalars['Boolean']['output'];
  /** First time body scan users need to confirm their goal weight */
  goalWeightRequired: Scalars['Boolean']['output'];
  /** Indicates whether the user has created a body scan before */
  isNewBodyScanUser: Scalars['Boolean']['output'];
  /**
   * If the user must accept (or re-accept, in the case of updated terms)
   * the privacy policy
   */
  termsAcceptanceRequired: Scalars['Boolean']['output'];
};

/** Encapsulates a list of body scans */
export type BodyScanList = Pageable & {
  __typename?: 'BodyScanList';
  /** The body scans */
  bodyScans: Array<BodyScanSummary>;
  /** Metadata for fetching the next page of body scan results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Whether the avatar preview images should be rendered by default */
  showAvatars: Scalars['Boolean']['output'];
  /** The total number of body scans which match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * A metric which was computed from a user's body scan. Fields declared using this type should
 * be named explicitly after the measurement (ex: massInKgMetric, fatPercentMetric)
 */
export type BodyScanMetric = {
  __typename?: 'BodyScanMetric';
  /**
   * Each metric has an associated label (ex: LOW/HIGH/etc), based on how the user's
   * measured value compares to their demographic. Only populated if the user's
   * demographic info is available
   */
  label?: Maybe<BodyScanMetricHealthLabel>;
  /** The actual measured value for the metric */
  value: Scalars['Float']['output'];
};

/**
 * Enumerates the qualitative tags that can be assigned to a health metric.
 * Ex: leanMass=HIGH, fatMass=IN_RANGE, etc.
 */
export enum BodyScanMetricHealthLabel {
  High = 'HIGH',
  InRange = 'IN_RANGE',
  Low = 'LOW',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

export enum BodyScanMode {
  /** For users who have regular training */
  Athlete = 'ATHLETE',
  /** The default mode for users who do not have regular training */
  Normal = 'NORMAL'
}

/** Encapsulates the data for a body scan user settings */
export type BodyScanSettingsResponse = {
  __typename?: 'BodyScanSettingsResponse';
  mode?: Maybe<BodyScanMode>;
  showAvatar?: Maybe<Scalars['Boolean']['output']>;
};

export enum BodyScanStatus {
  /** Default status for a newly-created body scan record */
  AwaitingSubmission = 'AWAITING_SUBMISSION',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has completed
   */
  ProcessingComplete = 'PROCESSING_COMPLETE',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has failed
   */
  ProcessingFailed = 'PROCESSING_FAILED',
  /**
   * Indicates that Prism reported that the body scan processing job
   * has begun
   */
  ProcessingStarted = 'PROCESSING_STARTED',
  /**
   * The Noom backend has completed post-processing the Prism body scan
   * and the resulting Health Report is ready for the user to view
   */
  ReportReady = 'REPORT_READY',
  /** The user has viewed the health report generated for the body scan */
  ReportViewed = 'REPORT_VIEWED'
}

/** Encapsulates the data for a single body scan */
export type BodyScanSummary = {
  __typename?: 'BodyScanSummary';
  /**
   * The body fat percent computed from the user's body scan
   * @deprecated Use bodyFatPercentMetric instead
   */
  bodyFatPercent: Scalars['Float']['output'];
  /** The user's body fat as computed by the body scan. Only populated for successful scans. */
  bodyFatPercentMetric?: Maybe<BodyScanMetric>;
  /**
   * The date and time the body scan was created, from the subjective
   * point of view of the client, that is, ignoring TZ
   */
  clientCivilDate: Scalars['LocalDate']['output'];
  /** The user's fat mass as computed by the body scan. Only populated for successful scans. */
  fatMassInKgMetric?: Maybe<BodyScanMetric>;
  /** The user's lean mass as computed by the body scan. Only populated for successful scans. */
  leanMassInKgMetric?: Maybe<BodyScanMetric>;
  /** The lean mass percent computed from the user's body scan */
  leanMassPercent: Scalars['Float']['output'];
  /**
   * URL to retrieve the image byte stream, the image will be shown if the
   * show avatars toggle is on
   */
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  scanUuid: Scalars['UUID']['output'];
  status: BodyScanStatus;
  /** The user's waist to height ratio as computed by the body scan. Only populated for successful scans. */
  waistToHeightRatioMetric?: Maybe<BodyScanMetric>;
  /** The user's weight at the time of the body scan */
  weightInKg: Scalars['Float']['output'];
};

/**
 * Encapsulates the data needed to render the body scan home screen
 * tracker
 */
export type BodyScanTrackerState = {
  __typename?: 'BodyScanTrackerState';
  /** The number of completed body scans for the user */
  bodyScanCount: Scalars['Int']['output'];
  /**
   * Status of the user's current body scan, or null if the user
   * does not have an in-progress body scan
   */
  bodyScanInfo?: Maybe<BodyScanInfo>;
  /**
   * The taskList endpoint will return the body scan tracker assignment
   * every day for a user, even if it's not time to prompt that user to start
   * a new body scan. The mobile client should use this field to conditionally
   * hide the body scan home screen task card if the user should not actually
   * receive the body scan assignment for the given date
   */
  isValidAssignment: Scalars['Boolean']['output'];
};

export type BodyScanUploadMetadata = {
  __typename?: 'BodyScanUploadMetadata';
  scanUuid: Scalars['UUID']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** The client may specify any of these filter to control which body scans are returned from the backend */
export type BodyScansListFilters = {
  /**
   * If set to true, the response will only contain successfully completed body scans. By default all scans will be
   * included in the response.
   */
  onlySuccessful?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BodyTraceAttributionDataInput = {
  timestamp: Scalars['Int']['input'];
};

/** Specifies the user business type - B2B or B2C */
export enum BusinessType {
  B2B = 'B2B',
  B2C = 'B2C'
}

/** Button configuration for weight graph content. */
export type Button = {
  __typename?: 'Button';
  /** The size for the button. */
  size?: Maybe<ButtonSize>;
  /** The style for the button. */
  style?: Maybe<ButtonStyle>;
  /**
   * Target for the button. Acceptable targets are:
   * - Another screen via #<screen_id> ie #first
   * - An action via ?<action> acceptable actions are:
   * - CLOSE (ie ?CLOSE)
   * - BACK (ie ?BACK)
   * - A deeplink (ie https://link.noom.com/app?open=UPGRADE_OFFER&offer_id=plateau_ad)
   */
  target: Scalars['String']['output'];
  /** Text to put on the button. */
  text: Scalars['String']['output'];
};

/** Button size options. */
export enum ButtonSize {
  /** Large button size. */
  Large = 'LARGE',
  /** Medium button size. */
  Medium = 'MEDIUM',
  /** Small button size. */
  Small = 'SMALL',
  /** Default status for enums. */
  Unknown = 'UNKNOWN'
}

/** Button style options. */
export enum ButtonStyle {
  /** Brand button style. */
  Brand = 'BRAND',
  /** Primary button style. */
  Primary = 'PRIMARY',
  /** Secondary button style. */
  Secondary = 'SECONDARY',
  /** Tertiary button style. */
  Tertiary = 'TERTIARY',
  /** Default status for enums. */
  Unknown = 'UNKNOWN'
}

/** Survey answer entry */
export type BuyflowSurveyAnswer = {
  /** The answer as a JSON string */
  answerJson: Scalars['String']['input'];
  /** The question id */
  questionId: Scalars['String']['input'];
};

/** Additional input data for [Mutation.calculateSmartDose] */
export type CalculateSmartDoseInput = {
  /** Optional side effect data indicated by the user. */
  sideEffects?: InputMaybe<MedicationSideEffectInput>;
};

/**
 *  These values should be aligned with:
 *  - macros.proto (CalorieBudgetMacroTargetsProto)
 */
export type CalorieBudgetMacroTargets = {
  __typename?: 'CalorieBudgetMacroTargets';
  /**
   *  This value is used to calculate the recommended carbohydrate intake
   *  based on the total calorie budget.
   */
  carbsTargetPercentage: Scalars['Float']['output'];
  /**
   *  This value is used to calculate the recommended fat intake based on
   *  the total calorie budget.
   */
  fatTargetPercentage: Scalars['Float']['output'];
  /**
   *  This value is used to calculate the recommended protein intake based on
   *  the total calorie budget.
   */
  proteinTargetPercentage: Scalars['Float']['output'];
};

/**
 *  These values should be aligned with:
 *  - type CalorieBudgetMacroTargets (above)
 */
export type CalorieBudgetMacroTargetsInput = {
  carbsTargetPercentage: Scalars['Float']['input'];
  fatTargetPercentage: Scalars['Float']['input'];
  proteinTargetPercentage: Scalars['Float']['input'];
};

export type CancelMicroChallengeResponse = {
  __typename?: 'CancelMicroChallengeResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Variants definitions used to determine home card appearance and emphasis in the client UI. */
export enum CardVariant {
  /** A simple and small card variant for standard display */
  Default = 'DEFAULT',
  /** A high emphasis variant for greater attention on the screen */
  Hero = 'HERO'
}

/** Represents a redeemable charitable donation reward */
export type CharitableDonationProductListing = {
  __typename?: 'CharitableDonationProductListing';
  /** Display image for the reward */
  image: RewardImage;
  /** Minimal amount required to make a donation */
  minimalAmount: RewardsMoney;
  /** Identifier of the product */
  productSlug: Scalars['String']['output'];
  /** WebView URL for redeeming the charitable donation reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Display subtitle for the reward */
  subtitle: Scalars['String']['output'];
  /** Display title for the reward */
  title: Scalars['String']['output'];
};

/**
 * A chat channel is a grouping structure for messages and provides an interaction
 * point for users and Noom humans (coaches, care, etc)
 */
export type ChatChannel = {
  __typename?: 'ChatChannel';
  /** Returns a list of surveys for the given user. */
  csatSurveys?: Maybe<Array<CsatSurvey>>;
  /** The id for the channel */
  id: Scalars['String']['output'];
};


/**
 * A chat channel is a grouping structure for messages and provides an interaction
 * point for users and Noom humans (coaches, care, etc)
 */
export type ChatChannelCsatSurveysArgs = {
  accessCode: Scalars['String']['input'];
};

export type ClientHints = {
  __typename?: 'ClientHints';
  enableClientPostCore?: Maybe<Scalars['Boolean']['output']>;
  usedDayOffsetStrategy?: Maybe<Scalars['Boolean']['output']>;
};

/** Header that is rendered by the client for specific progress features */
export type ClientProgressHeader = {
  __typename?: 'ClientProgressHeader';
  /** The type of client header to render */
  kind: ClientProgressHeaderType;
};

/** Client-rendered progress header types */
export enum ClientProgressHeaderType {
  /** Noomcoin header, rendered by the client for progress features related to Noomcoin. */
  Noomcoin = 'NOOMCOIN',
  /** Treat Day header, rendered by the client for progress features related to treatment days. */
  TreatDay = 'TREAT_DAY',
  /** Unknown or unspecified client-rendered progress header type. */
  Unknown = 'UNKNOWN'
}

export type CoachAnnouncement = {
  __typename?: 'CoachAnnouncement';
  /** The number of visibility days for the announcement */
  activeDurationDays?: Maybe<Scalars['Int']['output']>;
  /** The first date when the announcement will be visible */
  activeStartTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  announcementId?: Maybe<Scalars['String']['output']>;
  /** If an announcements is ephemeral, it won't be shown to the users once it's been acknowledged */
  isEphemeral?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedByCduAccessCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Whether or not the coach should acknowledge that they've seen the announcement */
  requiresAcknowledgement?: Maybe<Scalars['Boolean']['output']>;
  /** Types of coaches that can see the announcement */
  ufcTypeConstraints?: Maybe<Array<Maybe<UfcType>>>;
};

export type CoachAnnouncementInfo = {
  __typename?: 'CoachAnnouncementInfo';
  /** The number of coaches that acknowledged the announcement */
  acknowledgedByCount?: Maybe<Scalars['Int']['output']>;
  coachAnnouncement?: Maybe<CoachAnnouncement>;
  /** The number of coaches that should see the announcement */
  targetedCoachesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of coaches that viewed the announcement */
  viewedByCount?: Maybe<Scalars['Int']['output']>;
};

export type CoachAnnouncementInput = {
  activeDurationInDays: Scalars['Int']['input'];
  activeStartTime: Scalars['OffsetDateTime']['input'];
  isEphemeral?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  requiresAcknowledgement: Scalars['Boolean']['input'];
  ufcTypeConstraints: Array<UfcType>;
};

export type CoachAnnouncementUserInteraction = {
  __typename?: 'CoachAnnouncementUserInteraction';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  coachAnnouncement: CoachAnnouncement;
  viewed: Scalars['Boolean']['output'];
};

export type CoachAnnouncementUserInteractions = {
  __typename?: 'CoachAnnouncementUserInteractions';
  items: Array<CoachAnnouncementUserInteraction>;
};

export type CoachAnnouncementUserInteractionsPaged = {
  __typename?: 'CoachAnnouncementUserInteractionsPaged';
  items: Array<CoachAnnouncementUserInteraction>;
  pageInfo?: Maybe<CursorPageInfo>;
};

export type CoachAnnouncementsConfig = {
  __typename?: 'CoachAnnouncementsConfig';
  isCoachAnnouncementsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CoachAnnouncementsResult = {
  __typename?: 'CoachAnnouncementsResult';
  items: Array<CoachAnnouncementInfo>;
  pageInfo?: Maybe<CursorPageInfo>;
};

export type CoachAnnouncementsUserInteractionInfo = {
  __typename?: 'CoachAnnouncementsUserInteractionInfo';
  numberOfNewAcknowledgeAnnouncements?: Maybe<Scalars['Int']['output']>;
  numberOfUnseenAnnouncements?: Maybe<Scalars['Int']['output']>;
};

export type CoachingConfig = {
  __typename?: 'CoachingConfig';
  coachAnnouncementsConfig?: Maybe<CoachAnnouncementsConfig>;
  dashboardAiacConfig?: Maybe<DashboardAiacConfig>;
};

export type CoachingConfigForUser = {
  __typename?: 'CoachingConfigForUser';
  /** If AI assisted coaching should be shown to a user */
  aiacConfig?: Maybe<AiacConfigForUser>;
};

/**
 * Metrics to display in the goal achieved screen.
 * This will be displayed as a string, depending on the goal type. For example: "120/100 calories".
 */
export type ComparisonMetrics = {
  __typename?: 'ComparisonMetrics';
  /** Current value of the goal that user has achieved. */
  currentValue: Scalars['Int']['output'];
  /** Goal target value. */
  targetValue: Scalars['Int']['output'];
};

export type CompositeMealItem = {
  __typename?: 'CompositeMealItem';
  loggedUuid: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  originUuid?: Maybe<Scalars['UUID']['output']>;
  portion?: Maybe<Portion>;
  simpleMealItems: Array<SimpleMealItem>;
};

/** Content item for content section assignment. */
export type ContentItem = {
  __typename?: 'ContentItem';
  /** Content data */
  content?: Maybe<ContentItemData>;
  /** Content url of the content task assignment */
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Description string|markdown for UI, e.g. 'Earn 250 Seeds' */
  description?: Maybe<ContentItemDescription>;
  /** Whether this content task activity has been completed */
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
};

/** A union for a different content types */
export type ContentItemData = ArtBreaksContent;

/** A union for description wrappers to allow markdown */
export type ContentItemDescription = MarkdownString | SeedsString;

/** Content section assignment for creative mindfulness tasks. */
export type ContentSectionAssignment = {
  __typename?: 'ContentSectionAssignment';
  /** List of the content activities */
  items?: Maybe<Array<ContentItem>>;
  /** Subtitle of the assignment, e.g. 'Elevate your mood with 2 minutes of art' */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the assignment, e.g. 'Take your weekly Art Break' */
  title?: Maybe<Scalars['String']['output']>;
};

/** Enum for scheduled content status lifecycle */
export enum ContentStatus {
  /** Unspecified status (default) */
  ContentStatusUnspecified = 'CONTENT_STATUS_UNSPECIFIED',
  /** Content has been published and is live */
  Published = 'PUBLISHED',
  /** Content is ready for review before publishing */
  ReadyToReview = 'READY_TO_REVIEW'
}

/** Course Map tab presentation */
export type CourseMapTab = {
  __typename?: 'CourseMapTab';
  /** Placeholder field; reserved for future Course Map tab presentation properties */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Input type for creating a new art gallery. */
export type CreateArtGalleryInput = {
  /** URL to background music for the gallery experience */
  backgroundMusicUrl?: InputMaybe<Scalars['String']['input']>;
  /** URL to the cover photo for the gallery */
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Reflection question associated with the gallery */
  reflectionQuestion?: InputMaybe<Scalars['String']['input']>;
  /** URL to the thumbnail image for the gallery */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Title of the art gallery (required) */
  title: Scalars['String']['input'];
};

/** Input type for creating a new art piece. */
export type CreateArtPieceInput = {
  /** Names of the artists who created this piece */
  artistNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description of the art piece */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Display time period for the art piece (e.g. "early 17th century") */
  displayTimePeriod?: InputMaybe<Scalars['String']['input']>;
  /** Location hosting the art */
  hostedAt?: InputMaybe<Scalars['String']['input']>;
  /** URL to the image of the art piece (required) */
  imageUrl: Scalars['String']['input'];
  /** Medium/type of the artwork */
  medium?: InputMaybe<ArtPieceMedium>;
  /** Title of the art piece (required) */
  title: Scalars['String']['input'];
  /** Year the art piece was created */
  yearCreated?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the customer support ticket that was created. */
export type CreateCustomerSupportTicketResponse = {
  __typename?: 'CreateCustomerSupportTicketResponse';
  /** Identifier of the customer support ticket that was created */
  ticketId: Scalars['String']['output'];
};

/** Input for creating a new relation request by invite code. */
export type CreateOrGetRelationByInviteCodeInput = {
  /** Client date and time when the request is made. Used to check available rewards for relation creation. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** The type of invitation code.  */
  codeType: InvitationCodeType;
  /** The target (relation) user's invite code, which will be converted to an access code. */
  codeValue: Scalars['String']['input'];
};

/** Payload returned after attempting to create a relation connection. */
export type CreateOrGetRelationPayload = {
  __typename?: 'CreateOrGetRelationPayload';
  /** Available rewards earned through this relation creation. */
  availableRewards: Array<Maybe<RelationAvailableReward>>;
  /** True if a new request was created; false if an existing record was returned. */
  created: Scalars['Boolean']['output'];
  /** The resulting relation (newly created or existing). */
  relation: Relation;
};

/** Input type for creating a new scheduled content. */
export type CreateScheduledContentInput = {
  /** ID of the content to be scheduled (e.g., art gallery ID) (required) */
  contentId: Scalars['ID']['input'];
  /** Type of content being scheduled (optional) */
  contentType?: InputMaybe<ScheduledContentType>;
  /** End date and time of the scheduled content (required) */
  endDateTime: Scalars['LocalDateTime']['input'];
  /** Start date and time of the scheduled content (required) */
  startDateTime: Scalars['LocalDateTime']['input'];
  /** Initial status of the scheduled content (optional) */
  status?: InputMaybe<ContentStatus>;
};

export type CreatorsToExclude = {
  creators?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A customer satisfaction survey that can be presented to the user to get feedback */
export type CsatSurvey = {
  __typename?: 'CsatSurvey';
  id: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  status: CsatSurveyStatus;
  textFeedback?: Maybe<Scalars['String']['output']>;
  type: CsatSurveyType;
};

/** The status of a given customer satisfaction survey */
export enum CsatSurveyStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Dismissed = 'DISMISSED',
  Expired = 'EXPIRED'
}

/** The type of a given customer satisfaction survey */
export enum CsatSurveyType {
  Deprecated = 'DEPRECATED',
  LongTermCoachInteraction = 'LONG_TERM_COACH_INTERACTION',
  ShortTermCoachInteraction = 'SHORT_TERM_COACH_INTERACTION'
}

/** Available currencies for rewards */
export enum CurrencyCode {
  /** Currency awarded for gamification action */
  Seeds = 'SEEDS'
}

/** Rewards celebration shown when user earns currency. It has two variants: modal and toast */
export type CurrencyEarnedCelebration = {
  __typename?: 'CurrencyEarnedCelebration';
  /** Currency amount earned in currency units. */
  amountEarned: Scalars['Int']['output'];
  /** Type of in-app flow. */
  flowType: CurrencyEarnedCelebrationFlowType;
  /** New rewards balance in currency units. */
  newBalance: Scalars['Int']['output'];
  /** Data on rewards sharing */
  rewardSharingData?: Maybe<RewardSharingData>;
};

/**
 * Type of currency earned flow shown to the user.
 * In older versions of the app that do not recognize the flow type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedCelebrationFlowType = CurrencyEarnedCelebrationModal | CurrencyEarnedCelebrationToast;

/** Currency earned modal flow */
export type CurrencyEarnedCelebrationModal = {
  __typename?: 'CurrencyEarnedCelebrationModal';
  /** Reason for modal celebration. Drives the subtitle text shown in the modal. */
  earningReason?: Maybe<CurrencyEarnedReason>;
  /** Animation to display in the modal. Default is SEED_DROP_LARGE. */
  seedsAnimation?: Maybe<CurrencyEarnedModalSeedsAnimation>;
};

/** Currency earned toast flow */
export type CurrencyEarnedCelebrationToast = {
  __typename?: 'CurrencyEarnedCelebrationToast';
  /** Reason for toast notification. Used to drive text displayed in the toast. */
  earningReason?: Maybe<CurrencyEarnedReason>;
};

/**
 * DEPRECATED: use CurrencyEarnedCelebration instead.
 * We're simplifying the flow by removing the progress bar, reward unlocking, and first time earning experience.
 */
export type CurrencyEarnedEvent = {
  __typename?: 'CurrencyEarnedEvent';
  /** Currency amount earned in currency units. */
  amountEarned: Scalars['Int']['output'];
  /** New rewards balance in currency units. */
  newBalance: Scalars['Int']['output'];
  /** Type of in-app notification. */
  notification: CurrencyEarnedNotificationType;
};

/** DEPRECATED */
export type CurrencyEarnedModal = {
  __typename?: 'CurrencyEarnedModal';
  /**
   * Screens to show before the main currency earned modal flow is shown.
   * @deprecated Additional screens will be provided as part of the synchronous mutation result in the celebration field in GamificationActionResult
   */
  leadingScreens?: Maybe<Array<CurrencyEarnedModalScreen>>;
  /** Flow for modal notification. Used to drive specific screens used for the notification. */
  modalFlow: CurrencyEarnedModalFlow;
  /** Reason for modal notification. Drives the subtitle text shown in the modal. */
  modalReason: CurrencyEarnedModalReason;
  /** Animation to use in the first screen that shows the amount earned. Default is SEED_DROP_LARGE. */
  seedsAnimation?: Maybe<CurrencyEarnedModalSeedsAnimation>;
  /** Whether to show the progress bar. Default is true. */
  showProgressBar?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * DEPRECATED
 * Flow for the currency earned modal notification.
 * In older versions of the app that do not recognize the flow type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedModalFlow = CurrencyEarnedModalIntro | CurrencyEarnedModalProgress | CurrencyEarnedModalRewardUnlocked;

/** DEPRECATED */
export type CurrencyEarnedModalIntro = {
  __typename?: 'CurrencyEarnedModalIntro';
  /**
   * Next reward that can be unlocked.
   * This will typically be non-null but the field is optional to keep consistency with other CurrencyEarnedModalFlow subtypes.
   * This is due to a GraphQL limitation where fields with the same name across different child types of a union need to have the same type.
   */
  nextReward?: Maybe<CurrencyEarnedReward>;
  /** Title that is shown in intro flow. */
  title?: Maybe<CurrencyEarnedModalIntroTitle>;
};

/**
 * DEPRECATED
 * Intro title for the currency earned modal notification.
 * This drives title text shown in the modal.
 * In older versions of the app that do not recognize the modal reason, EARN_SEEDS_FOR_NOOMCOIN will be used.
 */
export enum CurrencyEarnedModalIntroTitle {
  /** Title will be similar to 'You get Seeds every time you earn your daily Noomcoin!' */
  EarnSeedsForNoomcoin = 'EARN_SEEDS_FOR_NOOMCOIN',
  /** Title will be similar to 'You get Seeds every time you earn your daily Noomcoin or weigh in for the first time in a week!' */
  EarnSeedsForNoomcoinAndFirstWeeklyWeighIn = 'EARN_SEEDS_FOR_NOOMCOIN_AND_FIRST_WEEKLY_WEIGH_IN'
}

/** DEPRECATED */
export type CurrencyEarnedModalProgress = {
  __typename?: 'CurrencyEarnedModalProgress';
  /** Next reward that can be unlocked. Null if no further reward can be unlocked. */
  nextReward?: Maybe<CurrencyEarnedReward>;
};

/**
 * DEPRECATED
 * Reason for the currency earned modal notification.
 * This drives subtitle text shown in the modal.
 * In older versions of the app that do not recognize the modal reason, the text will not be shown.
 */
export enum CurrencyEarnedModalReason {
  /** User completed first weigh-in in the current week. */
  FirstWeeklyWeighIn = 'FIRST_WEEKLY_WEIGH_IN',
  /** Reason for earning the currency will not be displayed. */
  None = 'NONE',
  /** User earned a Noomcoin. */
  Noomcoin = 'NOOMCOIN'
}

/** DEPRECATED */
export type CurrencyEarnedModalRewardUnlocked = {
  __typename?: 'CurrencyEarnedModalRewardUnlocked';
  /** Next reward that can be unlocked. Null if no further reward can be unlocked. */
  nextReward?: Maybe<CurrencyEarnedReward>;
  /** Reward that was unlocked. */
  unlockedReward: CurrencyEarnedReward;
};

/**
 * DEPRECATED
 * Union representing other screens that can be shown during the currency earned modal flow.
 * In older versions of the app that do not recognize the screen type, the screen will be ignored and not displayed.
 */
export type CurrencyEarnedModalScreen = GoalAchievedScreen;

/**
 * Animation to use in the first screen of the modal.
 * In older versions of the app that do not recognize the animation type:
 * - SEED_DROP_LARGE will be used for amounts >= 500
 * - SEED_DROP_MEDIUM will be used for amounts < 500
 */
export enum CurrencyEarnedModalSeedsAnimation {
  /** Large seed drop animation, used for larger earning amounts. */
  SeedDropLarge = 'SEED_DROP_LARGE',
  /** Medium seed drop animation, used for smaller earning amounts. */
  SeedDropMedium = 'SEED_DROP_MEDIUM'
}

/**
 * DEPRECATED
 * Type of currency earned notification shown to the user.
 * In older versions of the app that do not recognize the notification type, the event will be ignored and nothing will be shown.
 */
export type CurrencyEarnedNotificationType = CurrencyEarnedModal | CurrencyEarnedToast;

/**
 * Reason for the currency earned modal celebration.
 * This drives the copy shown on the modal and toast.
 * In older versions of the app that do not recognize the reason, in case of modal flow the text will not be shown, and in case of toast flow,
 * a generic earning message will be displayed.
 */
export enum CurrencyEarnedReason {
  /** User completed an art break. */
  ArtBreak = 'ART_BREAK',
  /** User performed a body scan. */
  BodyScan = 'BODY_SCAN',
  /** User has consumed a curriculum content item. */
  CurriculumContent = 'CURRICULUM_CONTENT',
  /** User performed a facial blood scan. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** User logged food/meal data. */
  FoodLogging = 'FOOD_LOGGING',
  /** User created a friendship */
  FriendshipCreated = 'FRIENDSHIP_CREATED',
  /** Reward shared by friend earning a reward */
  FriendRewardShared = 'FRIEND_REWARD_SHARED',
  /** User logged green calories. */
  GreenCaloriesLogging = 'GREEN_CALORIES_LOGGING',
  /** User achieved their green calorie goal. */
  GreenCalorieGoal = 'GREEN_CALORIE_GOAL',
  /** User logged med data. */
  MedLogging = 'MED_LOGGING',
  /** User logged mood. */
  MoodLogging = 'MOOD_LOGGING',
  /** User logged movement. */
  MoveLogging = 'MOVE_LOGGING',
  /** User earned a Noomcoin. */
  Noomcoin = 'NOOMCOIN',
  /** User has consumed a standalone content item (initially article, but type may expand). */
  StandaloneContent = 'STANDALONE_CONTENT',
  /** User has banked currency for steps. */
  StepsBanked = 'STEPS_BANKED',
  /** Steps goal achieved. */
  StepsGoalAchieved = 'STEPS_GOAL_ACHIEVED',
  /** User reached a milestone streak length. */
  StreakMilestone = 'STREAK_MILESTONE',
  /** User logged stress data. */
  StressLogging = 'STRESS_LOGGING',
  /** User logged water drinking. */
  WaterLogging = 'WATER_LOGGING',
  /** User completed weigh in task. */
  WeighIn = 'WEIGH_IN'
}

/** DEPRECATED */
export type CurrencyEarnedReward = {
  __typename?: 'CurrencyEarnedReward';
  /** Amount required to redeem reward in currency units. */
  amount: Scalars['Int']['output'];
  /** Image for the reward */
  image: RewardImage;
  /** Type of reward */
  type: CurrencyEarnedRewardType;
};

/** DEPRECATED */
export type CurrencyEarnedRewardCharity = {
  __typename?: 'CurrencyEarnedRewardCharity';
  /** Dummy field. Needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** DEPRECATED */
export type CurrencyEarnedRewardGiftCard = {
  __typename?: 'CurrencyEarnedRewardGiftCard';
  /** Monetary amount of gift card */
  value: Money;
};

/** DEPRECATED */
export type CurrencyEarnedRewardType = CurrencyEarnedRewardCharity | CurrencyEarnedRewardGiftCard;

/** DEPRECATED */
export type CurrencyEarnedToast = {
  __typename?: 'CurrencyEarnedToast';
  /** Reason for toast notification. Used to drive text and image assets used for the notification. */
  toastReason: CurrencyEarnedToastReason;
};

/**
 * DEPRECATED
 * Reason for the currency earned toast notification.
 * This drives text shown in the toast.
 * In older versions of the app that do not recognize the toast reason, the toast will not be shown.
 */
export enum CurrencyEarnedToastReason {
  /** User weighs in for the first time in a calendar week and receives bonus currency. */
  WeighInBonus = 'WEIGH_IN_BONUS'
}

/** Payload for ART_BREAK content items. */
export type CurriculumArtBreakContent = {
  __typename?: 'CurriculumArtBreakContent';
  /** Title of the gallery for the art break */
  galleryTitle?: Maybe<Scalars['String']['output']>;
  /** Primary image URL for the art break content */
  primaryImageUrl?: Maybe<Scalars['String']['output']>;
  /** Secondary image URL for the art break content */
  secondaryImageUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Consumption state response wrapper for curriculum tasks.
 * This wrapper exists (instead of a top-level list) to allow future extensibility such as pagination.
 */
export type CurriculumContentConsumptionState = {
  __typename?: 'CurriculumContentConsumptionState';
  /** The list of tasks returned by curriculum-api for the requested content type and timestamps */
  curriculumTasks: Array<CurriculumTask>;
};

/** An individual content item within a curriculum task section. */
export type CurriculumContentItem = {
  __typename?: 'CurriculumContentItem';
  /** Content-type specific payload for this item */
  content: CurriculumContentPayload;
  /** URL for the content item (e.g., deep link or web URL) */
  contentUrl: Scalars['String']['output'];
  /** Optional description seed data used by clients to generate display text */
  descriptionSeeds?: Maybe<CurriculumDescriptionSeeds>;
  /** Whether the user has completed this content item */
  isCompleted: Scalars['Boolean']['output'];
};

/**
 * Content payload for a curriculum content item.
 * This union allows adding new content types without breaking existing clients.
 */
export type CurriculumContentPayload = CurriculumArtBreakContent;

/** Metadata for how a task is displayed/organized into a section, including the ordered items in that section. */
export type CurriculumContentTaskSectionAssignment = {
  __typename?: 'CurriculumContentTaskSectionAssignment';
  /** Ordered content items for this section */
  items: Array<CurriculumContentItem>;
  /** Section subtitle */
  subtitle: Scalars['String']['output'];
  /** Section title */
  title: Scalars['String']['output'];
};

/**
 * Content types supported by curriculum-api for content consumption tasks.
 * Start small (ART_BREAK) and extend as backend adds new types.
 */
export enum CurriculumContentType {
  /** Art break content tasks */
  ArtBreak = 'ART_BREAK'
}

/** Seed data used to construct human-readable descriptions for content items. */
export type CurriculumDescriptionSeeds = {
  __typename?: 'CurriculumDescriptionSeeds';
  /** A seed value used by clients to generate the description */
  value: Scalars['String']['output'];
};

/**
 *  These values should be aligned with:
 *  - noom_contracts/backend/curriculum/model/shared.proto (CurriculumEditorActionTypeProto.Value)
 */
export enum CurriculumEditorAction {
  Delete = 'DELETE',
  Publish = 'PUBLISH',
  SaveDraft = 'SAVE_DRAFT',
  SendToQa = 'SEND_TO_QA',
  Unknown = 'UNKNOWN'
}

/**  Details about an editor action. It shows when was an editor action last taken (if at all). */
export type CurriculumEditorActionDetails = {
  __typename?: 'CurriculumEditorActionDetails';
  /**
   *  The action last taken datetime can be null if we need to report about
   *  an action that has never been taken.
   */
  actionLastTakenAt?: Maybe<Scalars['LocalDateTime']['output']>;
  actionType: CurriculumEditorAction;
};

/**  Composes all details about actions editors can take or have taken */
export type CurriculumEditorActionsDetails = {
  __typename?: 'CurriculumEditorActionsDetails';
  editorActionDetails: Array<CurriculumEditorActionDetails>;
  nextEditorActions: Array<CurriculumEditorAction>;
};

/** Represents a module within a curriculum program */
export type CurriculumModule = {
  __typename?: 'CurriculumModule';
  /** Optional description of the module */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the module */
  moduleId: Scalars['UUID']['output'];
  /** Name of the module */
  name: Scalars['String']['output'];
};

export type CurriculumModules = {
  __typename?: 'CurriculumModules';
  curriculumModules: Array<CurriculumModule>;
};

/** Clients may specify filtering options to control which modules they need */
export type CurriculumModulesFilters = {
  /** If specified, filters the list of modules by this list of module IDs, in the same order */
  moduleIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** If specified, filters the list of modules by module name */
  moduleName?: InputMaybe<Scalars['String']['input']>;
  /** If specified, returned modules must be referenced by the specified program */
  programConfigId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Basic definition of a program within a curriculum */
export type CurriculumProgram = {
  __typename?: 'CurriculumProgram';
  /** Program description. It's present for all programs, but it's optional in CurE, so it's optional here. */
  description?: Maybe<Scalars['String']['output']>;
  /** Program name */
  name: Scalars['String']['output'];
  /** Program Config ID coming from CurE. The same as in Curriculum API. */
  programConfigId: Scalars['UUID']['output'];
};

export type CurriculumPrograms = {
  __typename?: 'CurriculumPrograms';
  programs: Array<CurriculumProgram>;
};

/** A single task within the curriculum content consumption response. */
export type CurriculumTask = {
  __typename?: 'CurriculumTask';
  /** Section assignment information for this task */
  contentTaskSectionAssignment: CurriculumContentTaskSectionAssignment;
  /** The content type of this task */
  taskType: CurriculumContentType;
};

export type CurriculumWorkflowActionInput = {
  actionId: Scalars['ID']['input'];
  actionType: CurriculumEditorAction;
  objectId: Scalars['ID']['input'];
  objectType: CurriculumWorkflowObjectType;
};

/**
 *  These values should be aligned with:
 *  - noom_contracts/backend/curriculum/model/shared.proto (CurriculumWorkflowActionObjectTypeProto)
 */
export enum CurriculumWorkflowObjectType {
  Foundation = 'FOUNDATION',
  Unknown = 'UNKNOWN'
}

/** Metadata for a single page from a paginated set of results */
export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  /** Opaque token which represents the cursor for the current page */
  currentPageCursor: Scalars['String']['output'];
  /** Opaque token the client may use to fetch the next page, or null if none exists */
  nextPageCursor?: Maybe<Scalars['String']['output']>;
};

/** Provides the client the ability to paginate through a list of results */
export type CursorPagination = {
  /** Opaque token that specifies the page of results to retrieve. If unset, will default to the first page */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * The maximum number of results to include in the response. Note the backend may impose a stricter limit than
   * the client requests.
   */
  first: Scalars['Int']['input'];
  /** Dictates the order in which the results are returned. At least one Sort predicate must be defined */
  sort: Array<Sort>;
};

export type DailyStepsPayload = {
  __typename?: 'DailyStepsPayload';
  target: Scalars['Int']['output'];
};

export type DashboardAiacConfig = {
  __typename?: 'DashboardAiacConfig';
  isDashboardAiacEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a day of the week */
export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DecagonSignatureToken = {
  __typename?: 'DecagonSignatureToken';
  /** Specifies the user business type - B2B or B2C */
  businessType?: Maybe<BusinessType>;
  /** List of user entitlements */
  entitlements?: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp when the signature expires, represented as Unix epoch time */
  expiryEpochInSeconds: Scalars['Int']['output'];
  /** The external user id corresponding to the user access code for whom the signature is generated */
  externalUserId: Scalars['String']['output'];
  /** Any additional metadata serialized as JSON string */
  metadataJson?: Maybe<Scalars['String']['output']>;
  /** ID of the user's associated B2B Partner */
  partnerId?: Maybe<Scalars['Int']['output']>;
  /** Name of the user's associated B2B Partner */
  partnerName?: Maybe<Scalars['String']['output']>;
  /** HMAC-SHA256 signature used for validating the authenticity of the user with Decagon */
  signature: Scalars['String']['output'];
  /** User subscription tier */
  subscriptionTier?: Maybe<SubscriptionTier>;
};

/** Input for deleting a relations request. */
export type DeleteRelationInput = {
  /** The type of relations.  */
  relationType: RelationType;
  /** The target user's access code. */
  targetUserAccessCode: Scalars['String']['input'];
};

/** Payload returned after attempting to delete a relations. */
export type DeleteRelationPayload = {
  __typename?: 'DeleteRelationPayload';
  /** True if a relations was deleted; false if a relations can't be deleted for some reason. */
  success: Scalars['Boolean']['output'];
};

/** Response from successfully deleting scheduled content */
export type DeleteScheduledContentResponse = {
  __typename?: 'DeleteScheduledContentResponse';
  /** The scheduled content that was deleted */
  scheduledContent: ScheduledContent;
};

/** Input for dismissing a customer satisfaction survey */
export type DismissCsatSurveyInput = {
  dismissedBy: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
};

export type Document = {
  __typename?: 'Document';
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  lastAcceptedTime?: Maybe<Scalars['OffsetDateTime']['output']>;
  type: DocumentType;
};

/** Enum representing the different types of documents that can be accepted */
export enum DocumentType {
  /** Business Associate Agreement (BAA) */
  Baa = 'BAA',
  CoachLicenseAgreement = 'COACH_LICENSE_AGREEMENT',
  /** Data Processing Agreement (DPA) */
  Dpa = 'DPA',
  PrivacyPolicy = 'PRIVACY_POLICY'
}

/**
 *  These values should be aligned with:
 *  - measurement_type.proto (MeasurementTypeProto.Id)
 */
export enum DoseUnits {
  DoseInG = 'DOSE_IN_G',
  DoseInMcg = 'DOSE_IN_MCG',
  DoseInMg = 'DOSE_IN_MG',
  DoseInMl = 'DOSE_IN_ML',
  DoseInPercent = 'DOSE_IN_PERCENT',
  Unknown = 'UNKNOWN'
}

/** Encapsulates the data needed to render the calorie goal settings screen */
export type DynamicCalorieGoalSettingsState = {
  __typename?: 'DynamicCalorieGoalSettingsState';
  /** The activity level for the user */
  activityLevel: ActivityLevel;
  /** Whether the user has enabled external BMR source */
  externalBmrEnabled: Scalars['Boolean']['output'];
  /** Optional external BMR value, used to replace the BMR calculated from weight, height and gender */
  externalBmrValue?: Maybe<Scalars['Int']['output']>;
  /** Number of calories to manually add (if positive number) or subtract (if negative) from the calculated BMR. */
  manualCalorieAdjustment?: Maybe<Scalars['Int']['output']>;
};

/** DEPRECATED: Represents the different ways user can earn rewards currency */
export type EarnCurrencyMethod = {
  __typename?: 'EarnCurrencyMethod';
  /** The type of method used to earn rewards currency */
  type: EarnCurrencyMethodType;
  /** Currency units (seeds) awarded when requirements are met. */
  value: Scalars['Int']['output'];
};

/** DEPRECATED: The different types of earn currency methods */
export enum EarnCurrencyMethodType {
  /** Earn currency by earning 1 noomcoin */
  Noomcoin = 'NOOMCOIN',
  /** Earn currency by weighing in */
  WeighIn = 'WEIGH_IN'
}

export enum EatingReason {
  Bored = 'BORED',
  DontKnow = 'DONT_KNOW',
  Hungry = 'HUNGRY',
  ItWasTime = 'IT_WAS_TIME',
  Social = 'SOCIAL',
  Stressed = 'STRESSED',
  Tired = 'TIRED'
}

/** Represents a Streak Repair product */
export type EngagementStreakRepairProductListing = {
  __typename?: 'EngagementStreakRepairProductListing';
  /** Required amount to redeem a streak repair */
  amount: RewardsMoney;
  /** Whether if the user meets the product specific eligibility criteria */
  isRedemptionEligible: Scalars['Boolean']['output'];
  /** Identifier of the product */
  productSlug: Scalars['String']['output'];
  /** Length of the broken streak to be repaired */
  streakLength: Scalars['Int']['output'];
};

/** Status of user that is enrolled in rewards program. */
export type EnrolledRewardsState = {
  __typename?: 'EnrolledRewardsState';
  /** Rewards balance in currency units (seeds). */
  balance: Scalars['Int']['output'];
};

export type ExampleArticle = ExampleInterfaceContent & {
  __typename?: 'ExampleArticle';
  /**  Text body of the article */
  body: Scalars['String']['output'];
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

/**  If the items in your union don't need any fields of their own, consider using an enum instead */
export enum ExampleEnumStatus {
  Failure = 'FAILURE',
  /**  States in the enum don't have their own fields, but represent distinct, non-overlapping cases like unions do. */
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

/**
 *  If fields are shared between types, an interface allows for easier querying by specifying those fields once at the top
 *  level instead of repeating those fields for each type. The shared fields still have to be defined on each implementing
 *  type. Interfaces aren't allowed to end with the word interface!
 */
export type ExampleInterfaceContent = {
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

export type ExampleMultipleChoiceQuiz = ExampleInterfaceContent & {
  __typename?: 'ExampleMultipleChoiceQuiz';
  /**  Short description of the article for previews */
  description: Scalars['String']['output'];
  /**  List of multiple choice options to choose from */
  options: Array<Scalars['String']['output']>;
  /**  Title to show at the top */
  title: Scalars['String']['output'];
};

export type ExampleNullableItem = {
  __typename?: 'ExampleNullableItem';
  /**  Fields with ! are required */
  id: Scalars['ID']['output'];
  /**  Fields without ! can be omitted */
  optionalField?: Maybe<Scalars['String']['output']>;
};

/**
 *  Different list nullability states. Use the non-null list, non-null items by default. Nullable list items pose a risk.
 *  Only use nullableListNonNullItems if you need to model empty lists and null lists as separate states.
 */
export type ExampleNullableList = {
  __typename?: 'ExampleNullableList';
  /**  RECOMMENDED DEFAULT: list can't be null, items within the list can't be null */
  nonNullListNonNullItems: Array<ExampleNullableItem>;
  /**  AVOID: list can't be null, items within the list can be null */
  nonNullListNullableItems: Array<Maybe<ExampleNullableItem>>;
  /**  USE SPARINGLY: list can be null, items within the list can't be null */
  nullableListNonNullItems?: Maybe<Array<ExampleNullableItem>>;
  /**  AVOID: list can be null, items within the list can be null */
  nullableListNullableItems?: Maybe<Array<Maybe<ExampleNullableItem>>>;
};

export type ExampleStatusFailure = {
  __typename?: 'ExampleStatusFailure';
  /**  Error message to display to the user */
  errorMessage: Scalars['String']['output'];
};

/**
 *  In Protobuf, we achieve polymorphism using one-ofs, which specify an exclusive list of types that could be included.
 *  GraphQL doesn't have that construct, but does offer both interfaces and unions as mechanisms to model polymorphism.
 *  Both interfaces and unions have to be defined ahead of time. If it's unclear whether we'll need to support
 *  polymorphism, it's much better not to use a union or an interface since it may lead to restrictive or unintuitive type
 *  modeling down the line! In these cases, using a semantic comment above fields is a reasonable compromise.
 *  Unions are useful for describing types which have distinct possible states that don't have overlapping fields. They
 *  can be used to model scenarios which are more complicated than enums since each type within the union can have fields
 *  that are specific to that type. However, if there are shared fields between the types, an interface may be a better
 *  fit.
 */
export type ExampleStatusPending = {
  __typename?: 'ExampleStatusPending';
  /**  When the operation began */
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ExampleStatusSuccess = {
  __typename?: 'ExampleStatusSuccess';
  /**  Time the operation took to complete */
  timeElapsedMs: Scalars['Int']['output'];
};

export type ExampleStepData = {
  __typename?: 'ExampleStepData';
  /**  Step data is keyed by date (e.g. 2024-07-19) */
  date: Scalars['LocalDate']['output'];
  /**  Cumulative step count for the day */
  stepCount: Scalars['Int']['output'];
  /**  Target step count for the day */
  stepGoal: Scalars['Int']['output'];
};

export type ExampleStepsData = {
  __typename?: 'ExampleStepsData';
  /**
   *  In protobuf, we would likely model this as a map from date to step data, but here we model it as a list and use
   *  with the date field representing the key
   */
  stepData: Array<ExampleStepData>;
};

export type ExampleUnionStatus = ExampleStatusFailure | ExampleStatusPending | ExampleStatusSuccess;

export type ExtendMicroChallengeResponse = {
  __typename?: 'ExtendMicroChallengeResponse';
  error?: Maybe<Scalars['String']['output']>;
  newExpiresAt?: Maybe<Scalars['LocalDateTime']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalCoachingTermsAndConditionsInfo = {
  __typename?: 'ExternalCoachingTermsAndConditionsInfo';
  documents: Array<Document>;
};

export type ExternalCoachingTermsAndConditionsInput = {
  documents: Array<DocumentType>;
};

export type FaceScanError = {
  __typename?: 'FaceScanError';
  /** Type of the error message */
  faceScanErrorType: FaceScanErrorType;
  /** Body of the error message */
  messageBody?: Maybe<Scalars['String']['output']>;
  /** Title of the error message */
  messageTitle?: Maybe<Scalars['String']['output']>;
};

export enum FaceScanErrorType {
  Disabled = 'DISABLED',
  FatalError = 'FATAL_ERROR',
  NonFatalError = 'NON_FATAL_ERROR',
  ProcessingError = 'PROCESSING_ERROR',
  ProviderDown = 'PROVIDER_DOWN',
  Unknown = 'UNKNOWN'
}

export type FaceScanImageAndBackground = {
  __typename?: 'FaceScanImageAndBackground';
  imageBackgroundDownloadUrl: Scalars['String']['output'];
  imageDownloadUrl: Scalars['String']['output'];
};

export type FaceScanImageProcessingState = FaceScanError | FaceScanNotStarted | FaceScanProcessing | FaceScanResults;

export type FaceScanImageUploadHeader = {
  __typename?: 'FaceScanImageUploadHeader';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FaceScanInitializationInfo = {
  __typename?: 'FaceScanInitializationInfo';
  errorMessageBody?: Maybe<Scalars['String']['output']>;
  errorMessageTitle?: Maybe<Scalars['String']['output']>;
  processingScreenData: FaceScanProcessing;
  state: FaceScanInitializationState;
  uploadContentType: Scalars['String']['output'];
  uploadHeaders: Array<FaceScanImageUploadHeader>;
  uploadMethod: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export enum FaceScanInitializationState {
  Disabled = 'DISABLED',
  Error = 'ERROR',
  FatalError = 'FATAL_ERROR',
  NonFatalError = 'NON_FATAL_ERROR',
  Ok = 'OK',
  Unknown = 'UNKNOWN'
}

export type FaceScanLoadingScreenTips = {
  __typename?: 'FaceScanLoadingScreenTips';
  otherLines: Scalars['String']['output'];
  sourceLine: Scalars['String']['output'];
  topLine: Scalars['String']['output'];
};

export type FaceScanNotStarted = {
  __typename?: 'FaceScanNotStarted';
  /** Message in case we need to notify anything */
  message?: Maybe<Scalars['String']['output']>;
};

export type FaceScanProcessing = {
  __typename?: 'FaceScanProcessing';
  /** The image to show while the face scan gets processed */
  image: Scalars['String']['output'];
  /** Messages to show with the loading bar/icon to the user while the images get processed */
  loadingScreenAnalysisMessages: Array<Scalars['String']['output']>;
  /** Messages to show in the LOADING screen to the user while the images get processed */
  loadingScreenTips: Array<FaceScanLoadingScreenTips>;
};

export type FaceScanResults = {
  __typename?: 'FaceScanResults';
  badHabitsImageAndBackground: FaceScanImageAndBackground;
  /** @deprecated Use badHabitsImageAndBackground instead */
  badHabitsImageDownloadUrl: Scalars['String']['output'];
  badHabitsItems: Array<Scalars['String']['output']>;
  /** @deprecated Use badHabitsMarkdownHeader and badHabitsItems instead */
  badHabitsMarkdown: Scalars['String']['output'];
  badHabitsMarkdownHeader: Scalars['String']['output'];
  badHabitsSwitchButton: Scalars['String']['output'];
  choiceButton: Scalars['String']['output'];
  clientDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  goodHabitsImageAndBackground: FaceScanImageAndBackground;
  /** @deprecated Use goodHabitsImageAndBackground instead */
  goodHabitsImageDownloadUrl: Scalars['String']['output'];
  goodHabitsItems: Array<Scalars['String']['output']>;
  /** @deprecated Use goodHabitsMarkdownHeader and goodHabitsItems instead */
  goodHabitsMarkdown: Scalars['String']['output'];
  goodHabitsMarkdownHeader: Scalars['String']['output'];
  goodHabitsSwitchButton: Scalars['String']['output'];
  shareables: Array<Maybe<ShareableMedia>>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** State of face scan task */
export type FaceScanTask = {
  __typename?: 'FaceScanTask';
  state: FaceScanTaskState;
};

/** Represents the 'Completed' state of a face scan Task where processing has been completed */
export type FaceScanTaskCompleted = {
  __typename?: 'FaceScanTaskCompleted';
  /** The URL where the generated face scan image can be accessed */
  imageUrl: Scalars['String']['output'];
  /** The unique identifier of the completed scan */
  scanId: Scalars['UUID']['output'];
  /** How many years in future is scan */
  yearsInFuture: Scalars['Int']['output'];
};

/** Represents the 'Hidden' state of a face scan Task where no processing has been initiated */
export type FaceScanTaskHidden = {
  __typename?: 'FaceScanTaskHidden';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents the 'InProgress' state of a face scan Task where processing is currently ongoing */
export type FaceScanTaskInProgress = {
  __typename?: 'FaceScanTaskInProgress';
  /** The unique identifier of the scan in progress */
  scanId: Scalars['UUID']['output'];
};

/** Represents the 'Ready' state of a face scan Task face scan is ready to be initiated */
export type FaceScanTaskReady = {
  __typename?: 'FaceScanTaskReady';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Union type representing the different states of a face scan Task */
export type FaceScanTaskState = FaceScanTaskCompleted | FaceScanTaskHidden | FaceScanTaskInProgress | FaceScanTaskReady;

/**
 * Metadata needed for the facial blood scan introduction flow.
 * Contains information about the user's data collection status to help
 * determine which pages to show during the introduction flow.
 */
export type FacialBloodScanIntroMetadata = {
  __typename?: 'FacialBloodScanIntroMetadata';
  /**
   * Total number of completed facial blood scans for this user.
   * Used to show different introduction content for first-time users (0)
   * versus returning users (>0).
   */
  facialBloodScanCount: Scalars['Int']['output'];
  /** Whether user already answered the facial blood scan questionnaire */
  hasCompletedQuestionnaire?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether date of birth has been collected from any source (user profile,
   * questionnaire, etc.).
   */
  hasDateOfBirth: Scalars['Boolean']['output'];
};

/** Enumerates the facial blood scan 3rd party providers */
export enum FacialBloodScanProvider {
  Anura = 'ANURA'
}

export type FacialBloodScanQuestionnaire = {
  /** Server time of when the questionnaire has been saved */
  serverTimeCreated: Scalars['LocalDateTime']['output'];
};

/**
 * The status of the current scan, indicating where the user is in that scans
 * flow, and how to proceed.
 */
export enum FacialBloodScanStatus {
  /** There has been in error while generating the scan or processing the results */
  Error = 'ERROR',
  /** The report is ready. Any processing of the scan is complete */
  ReportReady = 'REPORT_READY',
  /** The report has been viewed by the user. */
  ReportViewed = 'REPORT_VIEWED',
  /** Indicates the user is due for another facial blood scan */
  ScanDue = 'SCAN_DUE'
}

export type FacialBloodScanToken = {
  __typename?: 'FacialBloodScanToken';
  /** Authentication token used for API authorization */
  authToken: Scalars['String']['output'];
  /** One time token used to obtain a new auth token when it expires */
  refreshToken: Scalars['String']['output'];
  /** Time in seconds until the refresh token expires */
  refreshTokenExpirationSeconds: Scalars['Int']['output'];
  /** Time in seconds until the auth token expires */
  tokenExpirationSeconds: Scalars['Int']['output'];
};

export type FacialBloodScanTokenInput = {
  anuraTokenInput?: InputMaybe<AnuraTokenInput>;
};

/** Payload added to Facial Blood Scan Tracker Assignments */
export type FacialBloodScanTrackerPayload = {
  __typename?: 'FacialBloodScanTrackerPayload';
  /** Optional ISO-8601 timestamp string from the original task list request */
  clientTimestamp?: Maybe<Scalars['String']['output']>;
  /**
   * Details about the latest scan. If the user has no scan, this field
   * will not be included.
   */
  state?: Maybe<FacialBloodScanTrackerPayloadState>;
  /** The total number of scans the user has */
  totalCount: Scalars['Int']['output'];
};

/** Representation of the latest scan status */
export type FacialBloodScanTrackerPayloadState = {
  __typename?: 'FacialBloodScanTrackerPayloadState';
  /** UUID of the most recent scan */
  scanUuid: Scalars['UUID']['output'];
  /** The status of the recent scan */
  status?: Maybe<FacialBloodScanStatus>;
};

/** Fixed content (e.g. static articles) served by url */
export type FixedContent = {
  __typename?: 'FixedContent';
  /** Url for audio version of FixedContent */
  audioSourceUrl?: Maybe<Scalars['String']['output']>;
  /** Describes to user how long to expect reading takes */
  averageReadingDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  /** Id for content analytics */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Indicates how to display FixedContent */
  contentType: FixedContentType;
  /** Url for fixed content */
  contentUrl: Scalars['String']['output'];
  /** ImageUrl for FixedContent */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Display title */
  title: Scalars['String']['output'];
};

/** Groups fixed content into titled sections */
export type FixedContentSection = {
  __typename?: 'FixedContentSection';
  /** List of FixedContent for section of fixed content */
  fixedContentList: Array<FixedContent>;
  /** Section Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Differentiates between articles and future types */
export enum FixedContentType {
  /** Article - contentUrl driven fixed content */
  Article = 'ARTICLE',
  /** Unknown type required by proto */
  FixedContentTypeUnknown = 'FIXED_CONTENT_TYPE_UNKNOWN'
}

export type FloatRange = {
  __typename?: 'FloatRange';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type FoodCalorieBar = {
  __typename?: 'FoodCalorieBar';
  foodColor?: Maybe<FoodColor>;
  goalInCals: Scalars['Float']['output'];
  valueInCals: Scalars['Float']['output'];
};

/**
 *  These values should be aligned with:
 *  - food_colors.proto (FoodColorProto)
 */
export enum FoodColor {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN',
  Yellow = 'YELLOW'
}

/** Response containing the presigned URL for uploading a food image */
export type FoodImageUploadUrlResponse = {
  __typename?: 'FoodImageUploadUrlResponse';
  /** The S3 key identifying this image, used in subsequent meal logging calls */
  s3Key: Scalars['String']['output'];
  /** The presigned URL for uploading the image via HTTP PUT */
  uploadUrl: Scalars['String']['output'];
};

/** Glucose forecast data associated with a specific food item */
export type FoodItemForecast = {
  __typename?: 'FoodItemForecast';
  /** Glucose spike classification assigned to this food item */
  spikeClassification: SpikeClassification;
  /** Time series data containing glucose values projected over time */
  timeSeriesData: Array<GlucoseTimeSeriesPoint>;
};

/**
 * Information about an individual food item that was logged.
 *
 * Note: we have calories, greenCalories, yellowCalories and orangeCalories as nullable because
 * some food items are expected to have only calories and color while others are expected to not have
 * the calories field populated, but the green, yellow or orangle calories fields populated.
 *
 * masterFoodUuid, customFoodUuid and name attributes will not be used by the backend at initial feature launch.
 */
export type FoodItemInput = {
  /** Calories in the food */
  calories?: InputMaybe<Scalars['Float']['input']>;
  /** Food color */
  color: FoodColor;
  /** Custom food UUID (either this will be present or masterFoodUuid) */
  customFoodUuid?: InputMaybe<Scalars['String']['input']>;
  /** Green calories of the food entry (if applicable) */
  greenCalories?: InputMaybe<Scalars['Float']['input']>;
  /** Master food UUID (either this will be present or customFoodUuid) */
  masterFoodUuid?: InputMaybe<Scalars['String']['input']>;
  /** The name of the food */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Orange calories of the food entry (if applicable) */
  orangeCalories?: InputMaybe<Scalars['Float']['input']>;
  /** Yellow calories of the food entry (if applicable) */
  yellowCalories?: InputMaybe<Scalars['Float']['input']>;
};

/**  Represents the state data of all food logging related features */
export type FoodLoggingFeaturesStates = {
  __typename?: 'FoodLoggingFeaturesStates';
  /**  Feature state containing configuration for the glucose forecasting feature */
  glucoseForecastingState: GlucoseForecastingFeatureState;
  /**  Feature state containing the configuration for meal logging method selector UI */
  loggingMethodSelectorState: MealLoggingMethodSelectorFeatureState;
};

/** Association between a food item identifier and its corresponding forecast data */
export type ForecastByFoodItem = {
  __typename?: 'ForecastByFoodItem';
  /** Glucose forecast data for the associated food item */
  foodItemForecast: FoodItemForecast;
  /** Unique identifier for the food item */
  foodItemId: Scalars['String']['output'];
};

/** Enumeration of specific reasons why glucose forecast generation may fail */
export enum ForecastErrorReason {
  MissingAge = 'MISSING_AGE',
  Unknown = 'UNKNOWN'
}

/** Enumeration of specific reasons why the forecast could not be generated */
export enum ForecastUnavailableReason {
  /** User's age could not be found */
  MissingAge = 'MISSING_AGE',
  /** User's height could not be found */
  MissingHeight = 'MISSING_HEIGHT',
  /** User's sex could not be found */
  MissingSex = 'MISSING_SEX',
  /** User's weight could not be found */
  MissingWeight = 'MISSING_WEIGHT',
  /** Reason could not be determined */
  Unknown = 'UNKNOWN'
}

/** Data input for art break gamification action */
export type GamificationActionArtBreakDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
};

/** Data input for body scan gamification action - triggered when user performs a body scan */
export type GamificationActionBodyScanDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
};

/** Data input for curriculum content consumed gamification action */
export type GamificationActionCurriculumContentDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/**
 * Data input type that contains features-specific data sent from the client. This is used to map Gamification action type to Domain SOA.
 * The team who's integrating a feature with rewards is responsible for creating an input type for their feature.
 * It's up to the team to decide what data to send to the backend - the context needed to process the action can be provided either by the client, or the backend.
 */
export type GamificationActionDataInput = {
  /** Art break data input */
  artBreak?: InputMaybe<GamificationActionArtBreakDataInput>;
  /** Body scan data input */
  bodyScan?: InputMaybe<GamificationActionBodyScanDataInput>;
  /** Reading curriculum content data input */
  curriculumContent?: InputMaybe<GamificationActionCurriculumContentDataInput>;
  /** Face scan data input */
  faceScan?: InputMaybe<GamificationActionFaceScanDataInput>;
  /** Facial blood scan data input */
  facialBloodScan?: InputMaybe<GamificationActionFacialBloodScanDataInput>;
  /** Food logging data input */
  foodLogging?: InputMaybe<GamificationActionFoodLoggingDataInput>;
  /** Med logging data input */
  medLogging?: InputMaybe<GamificationActionMedLoggingDataInput>;
  /** Mood logging data input */
  moodLogging?: InputMaybe<GamificationActionMoodLoggingDataInput>;
  /** Movement logging data input */
  moveLogging?: InputMaybe<GamificationActionMoveLoggingDataInput>;
  /** Reading standalone content data input */
  standaloneContent?: InputMaybe<GamificationActionStandaloneContentDataInput>;
  /** Step banking data input */
  stepBanking?: InputMaybe<GamificationActionStepBankingDataInput>;
  /** Stress logging data input */
  stressLogging?: InputMaybe<GamificationActionStressLoggingDataInput>;
  /** Water logging data input */
  waterLogging?: InputMaybe<GamificationActionWaterLoggingDataInput>;
  /** Weight logging data input */
  weightLogging?: InputMaybe<GamificationActionWeightLoggingDataInput>;
};

/** Data input for face scan gamification action - triggered when user performs a face scan */
export type GamificationActionFaceScanDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
};

/** Data input for facial blood scan gamification action - triggered when user performs a facial blood scan */
export type GamificationActionFacialBloodScanDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** 3rd party facial blood scan provider */
  provider: FacialBloodScanProvider;
};

/** Data input for food logging gamification action - triggered when user logs or updates a meal */
export type GamificationActionFoodLoggingDataInput = {
  /** User's current local time and date with timezone, used for determining the day context */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Total green calories across all meals for the current day */
  greenCaloriesCurrent: Scalars['Float']['input'];
  /** Current green calories goal for the user */
  greenCaloriesTarget: Scalars['Int']['input'];
  /** True indicates a new meal has been recorded, false means an existing meal has been updated */
  isNewMeal: Scalars['Boolean']['input'];
};

/** Data input for med logging gamification action - triggered when user logs medicine ingestion */
export type GamificationActionMedLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Data input for mood logging gamification action - triggered when user logs a mood */
export type GamificationActionMoodLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Data input for move logging gamification action - triggered when user logs movement */
export type GamificationActionMoveLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Result of processing a gamification action - returns celebrations and processing results */
export type GamificationActionResult = {
  __typename?: 'GamificationActionResult';
  /**
   * List of celebrations triggered by the gamification action (one action can trigger multiple celebrations)
   * E.g. when a user achieves daily goal with an action, celebrations list would contain GoalAchieved, and CurrencyEarnedEvent(modal) celebrations
   */
  celebrations?: Maybe<Array<GamificationCelebration>>;
  /** Processing result related to rewards */
  rewardsResult?: Maybe<GamificationActionRewardsResult>;
  /** Processing results related to streaks */
  streaksResults?: Maybe<Array<Maybe<GamificationActionStreaksResult>>>;
};

/**
 * Processing a rewards-specific gamification action didn't trigger a balance update.
 * In the future this can be expanded with an explanation on why the balance was not updated.
 */
export type GamificationActionRewardsBalanceUnchanged = {
  __typename?: 'GamificationActionRewardsBalanceUnchanged';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a balance update for a specific reward within a gamification action */
export type GamificationActionRewardsBalanceUpdate = {
  __typename?: 'GamificationActionRewardsBalanceUpdate';
  /** The amount of currency earned for this specific reward */
  amountEarned: Scalars['Int']['output'];
  /** The reason why currency was earned, e.g. completing a Noomcoin */
  reason: GamificationActionRewardsBalanceUpdateReason;
};

/**
 * Reason for the currency balance update.
 * Used on clients for cases when we want to break down the total amount earned - e.g. for analytics
 */
export enum GamificationActionRewardsBalanceUpdateReason {
  /** User completed an art break. */
  ArtBreak = 'ART_BREAK',
  /** User performed a body scan. */
  BodyScan = 'BODY_SCAN',
  /** User has consumed a curriculum content item. */
  CurriculumContent = 'CURRICULUM_CONTENT',
  /** User performed a facial blood scan. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** User logged food/meal data. */
  FoodLogging = 'FOOD_LOGGING',
  /** Reward shared by friend earning a reward */
  FriendRewardShared = 'FRIEND_REWARD_SHARED',
  /** User logged green calories. */
  GreenCaloriesLogging = 'GREEN_CALORIES_LOGGING',
  /** User achieved their green calorie goal. */
  GreenCalorieGoal = 'GREEN_CALORIE_GOAL',
  /** User logged med data. */
  MedLogging = 'MED_LOGGING',
  /** User logged mood. */
  MoodLogging = 'MOOD_LOGGING',
  /** User logged movement. */
  MoveLogging = 'MOVE_LOGGING',
  /** User earned a Noomcoin */
  Noomcoin = 'NOOMCOIN',
  /** User completed standalone content item */
  StandaloneContent = 'STANDALONE_CONTENT',
  /** User banked steps */
  StepBanking = 'STEP_BANKING',
  /** User banked step goal */
  StepGoalBanking = 'STEP_GOAL_BANKING',
  /** User banked steps onboarding reward */
  StepOnboardingRewardBanking = 'STEP_ONBOARDING_REWARD_BANKING',
  /** User reached a milestone streak length */
  StreakMilestone = 'STREAK_MILESTONE',
  /** User logged stress data. */
  StressLogging = 'STRESS_LOGGING',
  /** User logged water drinking. */
  WaterLogging = 'WATER_LOGGING',
  /** User completed weigh-in task. */
  WeighIn = 'WEIGH_IN'
}

/** Processing a rewards-specific gamification action triggered a balance update */
export type GamificationActionRewardsBalanceUpdated = {
  __typename?: 'GamificationActionRewardsBalanceUpdated';
  /** Total amount of currency earned from the action */
  amountEarned: Scalars['Int']['output'];
  /** Breakdown of balance updates by individual reward type - sum equals amountEarned */
  balanceUpdatesPerReward?: Maybe<Array<GamificationActionRewardsBalanceUpdate>>;
};

/**
 * Processing a rewards-specific gamification action failed.
 * In the future this can be expanded with a field that indicates the cause of failure.
 */
export type GamificationActionRewardsFailure = {
  __typename?: 'GamificationActionRewardsFailure';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Union of rewards specific processing results */
export type GamificationActionRewardsResult = GamificationActionRewardsBalanceUnchanged | GamificationActionRewardsBalanceUpdated | GamificationActionRewardsFailure;

/** Data input for standalone content consumed gamification action */
export type GamificationActionStandaloneContentDataInput = {
  /** User's local date */
  clientDate: Scalars['LocalDate']['input'];
};

/** Data input for step banking gamification action - data for generating granting context is provided by the domain SOA */
export type GamificationActionStepBankingDataInput = {
  /** The user's selected date, for determining the range of steps measurements to use */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Flag, used to determine if required to include onboarding steps reward to the list of gamification actions */
  onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's current selected program ID, used for determining the user's current steps goal */
  programId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Processing a streaks-specific gamification action failed.
 * In the future this can be expanded with a field that indicates the cause of failure.
 */
export type GamificationActionStreakFailure = {
  __typename?: 'GamificationActionStreakFailure';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Processing a streak update succeeded.
 * In the future this can be expanded with fields expanding on the result of update.
 */
export type GamificationActionStreakUpdated = {
  __typename?: 'GamificationActionStreakUpdated';
  /** Dummy field, needed since GraphQL doesn't support empty types */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** The wrapper for a processing result for a specific streak type. */
export type GamificationActionStreaksResult = {
  __typename?: 'GamificationActionStreaksResult';
  /** Processing result for this specific streak type */
  result?: Maybe<StreakProcessingResult>;
  /** Type of the streak the result is referring to */
  streakType?: Maybe<StreakType>;
};

/** Data input for stress logging gamification action - triggered when user logs a stress status */
export type GamificationActionStressLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Data input for water logging gamification action - triggered when user logs water ingestion */
export type GamificationActionWaterLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/** Data input for weight logging gamification action - triggered when user logs their weight */
export type GamificationActionWeightLoggingDataInput = {
  /** The user's local date and time, including their timezone. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /**
   * The date the gamification action should be applied to. This is typically the same date
   * as 'clientDateTime', but can be a past date if the user is back-logging content.
   */
  loggedForDate: Scalars['LocalDate']['input'];
};

/**
 * Union type representing different types of celebrations that can be triggered by gamification actions.
 * In older versions of the app that do not recognize the celebration type, the celebration will be ignored.
 */
export type GamificationCelebration = CurrencyEarnedCelebration | GoalAchievedCelebration | StreakIncreasedCelebration;

/**
 * Represents application-level errors that occur during forecast generation.
 * This does not replace HTTP 4xx or 5xx status codes, but provides structured
 * error information when the forecast cannot be completed due to known business
 * logic constraints that require client awareness.
 */
export type GenerateGlucoseForecastErrorResponse = {
  __typename?: 'GenerateGlucoseForecastErrorResponse';
  /** Specific error code indicating why the glucose forecast could not be generated */
  reason: ForecastErrorReason;
};

/** Union type representing either a successful forecast response or an error response */
export type GenerateGlucoseForecastResponse = GenerateGlucoseForecastErrorResponse | GenerateGlucoseForecastSuccessResponse;

/** Union type representing either a successful forecast response or a response for when the forecast is unavailable */
export type GenerateGlucoseForecastResponseV2 = GenerateGlucoseForecastSuccessResponse | GenerateGlucoseForecastUnavailableResponse;

/** Successful response containing the generated glucose forecast data */
export type GenerateGlucoseForecastSuccessResponse = {
  __typename?: 'GenerateGlucoseForecastSuccessResponse';
  /** Collection of food items mapped to their respective forecast data */
  forecastByFoodItem: Array<ForecastByFoodItem>;
};

/**
 * Response for when the forecast is unavailable.
 * This does not replace HTTP 4xx or 5xx status codes, but provides structured
 * way to inform clients that the forecast could not be generated because of
 * expected constraints (e.g. missing user data).
 */
export type GenerateGlucoseForecastUnavailableResponse = {
  __typename?: 'GenerateGlucoseForecastUnavailableResponse';
  /** Specific reason indicating why the glucose forecast could not be generated */
  reason: ForecastUnavailableReason;
};

/** Represents a redeemable gift card reward */
export type GiftCardProductListing = {
  __typename?: 'GiftCardProductListing';
  /** Required amount to redeem the gift card */
  amount: RewardsMoney;
  /** Identifier of the product */
  productSlug: Scalars['String']['output'];
  /** WebView URL for redeeming the gift card reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Monetary value of the gift card */
  value: Money;
};

/** Input parameters containing nutritional information for a food item used in glucose forecasting */
export type GlucoseForecastFoodItemInput = {
  /** Total carbohydrate content measured in milligrams */
  carbsMilligrams: Scalars['Float']['input'];
  /** Total fat content measured in milligrams */
  fatMilligrams: Scalars['Float']['input'];
  /** Unique identifier for the food item */
  id: Scalars['String']['input'];
  /** Total protein content measured in milligrams */
  proteinMilligrams: Scalars['Float']['input'];
};

/**  Represents the state of the glucose forecasting feature for a user */
export type GlucoseForecastingFeatureState = {
  __typename?: 'GlucoseForecastingFeatureState';
  /**  Indicates whether the glucose forecasting feature is enabled */
  isEnabled: Scalars['Boolean']['output'];
};

/** Individual data point within a glucose time series */
export type GlucoseTimeSeriesPoint = {
  __typename?: 'GlucoseTimeSeriesPoint';
  /** Predicted glucose level in milligrams per deciliter (mg/dL) */
  glucoseLevelMgDl: Scalars['Int']['output'];
  /** Time offset in minutes relative to the forecast start time */
  minute: Scalars['Int']['output'];
  /**
   * More precise version of the predicted glucose level in milligrams per deciliter (mg/dL)
   * that includes decimal points.
   */
  preciseGlucoseLevelMgDl: Scalars['Float']['output'];
};

/** Celebration shown when user achieves a goal. */
export type GoalAchievedCelebration = {
  __typename?: 'GoalAchievedCelebration';
  /** Metrics to display in the goal achieved celebration. If null, metrics will not be displayed. */
  metrics?: Maybe<GoalAchievedMetrics>;
  /** Type of goal achieved (required). */
  type?: Maybe<GoalAchievedType>;
};

/**
 * Union type for the metrics to display in the goal achieved screen.
 * In older versions of the app that do not recognize the metrics type, metrics will not be displayed.
 */
export type GoalAchievedMetrics = ComparisonMetrics;

/** DEPRECATED: use GoalAchievedCelebration instead */
export type GoalAchievedScreen = {
  __typename?: 'GoalAchievedScreen';
  /** Metrics to display in the goal achieved screen. If null, metrics will not be displayed. */
  metrics?: Maybe<GoalAchievedMetrics>;
  /** Type of goal achieved (required). */
  type?: Maybe<GoalAchievedType>;
};

/**
 * Type of goal achieved.
 * This drives UI assets used in the goal achieved screen - highlight color, goal text, and header animation.
 * In older versions of the app that do not recognize the goal achieved type, the goal achieved screen will be ignored and not displayed.
 */
export enum GoalAchievedType {
  /** Green calorie goal. */
  GreenCalorie = 'GREEN_CALORIE',
  /** Steps goal */
  Steps = 'STEPS'
}

/**
 *  These values should be aligned with:
 *  - goal_id_enum.proto (GoalIdEnumProto.Value.Id)
 */
export enum GoalId {
  DailyStepsAtLeastCount = 'DAILY_STEPS_AT_LEAST_COUNT',
  DrinkAtLeastWaterUnits = 'DRINK_AT_LEAST_WATER_UNITS',
  IngestBelowCalorieUnits = 'INGEST_BELOW_CALORIE_UNITS',
  LogBloodGlucoseReadingAtLeastCount = 'LOG_BLOOD_GLUCOSE_READING_AT_LEAST_COUNT',
  LogGreenCaloriesAtLeastCount = 'LOG_GREEN_CALORIES_AT_LEAST_COUNT',
  LogHighBloodGlucoseReading = 'LOG_HIGH_BLOOD_GLUCOSE_READING',
  LogLowBloodGlucoseReading = 'LOG_LOW_BLOOD_GLUCOSE_READING',
  LogMealsAtLeastCount = 'LOG_MEALS_AT_LEAST_COUNT',
  LogMedicationDoseAtLeastCount = 'LOG_MEDICATION_DOSE_AT_LEAST_COUNT',
  LogMedicationMetforminDoseAtLeastCount = 'LOG_MEDICATION_METFORMIN_DOSE_AT_LEAST_COUNT',
  LogVeryHighBloodGlucoseReading = 'LOG_VERY_HIGH_BLOOD_GLUCOSE_READING',
  LogVeryLowBloodGlucoseReading = 'LOG_VERY_LOW_BLOOD_GLUCOSE_READING',
  TakeAtLeastMedicationDoseCount = 'TAKE_AT_LEAST_MEDICATION_DOSE_COUNT',
  Unknown = 'UNKNOWN'
}

export type GoalMetadata = GreenCaloriesGoalMetadata | MedicationGoalMetadata | StepGoalMetadata | WaterGoalMetadata;

export type GoalTarget = {
  greenCaloriesTarget?: InputMaybe<GreenCaloriesTarget>;
  stepTarget?: InputMaybe<StepTarget>;
  waterTarget?: InputMaybe<WaterTarget>;
};

export type GoogleFitAttributionDataInput = {
  /** Package name of the app inserting data. */
  packageName: Scalars['String']['input'];
  /** Name of the app inserting data in Google Fit. */
  sourceName: Scalars['String']['input'];
  timestamp: Scalars['Int']['input'];
};

/** A graph widget on the Trends surface */
export type GraphWidget = {
  __typename?: 'GraphWidget';
  /** Content of the graph widget (union of supported graph types) */
  content: GraphWidgetContent;
};

/** Union of supported graph widget types */
export type GraphWidgetContent = ToolGraph;

export type GreenCaloriesGoalMetadata = {
  __typename?: 'GreenCaloriesGoalMetadata';
  minGreenCalories?: Maybe<Scalars['Int']['output']>;
};

export type GreenCaloriesTarget = {
  minGreenCalories?: InputMaybe<Scalars['Int']['input']>;
};

export enum HeaderAnimation {
  Apple = 'APPLE',
  BarGraph = 'BAR_GRAPH',
  Camera = 'CAMERA',
  One = 'ONE',
  Plant = 'PLANT',
  Rocket = 'ROCKET',
  Target = 'TARGET'
}

/** A header widget on the Trends surface */
export type HeaderWidget = {
  __typename?: 'HeaderWidget';
  /** Content of the header widget (union of supported header types) */
  content: HeaderWidgetContent;
};

/** Union of supported header widget types */
export type HeaderWidgetContent = ClientProgressHeader | ToolHeader;

export type HealthConnectAttributionDataInput = {
  /** List of package names of the apps inserting data. Steps data could have multiple data providers. Other types of data will have one provider. */
  packageNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Supported health-data providers. */
export enum HealthDataProvider {
  /** Validic provider. */
  Validic = 'VALIDIC'
}

/**
 * Represents the external user identity for a Noom user within a given health-data
 * provider.
 */
export type HealthDataProviderUser = {
  __typename?: 'HealthDataProviderUser';
  /** User's access code in the Noom system. */
  accessCode: Scalars['String']['output'];
  /** Partner user account details for this user. */
  partnerUserAccountDetails?: Maybe<PartnerUserAccountDetails>;
  /** Which provider this user is associated with. */
  provider: HealthDataProvider;
  /** The unique identifier for the user in the provider system. */
  providerUserId: Scalars['String']['output'];
};

/** Health insights data, providing an overview of available scan data and actionable items for users. */
export type HealthInsights = {
  __typename?: 'HealthInsights';
  /**
   * Actionable items encouraging users to take specific health assessments
   * or follow up on existing scan results.
   */
  actions: Array<HealthScanItem>;
  /**
   * Tiles displaying available scan types and their current status.
   * Shows users what health assessments they can take or have taken.
   */
  tiles: Array<HealthScanItem>;
};

/** Health Insights tab presentation */
export type HealthInsightsTab = {
  __typename?: 'HealthInsightsTab';
  /** Placeholder field; reserved for future Health Insights tab presentation properties */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthKitAttributionDataInput = {
  /** The bundle identifier of the app inserting the data. */
  bundleIdentifier: Scalars['String']['input'];
  /** Name of the app inserting data in HealthKit. */
  sourceName: Scalars['String']['input'];
};

/** Reference range for a specific health status level. */
export type HealthLabelRange = {
  __typename?: 'HealthLabelRange';
  /** Maximum value for this range (inclusive). */
  max?: Maybe<Scalars['Float']['output']>;
  /** Minimum value for this range (inclusive). */
  min?: Maybe<Scalars['Float']['output']>;
  /** Health status classification for values in this range. */
  status: HealthStatus;
  /** Unit of measurement for this range (e.g., "%", "mg/dL"). */
  unit?: Maybe<HealthMetricUnit>;
};

/** Individual health metric with current value and detailed information. */
export type HealthMetric = {
  __typename?: 'HealthMetric';
  /** Detailed information about this metric including reference ranges. */
  detail: HealthMetricDetail;
  /** Most recent measurement value for this metric. */
  latestMetricValue: HealthMetricValue;
  /** Name of this health metric. */
  name: HealthMetricName;
};

/** Detailed information about a health metric including reference ranges and source. */
export type HealthMetricDetail = {
  __typename?: 'HealthMetricDetail';
  /** Reference ranges for different health status levels. */
  healthLabels: Array<HealthLabelRange>;
  /** Source of this metric data for presentation purposes. */
  source?: Maybe<HealthMetricSource>;
  /** The weight of the metric. Metrics with higher weight are shown first. */
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Individual health metric names. */
export enum HealthMetricName {
  /** Alanine aminotransferase enzyme levels. */
  AlanineAminotransferase = 'ALANINE_AMINOTRANSFERASE',
  /** Apolipoprotein B levels. */
  ApolipoproteinB = 'APOLIPOPROTEIN_B',
  /** Basal Metabolic Rate - calories burned at rest. */
  BasalMetabolicRate = 'BASAL_METABOLIC_RATE',
  /** Body fat percentage. */
  BodyFatPercentage = 'BODY_FAT_PERCENTAGE',
  /** Respiratory rate measurement. */
  BreathingRate = 'BREATHING_RATE',
  /** Cardiac workload assessment. */
  CardiacWorkload = 'CARDIAC_WORKLOAD',
  /** Total cholesterol levels. */
  Cholesterol = 'CHOLESTEROL',
  /** CHOLESTEROL_HDL_RATIO levels for Labs. */
  CholesterolHdlRatio = 'CHOLESTEROL_HDL_RATIO',
  /** Dehydroepiandrosterone sulfate levels. */
  DehydroepiandrosteroneSulfate = 'DEHYDROEPIANDROSTERONE_SULFATE',
  /** Estradiol hormone levels. */
  Estradiol = 'ESTRADIOL',
  /** Total fat mass in the body. */
  FatMass = 'FAT_MASS',
  /** Heart rate measurement. */
  HeartRate = 'HEART_RATE',
  /** Heart rate variability analysis. */
  HeartRateVariability = 'HEART_RATE_VARIABILITY',
  /** Hemoglobin A1C levels for diabetes monitoring. */
  HemoglobinA1C = 'HEMOGLOBIN_A1C',
  /** High-density lipoprotein cholesterol. */
  HighDensityLipoproteinCholesterol = 'HIGH_DENSITY_LIPOPROTEIN_CHOLESTEROL',
  /** High-sensitivity C-reactive protein levels. */
  HighSensitivityCReactiveProtein = 'HIGH_SENSITIVITY_C_REACTIVE_PROTEIN',
  /** Detection of irregular heartbeat patterns. */
  IrregularHeartbeats = 'IRREGULAR_HEARTBEATS',
  /** LDL_APOB_RATIO levels for Labs. */
  LdlApobRatio = 'LDL_APOB_RATIO',
  /** Total lean mass in the body. */
  LeanMass = 'LEAN_MASS',
  /** Likelihood of avoiding heart attack (inverted from risk). */
  LikelihoodOfAvoidingHeartAttack = 'LIKELIHOOD_OF_AVOIDING_HEART_ATTACK',
  /** Likelihood of avoiding stroke (inverted from risk). */
  LikelihoodOfAvoidingStroke = 'LIKELIHOOD_OF_AVOIDING_STROKE',
  /** Likelihood of avoiding Type 2 diabetes (inverted from risk). */
  LikelihoodOfAvoidingType_2Diabetes = 'LIKELIHOOD_OF_AVOIDING_TYPE_2_DIABETES',
  /** Lipoprotein(a) levels. */
  LipoproteinA = 'LIPOPROTEIN_A',
  /**
   * Long-term risk assessment for heart attack.
   * @deprecated Use LIKELIHOOD_OF_AVOIDING_HEART_ATTACK instead for positive framing.
   */
  LongTermRiskOfHeartAttack = 'LONG_TERM_RISK_OF_HEART_ATTACK',
  /**
   * Long-term risk assessment for stroke.
   * @deprecated Use LIKELIHOOD_OF_AVOIDING_STROKE instead for positive framing.
   */
  LongTermRiskOfStroke = 'LONG_TERM_RISK_OF_STROKE',
  /** Low-density lipoprotein cholesterol. */
  LowDensityLipoproteinCholesterol = 'LOW_DENSITY_LIPOPROTEIN_CHOLESTEROL',
  /** Luteinizing hormone levels for Labs. */
  LuteinizingHormone = 'LUTEINIZING_HORMONE',
  /** General body measurements. */
  Measurements = 'MEASUREMENTS',
  /** Mental stress level assessment. */
  MentalStressLevel = 'MENTAL_STRESS_LEVEL',
  /** Risk assessment for developing fatty liver disease. */
  RiskOfFattyLiverDisease = 'RISK_OF_FATTY_LIVER_DISEASE',
  /** Risk assessment for developing high blood pressure. */
  RiskOfHighBloodPressure = 'RISK_OF_HIGH_BLOOD_PRESSURE',
  /** Risk assessment for developing high cholesterol. */
  RiskOfHighCholesterol = 'RISK_OF_HIGH_CHOLESTEROL',
  /** Risk assessment for developing high triglycerides. */
  RiskOfHighTriglycerides = 'RISK_OF_HIGH_TRIGLYCERIDES',
  /** Risk assessment for developing prediabetes. */
  RiskOfPrediabetes = 'RISK_OF_PREDIABETES',
  /**
   * Risk assessment for developing Type 2 diabetes.
   * @deprecated Use LIKELIHOOD_OF_AVOIDING_TYPE_2_DIABETES instead for positive framing.
   */
  RiskOfType_2Diabetes = 'RISK_OF_TYPE_2_DIABETES',
  /** Total testosterone hormone levels. */
  TotalTestosterone = 'TOTAL_TESTOSTERONE',
  /** Triglyceride levels. */
  Triglycerides = 'TRIGLYCERIDES',
  /** TRIGLYCERIDES_HDL_RATIO levels for Labs. */
  TriglyceridesHdlRatio = 'TRIGLYCERIDES_HDL_RATIO',
  /** Blood vessel elasticity and flexibility. */
  VascularElasticity = 'VASCULAR_ELASTICITY',
  /** Vitamin B12 levels. */
  VitaminB12 = 'VITAMIN_B12',
  /** Vitamin D levels. */
  VitaminD = 'VITAMIN_D',
  /** Waist to height ratio measurement. */
  WaistToHeightRatio = 'WAIST_TO_HEIGHT_RATIO'
}

/** Content for health metric overview. */
export type HealthMetricOverviewContent = {
  __typename?: 'HealthMetricOverviewContent';
  /** Reference to the image that will be shown depending on the framing. */
  arrowImageUrl: Scalars['String']['output'];
  /**
   * Represents how we will frame the claims of the program for that metric.
   * Eg: "Lose upto 11lbs in 30 days"
   * Eg: "Reduce your risk of heart attack"
   */
  metricClaimFraming: Scalars['String']['output'];
};

/**
 * Source of health metric data used for frontend presentation grouping.
 * This helps the frontend group metrics with appropriate subtitles like
 * "Last update from your Blood Test on 6/2/2025".
 */
export enum HealthMetricSource {
  /** Data sourced from body scan analysis. */
  BodyScan = 'BODY_SCAN',
  /** Data sourced from facial blood scan technology. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** Data sourced from Future Me analysis. */
  FutureMe = 'FUTURE_ME',
  /** Data sourced from laboratory blood tests. */
  Labs = 'LABS'
}

/** Units of measurement for health metrics. */
export enum HealthMetricUnit {
  /** Beats per minute - heart rate measurement. */
  BeatsPerMinute = 'BEATS_PER_MINUTE',
  /** Breaths per minute - respiratory rate. */
  BreathsPerMinute = 'BREATHS_PER_MINUTE',
  /** Calories - unit of energy measurement. */
  Calories = 'CALORIES',
  /** Decibels (dB) - sound intensity measurement. */
  Db = 'DB',
  /** Inches (in) - length measurement. */
  In = 'IN',
  /** Inches per inch (in/in) - ratio measurement. */
  InPerIn = 'IN_PER_IN',
  /** Pounds (lbs) - weight measurement. */
  Lbs = 'LBS',
  /** Milligrams per deciliter (mg/dL) - concentration measurement. */
  MgDl = 'MG_DL',
  /** Milliseconds (ms) - time measurement. */
  Milliseconds = 'MILLISECONDS',
  /** Milli-international units per milliliter (mIU/mL) */
  MiuMl = 'MIU_ML',
  /** Nanograms per deciliter (ng/dL) - concentration measurement. */
  NgDl = 'NG_DL',
  /** Nanograms per milliliter (ng/mL) - concentration measurement. */
  NgMl = 'NG_ML',
  /** Percentage (%). */
  Percent = 'PERCENT',
  /** Picograms per milliliter (pg/mL) - concentration measurement. */
  PgMl = 'PG_ML',
  /** Seconds - time measurement. */
  Seconds = 'SECONDS',
  /** Micrograms per deciliter (ug/dL) - concentration measurement. */
  UgDl = 'UG_DL',
  /** Dimensionless count or index */
  Unitless = 'UNITLESS',
  /** Units per liter (U/L) - enzyme activity measurement. */
  UL = 'U_L'
}

/** User's biological age information. */
export type HealthMetricUpsellBiologicalAge = {
  __typename?: 'HealthMetricUpsellBiologicalAge';
  /** The user's current age. */
  currentAge: Scalars['Float']['output'];
  /** User's face scan age. */
  faceScanAge?: Maybe<Scalars['Float']['output']>;
  /** Biological age at healthy BMI. */
  healthyBmiAge: Scalars['Float']['output'];
};

/** Content for health metric upsell learn more section. */
export type HealthMetricUpsellLearnMoreContent = {
  __typename?: 'HealthMetricUpsellLearnMoreContent';
  /**
   * Footnotes that contain supporting information for the claim.
   * NOTE: This will be a html component that encodes all of the footnotes.
   */
  footnotes: Scalars['String']['output'];
  /** The label for the metric that determines the status of the metric (e.g. NEEDS_ATTENTION, FAIR). */
  label: HealthStatus;
  /** Description of the health label enum that determines what to show for the user. Eg: "Needs Attention" */
  labelDescription: Scalars['String']['output'];
  /**
   * Additional information corresponding to the metric.
   * Eg: "Losing 5-10% of body weight has been shown to... lowering heart attack risk"
   */
  metricDescription: Scalars['String']['output'];
  /**
   * The string representation of the metric type enum.
   * Eg: "Likelihood of avoiding heart attack"
   */
  metricTitle: Scalars['String']['output'];
  /** The health metric type. */
  metricType: HealthMetricName;
};

/** Group of health metric upsell content shown in the learn more page. */
export type HealthMetricUpsellLearnMoreContentGroup = {
  __typename?: 'HealthMetricUpsellLearnMoreContentGroup';
  /** The health metrics that belong to this group. */
  metrics: Array<HealthMetricUpsellLearnMoreContent>;
  /**
   * The subtitle text to display for this group of health metrics.
   * Eg: "Noom weight is designed to improve the following..."
   * Eg: "Noom weight is designed to further improve these healthy metrics..."
   */
  subtitle: Scalars['String']['output'];
};

/** Current or historical measurement value for a health metric. */
export type HealthMetricValue = {
  __typename?: 'HealthMetricValue';
  /** Health status classification for this value. */
  status?: Maybe<HealthStatus>;
  /** Date and time when this measurement was taken. */
  timestamp: Scalars['LocalDateTime']['output'];
  /** Trend comparison with the first recorded measurement. */
  trendFromFirst?: Maybe<Trend>;
  /** Trend comparison with the previous measurement. */
  trendFromPrevious?: Maybe<Trend>;
  /** Unit of measurement for the value. */
  unit?: Maybe<HealthMetricUnit>;
  /** Numerical value of the measurement. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Available health pillar names. */
export enum HealthPillarName {
  /** Cardiovascular health and heart-related metrics. */
  HeartHealth = 'HEART_HEALTH',
  /** Hormone levels and endocrine system health. */
  HormoneBalance = 'HORMONE_BALANCE',
  /** Inflammation markers and immune system health. */
  Inflammation = 'INFLAMMATION',
  /** Blood sugar, cholesterol, and metabolism-related metrics. */
  MetabolicHealth = 'METABOLIC_HEALTH'
}

/** Health assessment for a specific pillar (e.g., heart health, metabolic health). */
export type HealthPillarReport = {
  __typename?: 'HealthPillarReport';
  /** Name of this health pillar. */
  name: HealthPillarName;
  /** Detailed sections within this pillar (e.g., blood vessel risk, cholesterol levels). */
  sections: Array<HealthPillarSection>;
  /** Overall health status for this pillar based on all subsection assessments. */
  status?: Maybe<HealthStatus>;
};

/** Detailed section within a health pillar containing related health metrics. */
export type HealthPillarSection = {
  __typename?: 'HealthPillarSection';
  /** Individual health metrics within this subsection. */
  metrics: Array<HealthMetric>;
  /** Name of this subsection. */
  name: HealthPillarSectionName;
  /** Health status for this specific subsection. */
  status?: Maybe<HealthStatus>;
  /** Trend comparison with the previous assessment. */
  trendFromPrevious?: Maybe<Trend>;
};

/** Section names within health pillars. */
export enum HealthPillarSectionName {
  /** Adrenal function and stress response markers. */
  AdrenalHealth = 'ADRENAL_HEALTH',
  /** Risk assessment for heart attack and cardiovascular events. */
  HeartAndBloodVesselRisk = 'HEART_AND_BLOOD_VESSEL_RISK',
  /** Heart function and cardiac performance metrics. */
  HeartFunction = 'HEART_FUNCTION',
  /** Lipid levels and liver function markers. */
  LipidsAndLiver = 'LIPIDS_AND_LIVER',
  /** Metabolic risk factors and blood sugar control. */
  MetabolicRisk = 'METABOLIC_RISK',
  /** Sex hormone levels and reproductive health markers. */
  SexHormones = 'SEX_HORMONES',
  /** Systemic inflammation markers and immune response. */
  SystemicInflammation = 'SYSTEMIC_INFLAMMATION',
  /** Vitamin levels and nutritional balance. */
  VitaminBalance = 'VITAMIN_BALANCE'
}

/**
 * Top-level health report containing comprehensive health assessment data
 * based on the latest facial blood scan, body scan and lab results.
 */
export type HealthReport = {
  __typename?: 'HealthReport';
  /** Assessments that were included in this health report */
  assessments?: Maybe<Array<Assessment>>;
  /** Body age analysis based on body scan data. */
  bodyAgeReport?: Maybe<BodyAgeReport>;
  /** Date and time of the most recent health assessment used to generate this report. */
  dateOfLastAssessment: Scalars['LocalDateTime']['output'];
  /** Heart health assessment pillar including cardiovascular risk metrics. */
  heartHealth?: Maybe<HealthPillarReport>;
  /** Hormone balance assessment pillar including hormone levels and endocrine system health. */
  hormoneBalance?: Maybe<HealthPillarReport>;
  /** Inflammation assessment pillar including inflammatory markers and immune system health. */
  inflammation?: Maybe<HealthPillarReport>;
  /** Metabolic health assessment pillar including blood sugar, cholesterol, and metabolism metrics. */
  metabolicHealth?: Maybe<HealthPillarReport>;
};

/** Content for health report upsell. */
export type HealthReportUpsellContent = {
  __typename?: 'HealthReportUpsellContent';
  /** Appendix, if applicable. */
  appendixText?: Maybe<Scalars['String']['output']>;
  /** The user's biological age info. */
  biologicalAgeInfo?: Maybe<HealthMetricUpsellBiologicalAge>;
  /** Disclaimer text, if applicable. */
  disclaimers: Array<Scalars['String']['output']>;
  /** The url of the image to show at the top of the page. */
  headerImageUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Health metrics upsell related content shown in the learn more page.
   * Each group contains a subtitle and the metrics that belong to that group.
   */
  healthMetricUpsellContentGroups: Array<HealthMetricUpsellLearnMoreContentGroup>;
  /** List of health metrics overview content, which will be shown in the main page. */
  healthMetricsOverview: Array<HealthMetricOverviewContent>;
  /**
   * Subtitle for the title page.
   * Eg: "Recommended for ..."
   */
  healthReportUpsellPageSubtitle?: Maybe<Scalars['String']['output']>;
  /**
   * Text to be shown as the title of the upsell page.
   * Eg: "Designed to improve your health metrics and biological age"
   */
  healthReportUpsellPageTitle?: Maybe<Scalars['String']['output']>;
  /**
   * The string representing the title of the page that will be shown from the learn more section.
   * Eg: "How Noom's Program can support your overall health"
   */
  learnMorePageTitle: Scalars['String']['output'];
  /** The primary button. */
  primaryButton?: Maybe<Button>;
  /** The name of the upsell product. */
  productName: Scalars['String']['output'];
  /** The secondary button. */
  secondaryButton?: Maybe<Button>;
  /** The starts at price pill. */
  startsAtPriceText: Scalars['String']['output'];
  /**
   * Based on the upsell ad location type we might have to show a different
   * entry page for the upsell ad. This field will represent that.
   */
  upsellAdUrl?: Maybe<Scalars['String']['output']>;
  /** The value proposition bullets. */
  valueProps: Array<ValueProps>;
};

/** Individual health scan item representing a specific type of health assessment. */
export type HealthScanItem = {
  __typename?: 'HealthScanItem';
  /**
   * Date and time of the most recent scan of this type.
   * Null if the user has never completed this type of scan.
   */
  lastScanAt?: Maybe<Scalars['LocalDateTime']['output']>;
  /**
   * Unique identifier of the most recent scan of this type.
   * Null if the user has never completed this type of scan.
   */
  lastScanId?: Maybe<Scalars['String']['output']>;
  /** Total number of scans of this type that the user has completed. */
  numberOfScans: Scalars['Int']['output'];
  /** Type of health scan or assessment this item represents. */
  scanType: HealthMetricSource;
};

/** Overall health status classification levels. */
export enum HealthStatus {
  /** Health metric is acceptable but could be improved. */
  Fair = 'FAIR',
  /** Health metric is in a good range. */
  Good = 'GOOD',
  /** Health metric requires attention or intervention. */
  NeedsAttention = 'NEEDS_ATTENTION',
  /** Health metric is in the optimal range. */
  Optimal = 'OPTIMAL'
}

/** Content for a large home screen ad placement. */
export type HomeLargeContent = {
  __typename?: 'HomeLargeContent';
  /** A bullet list of benefits with markdown encoding. */
  benefitKeysMarkdown: Array<Scalars['String']['output']>;
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** Text for the disclaimer. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
  /** The title of the testimonial section. */
  testimonialTitle?: Maybe<Scalars['String']['output']>;
  /** The title of the content block. */
  title?: Maybe<Scalars['String']['output']>;
  /** A list of testimonials. */
  upsellAdTestimonial?: Maybe<Array<UpsellAdTestimonial>>;
};

/**
 *  Available page types for the home screen carousel.
 *  Pages handles their own state.
 */
export enum HomeScreenCarouselPage {
  CalorieBudget = 'CALORIE_BUDGET',
  FoodColorBreakdown = 'FOOD_COLOR_BREAKDOWN',
  MacroBudgets = 'MACRO_BUDGETS',
  ProteinBudget = 'PROTEIN_BUDGET',
  ProteinFocusedMacroBudgets = 'PROTEIN_FOCUSED_MACRO_BUDGETS'
}

export type HomeScreenCarouselState = {
  __typename?: 'HomeScreenCarouselState';
  pages: Array<HomeScreenCarouselPage>;
};

/** Content for a single tile in the home screen carousel ad placement. */
export type HomeScreenCarouselTileContent = {
  __typename?: 'HomeScreenCarouselTileContent';
  /** Call to action button for the carousel tile. */
  button?: Maybe<Button>;
  /** Header for this carousel tile. */
  header?: Maybe<Scalars['String']['output']>;
  /** URL of the image to display in this carousel tile. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Text to display on the carousel tile. */
  text?: Maybe<Scalars['String']['output']>;
  /**
   * Title for the entire carousel section.
   * This value is expected to be the same across all tiles and is typically taken from the first tile.
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The upsell ad type for this carousel tile. Note that each tile can be a different
   * type and the type of the ad UpsellAdData may not be representative of all of the ads.
   */
  upsellAdType?: Maybe<UpsellAdType>;
};

/** Home screen navigation configuration - drives the navigation view shown in toolbar */
export type HomeScreenNavigation = {
  __typename?: 'HomeScreenNavigation';
  /** Type of home screen navigation */
  type: HomeScreenNavigationType;
};

/** Available types of home screen navigation */
export enum HomeScreenNavigationType {
  /** Daily navigation */
  DailyNavigation = 'DAILY_NAVIGATION',
  /** No navigation */
  NoNavigation = 'NO_NAVIGATION',
  /** Weekly navigation - for users with Noomcoin */
  WeeklyNavigation = 'WEEKLY_NAVIGATION'
}

/** DEPRECATED: Display the full list of available methods from RewardsLevels.methods. This type is not currently supported by clients */
export type HowToEarnCurrencyFullList = {
  __typename?: 'HowToEarnCurrencyFullList';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

/** Display the generic message with a link to a FAQ page */
export type HowToEarnCurrencyGeneric = {
  __typename?: 'HowToEarnCurrencyGeneric';
  /** WebView URL for rewards learn more webpage */
  learnMoreWebViewUrl: Scalars['String']['output'];
};

/** Display noomcoin information only */
export type HowToEarnCurrencyNoomcoin = {
  __typename?: 'HowToEarnCurrencyNoomcoin';
  /** Currency units (seeds) awarded when requirements are met. */
  currencyAmountAwarded: Scalars['Int']['output'];
  /** WebView URL for rewards learn more webpage */
  learnMoreWebViewUrl: Scalars['String']['output'];
};

/** Union type representing the type of How to earn currency screen to display */
export type HowToEarnCurrencyType = HowToEarnCurrencyFullList | HowToEarnCurrencyGeneric | HowToEarnCurrencyNoomcoin;

/** Payload returned after attempting to initialize the core experience for the user. */
export type InitializeCoreExperiencePayload = {
  __typename?: 'InitializeCoreExperiencePayload';
  /**
   * Returns true if the initialization was successful; otherwise, it is false.
   * Note: Currently, it cannot be false, as the service method implementation
   * is expected to either return true or throw an exception.
   */
  success: Scalars['Boolean']['output'];
};

/** CTA for insight (example is quick reply with a deep link, etc.). */
export type InsightCallToAction = {
  __typename?: 'InsightCallToAction';
  /** Indicates do we need to show locker on the CTA. */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Link to take action of CTA. */
  link: Scalars['String']['output'];
  /** Text to show for the CTA. */
  text: Scalars['String']['output'];
};

/** Feedback from the user on the value of the insight */
export type InsightFeedback = {
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
};

/** Options for how the user can rate an insight */
export enum InsightFeedbackRating {
  ThumbsDown = 'THUMBS_DOWN',
  ThumbsUp = 'THUMBS_UP'
}

export type InterstitialState = {
  __typename?: 'InterstitialState';
  lastShownDate?: Maybe<Scalars['LocalDate']['output']>;
  shownCount: Scalars['Int']['output'];
};

export type Interstitials = {
  __typename?: 'Interstitials';
  communityHint: InterstitialState;
  communityIntroAnnouncement: InterstitialState;
  successKitIntro: InterstitialState;
};

/** Enumerates the available code types for user invitation codes. */
export enum InvitationCodeType {
  /** Invitation code used for establishing friend connections between users. */
  FriendInvitation = 'FRIEND_INVITATION'
}

/** Response for generating an friend invitation link mutation */
export type InviteFriendLink = {
  __typename?: 'InviteFriendLink';
  /** User's invitation code. Since the code can be copied separately from the link, we return it as a separate field. */
  code: Scalars['String']['output'];
  /** User’s friend invitation link. */
  link: Scalars['String']['output'];
};

/**
 * A label -> value pair of strings, formatted in markdown.
 *
 * Can be used to represent a list of labeled items.
 */
export type LabeledValue = {
  __typename?: 'LabeledValue';
  /** The descriptive label for the field name, optionally with markdown */
  labelMarkdown: Scalars['String']['output'];
  /** The value associated with the label, optionally with markdown */
  valueMarkdown: Scalars['String']['output'];
};

export type LessonsData = {
  __typename?: 'LessonsData';
  measurementCivilDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  secondsRead: Scalars['Int']['output'];
};

export type LessonsDataInput = {
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  secondsRead: Scalars['Int']['input'];
};

/** A wrapper input type for an inclusive date range */
export type LocalDateRangeInput = {
  /** The inclusive end day of the date range */
  endDate: Scalars['LocalDate']['input'];
  /** The inclusive starting day of the date range */
  startDate: Scalars['LocalDate']['input'];
};

export type LocalDateTimeRange = {
  __typename?: 'LocalDateTimeRange';
  end: Scalars['LocalDateTime']['output'];
  start: Scalars['LocalDateTime']['output'];
};

export type LogMealsTrackerPayload = {
  __typename?: 'LogMealsTrackerPayload';
  /** Different configurable pages for a tracker */
  pages: Array<MealLoggingTrackerPage>;
  /** Optional task subtitle override */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Optional task title override */
  title?: Maybe<Scalars['String']['output']>;
  /** What variant of the tracker are we showing. */
  variant: MealLoggingTrackerVariant;
};

/** Logged meal information used to generate an AI insight for the user. */
export type LoggedMealInput = {
  /** Access code of user that meal was logged for. */
  accessCode: Scalars['String']['input'];
  /** The food items that the user logged for the meal. */
  foodItems: Array<FoodItemInput>;
  /** Date of the meal. */
  mealDate: Scalars['LocalDate']['input'];
  /** The slot for the logged meal. */
  mealSlot: MealSlot;
};

/**  Encapsulates the data needed to render the macro monitoring settings screen */
export type MacroMonitoringSettingsState = {
  __typename?: 'MacroMonitoringSettingsState';
  /**  Whether the user has enabled macro monitoring on their account */
  isEnabled: Scalars['Boolean']['output'];
  /**  The macronutrient target percentage values based on the users calorie budget */
  macroTargets: CalorieBudgetMacroTargets;
};

/** Input for marking a content item as completed */
export type MarkContentItemCompletedInput = {
  /** Access code of the user that is completing the content */
  accessCode: Scalars['String']['input'];
  /** The client's date and time when the task was completed */
  completedAt: Scalars['LocalDateTime']['input'];
  /** The id of the task to mark as completed */
  taskId: Scalars['ID']['input'];
};

/** Input for marking standalone content as consumed */
export type MarkStandaloneContentConsumedInput = {
  /** Access code that pseudo-identifies the user (optional, can be obtained from headers) */
  accessCode?: InputMaybe<Scalars['String']['input']>;
  /** Opaque round-trip payload for tracking content consumption state */
  contentConsumedPayload: Scalars['String']['input'];
  /** Represents the client's civil date the content is requested for */
  contentLocalDate: Scalars['LocalDate']['input'];
};

/** Response for marking standalone content as consumed */
export type MarkStandaloneContentConsumedResponse = {
  __typename?: 'MarkStandaloneContentConsumedResponse';
  /** The updated standalone content item */
  content: StandaloneContent;
};

/** A wrapper for the markdown string Content Item description */
export type MarkdownString = {
  __typename?: 'MarkdownString';
  /** Markdown string value */
  value: Scalars['String']['output'];
};

/**
 *  These values should be aligned with:
 *  - blood_glucose_data.proto (BloodGlucoseDataProto)
 */
export enum MealContext {
  AfterAfternoonSnack = 'AFTER_AFTERNOON_SNACK',
  AfterBreakfast = 'AFTER_BREAKFAST',
  AfterDinner = 'AFTER_DINNER',
  AfterEveningSnack = 'AFTER_EVENING_SNACK',
  AfterLunch = 'AFTER_LUNCH',
  AfterMorningSnack = 'AFTER_MORNING_SNACK',
  BeforeAfternoonSnack = 'BEFORE_AFTERNOON_SNACK',
  BeforeBed = 'BEFORE_BED',
  BeforeBreakfast = 'BEFORE_BREAKFAST',
  BeforeDinner = 'BEFORE_DINNER',
  BeforeEveningSnack = 'BEFORE_EVENING_SNACK',
  BeforeLunch = 'BEFORE_LUNCH',
  BeforeMorningSnack = 'BEFORE_MORNING_SNACK',
  Fasting = 'FASTING',
  Unknown = 'UNKNOWN'
}

export type MealData = {
  __typename?: 'MealData';
  mealItems: Array<MealItemOneOf>;
  mealNotes?: Maybe<MealNotes>;
  mealPhotos?: Maybe<MealPhotos>;
  mealSlot?: Maybe<MealSlot>;
  mealTimeSlot?: Maybe<MealTimeSlot>;
  measurementCivilDate: Scalars['LocalDate']['output'];
};

/** Content for displaying a meal feedback screen upsell ad. */
export type MealFeedbackScreenContent = {
  __typename?: 'MealFeedbackScreenContent';
  /** Button configuration for the meal feedback screen upsell ad. */
  button?: Maybe<Button>;
  /** URL of the image to display on the meal feedback screen upsell ad. */
  imageUrl: Scalars['String']['output'];
  /** Text to display on the meal feedback screen upsell ad. */
  text: Scalars['String']['output'];
};

export type MealItemOneOf = {
  __typename?: 'MealItemOneOf';
  compositeMealItem?: Maybe<CompositeMealItem>;
  simpleMealItem?: Maybe<SimpleMealItem>;
};

/** Feature state containing the configuration for meal logging method selector UI */
export type MealLoggingMethodSelectorFeatureState = {
  __typename?: 'MealLoggingMethodSelectorFeatureState';
  /** List of rows containing meal logging option cards */
  rows: Array<MealLoggingSelectorRow>;
};

/**
 * Available meal logging methods
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionType)
 */
export enum MealLoggingOption {
  /** Log meals by scanning product barcodes */
  Barcode = 'BARCODE',
  /** View previously recorded meal history */
  History = 'HISTORY',
  /** Log meals by taking a photo */
  Photo = 'PHOTO',
  /** Log meals by searching a food database */
  Search = 'SEARCH',
  /** Default/unspecified meal logging option type */
  UnknownType = 'UNKNOWN_TYPE',
  /** Log meals using voice recording */
  Voice = 'VOICE'
}

/**
 * Availability states for meal logging options
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionAvailability)
 */
export enum MealLoggingOptionAvailability {
  /** Option is temporarily unavailable */
  Disabled = 'DISABLED',
  /** Option is available and can be used */
  Enabled = 'ENABLED',
  /** Option is locked and requires special access or upgrade */
  Locked = 'LOCKED',
  /** Default/unspecified availability state */
  UnknownAvailability = 'UNKNOWN_AVAILABILITY'
}

/** Individual card representing a meal logging method option */
export type MealLoggingOptionCard = {
  __typename?: 'MealLoggingOptionCard';
  /** Current availability state of this logging option */
  availability: MealLoggingOptionAvailability;
  /** The specific meal logging method this card represents */
  option: MealLoggingOption;
  /** Display size of the card in the UI */
  size: MealLoggingOptionCardSize;
  /** Tags to highlight special features or promotions */
  tags: Array<MealLoggingOptionCardTag>;
};

/**
 * Display sizes for meal logging option cards
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionCardSize)
 */
export enum MealLoggingOptionCardSize {
  /** Large card size for prominent display */
  Large = 'LARGE',
  /** Medium card size for standard display */
  Medium = 'MEDIUM',
  /** Small card size for compact display */
  Small = 'SMALL',
  /** Default/unspecified card size */
  UnknownSize = 'UNKNOWN_SIZE'
}

/**
 * Optional tags for meal logging option cards
 * These values should be aligned with:
 * - noom-contracts/food/shared.proto (MealLoggingOptionCardTagProto)
 */
export enum MealLoggingOptionCardTag {
  /** Indicates a feature the user should try */
  TryMe = 'TRY_ME',
  /** Default/unspecified card tag */
  UnknownTag = 'UNKNOWN_TAG'
}

export type MealLoggingProgressBarPage = {
  __typename?: 'MealLoggingProgressBarPage';
  bars: Array<MealLoggingTrackerBar>;
};

/** A row in the meal logging method selector containing option cards */
export type MealLoggingSelectorRow = {
  __typename?: 'MealLoggingSelectorRow';
  /** List of meal logging option cards in this row */
  cards: Array<MealLoggingOptionCard>;
};

export type MealLoggingTrackerBar = FoodCalorieBar;

export type MealLoggingTrackerPage = MealLoggingProgressBarPage;

export enum MealLoggingTrackerVariant {
  /** Regular configurable food tracking, showing progress bars for food calories or mass. */
  Default = 'DEFAULT',
  /** The state shown for freemium users before they set their green goal. */
  GreenGoalOnboarding = 'GREEN_GOAL_ONBOARDING',
  Unknown = 'UNKNOWN'
}

export type MealNotes = {
  __typename?: 'MealNotes';
  eatingReason?: Maybe<EatingReason>;
  mealOrigin?: Maybe<MealOrigin>;
};

export enum MealOrigin {
  DontKnow = 'DONT_KNOW',
  FastFood = 'FAST_FOOD',
  Homemade = 'HOMEMADE',
  Prepackaged = 'PREPACKAGED',
  Raw = 'RAW',
  Restaurant = 'RESTAURANT'
}

export type MealPhoto = {
  __typename?: 'MealPhoto';
  url: Scalars['String']['output'];
};

export type MealPhotos = {
  __typename?: 'MealPhotos';
  photos?: Maybe<Array<MealPhoto>>;
};

/**
 *  These values should be aligned with:
 *  - meal_slots.proto (MealSlotsProto.MealSlot)
 */
export enum MealSlot {
  AfternoonSnack = 'AFTERNOON_SNACK',
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  EveningSnack = 'EVENING_SNACK',
  Lunch = 'LUNCH',
  MorningSnack = 'MORNING_SNACK',
  Unknown = 'UNKNOWN'
}

export type MealTimeSlot = {
  __typename?: 'MealTimeSlot';
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
};

/**
 *  These values should be aligned with:
 *  - measurement_data.proto (DatapointAggregationProto.Grouping)
 */
export enum MeasurementAggregationGrouping {
  Day = 'DAY',
  GroupingUnknown = 'GROUPING_UNKNOWN',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type MeasurementData = BloodGlucoseData | LessonsData | MealData | MedicationData | MoodData | StepsData | WaterData | WeightData;

export type MeasurementDataInput = {
  bloodGlucoseData?: InputMaybe<BloodGlucoseDataInput>;
  lessonsData?: InputMaybe<LessonsDataInput>;
  medicationData?: InputMaybe<MedicationDataInput>;
  /**  TODO: mealData: MealDataInput - too complex for to implement now */
  moodData?: InputMaybe<MoodDataInput>;
  stepsData?: InputMaybe<StepsDataInput>;
  waterData?: InputMaybe<WaterDataInput>;
  weightData?: InputMaybe<WeightDataInput>;
};

export type MeasurementDataList = {
  __typename?: 'MeasurementDataList';
  measurements: Array<MeasurementDataOneOf>;
};

export type MeasurementDataOneOf = {
  __typename?: 'MeasurementDataOneOf';
  bloodGlucoseData?: Maybe<BloodGlucoseData>;
  lessonsData?: Maybe<LessonsData>;
  mealData?: Maybe<MealData>;
  medicationData?: Maybe<MedicationData>;
  moodData?: Maybe<MoodData>;
  stepsData?: Maybe<StepsData>;
  waterData?: Maybe<WaterData>;
  weightData?: Maybe<WeightData>;
};

export enum MeasurementSnapshotStyle {
  Default = 'DEFAULT',
  Prominent = 'PROMINENT'
}

/**
 *  These values should be aligned with:
 *  - measurement_type.proto (MeasurementTypeProto.Id)
 */
export enum MeasurementType {
  BloodGlucose = 'BLOOD_GLUCOSE',
  Lessons = 'LESSONS',
  Meal = 'MEAL',
  Medication = 'MEDICATION',
  Mood = 'MOOD',
  Steps = 'STEPS',
  Unknown = 'UNKNOWN',
  Water = 'WATER',
  Weight = 'WEIGHT'
}

export type MeasurementsData = {
  __typename?: 'MeasurementsData';
  measurements: Array<MeasurementData>;
};

export type MeasurementsDataInput = {
  measurements: Array<MeasurementDataInput>;
};

/**  Medication that is available to the user for logging. */
export type Medication = {
  __typename?: 'Medication';
  /** Medication concentration info, used for deriving syringe units */
  concentrationInfo?: Maybe<MedicationConcentration>;
  /** Medication dose options */
  doseOptions: Array<MedicationDoseOption>;
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
  /** The list of potential side-effects for this medication */
  potentialSideEffects: Array<MedicationSideEffect>;
};

/**  Concentration of an available medication. */
export type MedicationConcentration = {
  __typename?: 'MedicationConcentration';
  /** The units of the medication's concentration ratio numerator */
  activeIngredientUnit: DoseUnits;
  /** The ratio of medication dose to concentration volume */
  concentrationRatio: Scalars['Float']['output'];
  /** The units of the medication's concentration ratio denominator */
  concentrationUnits: DoseUnits;
};

export type MedicationData = {
  __typename?: 'MedicationData';
  dose: Scalars['Float']['output'];
  measurementCivilDateTime: Scalars['LocalDateTime']['output'];
  medicationExternalId: Scalars['String']['output'];
  sideEffects: Array<Scalars['ID']['output']>;
  unit: DoseUnits;
};

export type MedicationDataInput = {
  dose: Scalars['Float']['input'];
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  medicationExternalId: Scalars['String']['input'];
  sideEffects: Array<Scalars['ID']['input']>;
  smartDose?: InputMaybe<Scalars['Float']['input']>;
  unit: DoseUnits;
};

/**  Dose option - each unit could have multiple strengths. */
export type MedicationDoseOption = {
  __typename?: 'MedicationDoseOption';
  /** Available dose strengths */
  doses: Array<Scalars['Float']['output']>;
  /** Dose option unit */
  unit: DoseUnits;
};

export type MedicationGoalMetadata = {
  __typename?: 'MedicationGoalMetadata';
  externalMedicationId?: Maybe<Scalars['String']['output']>;
  /** Days of the week when the medication identified by externalMedicationId should be taken */
  scheduledDaysOfWeek?: Maybe<Array<DayOfWeek>>;
};

/**  Information about a medication identified by external Id. */
export type MedicationInfo = {
  __typename?: 'MedicationInfo';
  /** Whether the medication represents a GLP-1 agonist classification */
  isGlp1?: Maybe<Scalars['Boolean']['output']>;
  /** Color HEX code (#RRGGBB) for the medication background in the UI */
  medicationBackgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** External id of the medication */
  medicationExternalId: Scalars['String']['output'];
  /** URL of the image representing the medication */
  medicationImageUrl: Scalars['String']['output'];
  /** URL of the large image representing the medication */
  medicationLargeImageUrl?: Maybe<Scalars['String']['output']>;
  /** Human readable medication name */
  medicationName: Scalars['String']['output'];
};

/**  List of medications available to the user for logging. */
export type MedicationList = {
  __typename?: 'MedicationList';
  /** List of available medications */
  medications: Array<Medication>;
};

export type MedicationPayload = {
  __typename?: 'MedicationPayload';
  medicationName: Scalars['String']['output'];
};

/**  A model wrapping a potential side-effect with ID and display name. */
export type MedicationSideEffect = {
  __typename?: 'MedicationSideEffect';
  /** The string to be used in UI-related features when showing this side-effect */
  displayName: Scalars['String']['output'];
  /** The id of the side-effect */
  id: Scalars['ID']['output'];
};

export type MedicationSideEffectInput = {
  /** The user's indication of whether their side effects were manageable, if any. */
  manageableSideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The list of side effects experienced since the user's last dose.
   * Can be empty if `None`, or the list of [MedicationSideEffect.id] that the
   * user selected at check-in.
   */
  medicationSideEffectIds?: Array<Scalars['ID']['input']>;
};

/** Payload added to Medication Tracker Assignments */
export type MedicationTrackerPayload = {
  __typename?: 'MedicationTrackerPayload';
  /** Status that drives UI state of the task card */
  doseStatus: MedicationTrackerStatus;
  /** The date on or after which we can reuse the last logged weight */
  earliestAcceptedWeightDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Whether the user has ever logged this type of medication before */
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this task should be displayed prominently -- such as with a
   * Hero-style card layout, or by moving into a more prominent position.
   * Recommended client-side default: isProminent = isOnboarded == false
   */
  isProminent?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use title and subTitle */
  lastScheduledDoseDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** @deprecated Use title and subTitle */
  lastTakenDoseDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** @deprecated Use title and subTitle */
  lastTakenDoseStrength?: Maybe<Scalars['Float']['output']>;
  /**
   *  DoseUnits comes from measurements/medication.graphqls
   * @deprecated Use title and subTitle
   */
  lastTakenDoseUnit?: Maybe<DoseUnits>;
  /** Whether to present the SmartDose flow on this medication */
  smartDoseFlowEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Subtitle of the task card */
  subTitle: Scalars['String']['output'];
  /** Title of the task card */
  title: Scalars['String']['output'];
};

export enum MedicationTrackerStatus {
  LastDoseMissed = 'LAST_DOSE_MISSED',
  LastDoseTaken = 'LAST_DOSE_TAKEN',
  /** @deprecated Abandoned */
  NextDoseUpcoming = 'NEXT_DOSE_UPCOMING'
}

/** Payload for a Member Trust & Safety escalation ticket. */
export type MemberTrustAndSafetyEscalationInput = {
  /** Optional attachments such as screenshots */
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Case category to help Trust & Safety triage appropriately */
  caseCategory: Scalars['String']['input'];
  /** Coach access code that uniquely identifies the coach */
  coachAccessCode: Scalars['String']['input'];
  /** Name of the coach raising the escalation */
  coachName: Scalars['String']['input'];
  /** Dashboard type that the coach is working in */
  dashboardType: Scalars['String']['input'];
  /** Detailed description supplied by the coach */
  description: Scalars['String']['input'];
  /** Indicates if this is a life threatening situation */
  lifeThreateningStatus: Scalars['String']['input'];
  /** Manager email to keep in the loop */
  managerEmail: Scalars['String']['input'];
  /** Member message that prompted the escalation */
  memberMessage: Scalars['String']['input'];
  /** Optional link to a Manatee or Circles transcript */
  transcriptLink: Scalars['String']['input'];
  /** User access code for the affected member */
  userAccessCode: Scalars['String']['input'];
};

/** Experiment information */
export type MeristemExperimentInfo = {
  /** The context for this experiment */
  context?: InputMaybe<Scalars['String']['input']>;
  /** The experiment name */
  experimentName?: InputMaybe<Scalars['String']['input']>;
  /** The SHA the user is accessing for this context */
  sha?: InputMaybe<Scalars['String']['input']>;
  /** The name of the arm the user is in */
  variationName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a micro challenge definition/template.
 * This is the base challenge configuration that users can start instances of.
 */
export type MicroChallenge = {
  __typename?: 'MicroChallenge';
  /** The actions available for the user to take for this challenge. */
  availableActions?: Maybe<MicroChallengeActions>;
  /** IDs of the categories for this challenge; used for filtering */
  categories: Array<Scalars['String']['output']>;
  /** Description of what the challenge entails */
  description: Scalars['String']['output'];
  /**
   * Duration of the challenge in days
   * Derived from completion_condition.duration_days
   */
  durationDays: Scalars['Int']['output'];
  /** URL to the challenge image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Long description providing detailed information about the challenge. */
  longDescription?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the micro challenge definition */
  microChallengeId: Scalars['String']['output'];
  /** Display name of the micro challenge */
  name: Scalars['String']['output'];
  /**
   * Target progress needed for completion (e.g., number of required success days)
   * Derived from completion_condition.daily_threshold.required_success_days
   */
  targetProgress: Scalars['Int']['output'];
};

/** Reasons why an action cannot be performed. */
export enum MicroChallengeActionDisabledReason {
  /** Indicates that the user has reached or exceeded the limit of active challenges */
  MaxChallengesReached = 'MAX_CHALLENGES_REACHED'
}

/** Provides details about the action for a micro challenge. */
export type MicroChallengeActionInfo = {
  __typename?: 'MicroChallengeActionInfo';
  /** The reason why the action is disabled, if applicable */
  disabledReason?: Maybe<MicroChallengeActionDisabledReason>;
  /** Whether the action is currently enabled */
  isEnabled: Scalars['Boolean']['output'];
};

/** Represents the actions a user can take for a micro challenge. */
export type MicroChallengeActions = {
  __typename?: 'MicroChallengeActions';
  /** Show 'End' button to stop the challenge */
  cancel?: Maybe<MicroChallengeActionInfo>;
  /** Show 'Did it' button to track progress */
  record?: Maybe<MicroChallengeActionInfo>;
  /** Show 'Retry' button for recently ended challenge */
  retry?: Maybe<MicroChallengeActionInfo>;
  /** Show 'Start' button */
  start?: Maybe<MicroChallengeActionInfo>;
};

/** Category of a micro challenge. Used to filter challenges in library */
export type MicroChallengeCategory = {
  __typename?: 'MicroChallengeCategory';
  /** Unique identifier for the category */
  id: Scalars['String']['output'];
  /** URL for the category icon */
  imageUrl: Scalars['String']['output'];
  /** Display name of the category */
  name: Scalars['String']['output'];
};

/** Container for the user's micro challenges library entries */
export type MicroChallengeLibrary = {
  __typename?: 'MicroChallengeLibrary';
  /** List of categories to display */
  categories?: Maybe<Array<Maybe<MicroChallengeCategory>>>;
  /** List of micro challenge definitions available in the library (may include locked items) */
  challenges: Array<MicroChallenge>;
  /** List of users challenges */
  myChallenges?: Maybe<Array<Maybe<UserMicroChallenge>>>;
  /**
   * Usage information for the user's challenges (capacity tracking)
   * @deprecated Use `challenges.map { it.availableActions }`.
   */
  usage: Usage;
};

/** Status of a user's micro challenge enrollment */
export enum MicroChallengeStatus {
  /** Challenge is active and user can make progress */
  Active = 'ACTIVE',
  /** Challenge was cancelled by the user */
  Cancelled = 'CANCELLED',
  /** Challenge was successfully completed */
  Completed = 'COMPLETED',
  /** Challenge failed (expired or insufficient progress) */
  Failed = 'FAILED'
}

/** Placeholder for Micro Challenges tracker payload details. */
export type MicroChallengesTrackerPayload = {
  __typename?: 'MicroChallengesTrackerPayload';
  /** Placeholder field to satisfy GraphQL type requirements. Will be replaced with actual fields. */
  placeholder?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represents the state of a user's micro challenges for the tracker card.
 * This determines what UI the client should show (HIDDEN, INTRO, INACTIVE, or ACTIVE).
 */
export type MicroChallengesTrackerState = {
  __typename?: 'MicroChallengesTrackerState';
  /** The card variant that clients may use to modify the UI */
  cardVariant?: Maybe<CardVariant>;
  /**
   * List of the user's micro challenge instances.
   * Empty if state is INTRO or INACTIVE.
   */
  challenges: Array<UserMicroChallenge>;
  /**
   * Whether the user has seen the intro splash screen
   * Null if state is NOT INTRO.
   */
  hasSeenIntroSplashScreen?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The current status of the micro challenges tracker card.
   * HIDDEN - Don't show the card
   * INTRO - Show introduction/onboarding
   * INACTIVE - Show empty state with library entry point
   * ACTIVE - Show active challenges
   */
  state: MicroChallengesTrackerStatus;
  /**
   * Usage information for the user's challenges (capacity tracking)
   * @deprecated Use `challenges.map { it.availableActions }`.
   */
  usage: Usage;
};

/** Status of the micro challenges tracker card, determining what UI to show. */
export enum MicroChallengesTrackerStatus {
  Active = 'ACTIVE',
  Hidden = 'HIDDEN',
  Inactive = 'INACTIVE',
  Intro = 'INTRO'
}

/**
 * Represents an amount of money with its currency type.
 * Modeled after MoneyProto in money.proto.
 */
export type Money = {
  __typename?: 'Money';
  /** The three-letter currency code defined in ISO 4217. */
  currencyCode: Scalars['String']['output'];
  /**
   * Number of nano (10^-9) units of the amount.
   * Defaults to 0 if null.
   * The value must be between -999,999,999 and +999,999,999 inclusive.
   * If `units` is positive, `nanos` must be positive or zero.
   * If `units` is zero, `nanos` can be positive, zero, or negative.
   * If `units` is negative, `nanos` must be negative or zero.
   * For example:
   *   - $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   *   - $99.99 is represented as `units`=99 and `nanos`=990,000,000.
   *   - $5.00  is represented as `units`=5  and `nanos`=0.
   */
  nanos?: Maybe<Scalars['Int']['output']>;
  /**
   * The whole units of the amount.
   * For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units: Scalars['Int']['output'];
};

export type MoodData = {
  __typename?: 'MoodData';
  measurementCivilDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  moodLevel: Scalars['Int']['output'];
};

export type MoodDataInput = {
  measurementCivilDateTime: Scalars['LocalDateTime']['input'];
  moodLevel: Scalars['Int']['input'];
};

export type MultiDayAssignment = {
  __typename?: 'MultiDayAssignment';
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptExternalCoachingTermsAndConditions: ExternalCoachingTermsAndConditionsInfo;
  acknowledgeCoachUserAnnouncement: CoachAnnouncementUserInteraction;
  /**
   * Apply a workflow action to a curriculum object.
   * - `actionInput`: Input containing the action type, object ID and object type
   * Returns the updated editor actions details after applying the workflow action
   */
  applyWorkflowAction: CurriculumEditorActionsDetails;
  /** Processes measurements by proxying the request to the measurement-api. */
  batchMeasurements: BatchMeasurementsData;
  /**
   * Updates a user's SmartDose table as needed, returns current SmartDose.
   * May be null if the user hasn't logged medications before.
   * In case of errors, clients should check if `errors[].extensions.code`
   * is one of the known [SmartDoseMutationErrorCodes], and handle accordingly.
   */
  calculateSmartDose?: Maybe<SmartDose>;
  /** Cancel an active micro challenge instance for the user */
  cancelMicroChallenge: CancelMicroChallengeResponse;
  /**
   * Creates a new art gallery.
   * - `input`: Data for the new gallery
   */
  createArtGallery?: Maybe<ArtGallery>;
  /**
   * Creates a new art piece.
   * - `input`: Data for the new art piece
   */
  createArtPiece?: Maybe<ArtPiece>;
  createCoachAnnouncement: CoachAnnouncement;
  /** Retrieves the Decagon signature token for a user identified by their access code */
  createDecagonSignatureToken: DecagonSignatureToken;
  /** Creates a Member Trust & Safety escalation ticket */
  createMemberTrustAndSafetyEscalation: CreateCustomerSupportTicketResponse;
  /** Create a relation request, or return the existing relation. */
  createOrGetRelationByInviteCode: CreateOrGetRelationPayload;
  /** Creates a partner mapping for the user if one doesn't exist and returns the (existing|new) mapping. */
  createPartnerMappingIfNotExists: PartnerMapping;
  /**
   * Create a program foundation.
   * - `programConfigId`: Required id of the program this foundation is being added to
   * - `foundation`: the input required to create the foundation
   * Returns the newly created foundation
   */
  createProgramFoundation: ProgramFoundation;
  /**
   * Creates a new scheduled content.
   * - `input`: Data for the new scheduled content
   */
  createScheduledContent?: Maybe<ScheduledContent>;
  /** Creates a customer support request ticket */
  createSupportRequest: CreateCustomerSupportTicketResponse;
  /** Deletes the specified body scan for a user */
  deleteBodyScan: BodyScanDeletionResponse;
  deleteCoachAnnouncement: Scalars['Boolean']['output'];
  /**
   * Delete a program foundation.
   * - `programConfigId`: the UUID of the program this foundation is in
   * - `foundationId`: the UUID of the foundation to delete
   * Returns `true` if the deletion was successful (status code `204`)
   */
  deleteProgramFoundation: Scalars['Boolean']['output'];
  /** Delete a relations request */
  deleteRelation: DeleteRelationPayload;
  /** Cascade delete a scheduled content item */
  deleteScheduledContent: DeleteScheduledContentResponse;
  /** Dismisses customer satisfaction survey of the given type on behalf of the user */
  dismissCsatSurvey?: Maybe<CsatSurvey>;
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  /**
   * Idempotently ensure that a provider-side user identity exists for the given
   * Noom accessCode and provider. If one already exists, return it; otherwise,
   * create it.
   */
  ensureHealthDataProviderUser: HealthDataProviderUser;
  expireCoachAnnouncement: CoachAnnouncement;
  /**
   * Extend the duration of an active micro challenge instance for the user
   * (extension parameters TBD; seeds redemption flow likely to supply menu item instead of duration)
   */
  extendMicroChallenge: ExtendMicroChallengeResponse;
  /** Generates a pair of auth/refresh tokens used to access facial blood scan partner API */
  generateApiToken: FacialBloodScanToken;
  /** Generates a presigned S3 URL for uploading a food image */
  generateFoodImageUploadUrl: FoodImageUploadUrlResponse;
  /** Generate or get invite friend link */
  generateInviteFriendLink: InviteFriendLink;
  /** Initializes a new body scan for the user, and returns the URL which the client should use to upload the body scan data */
  initializeBodyScan: BodyScanUploadMetadata;
  /**
   * Initialize the core experience for the user.
   * Returns InitializeCoreExperiencePayload with success status.
   */
  initializeCoreExperience: InitializeCoreExperiencePayload;
  markCoachAnnouncementsView: CoachAnnouncementUserInteractions;
  /** Mark a content item as completed */
  markContentItemCompleted: Scalars['Boolean']['output'];
  /** Mark standalone content as consumed */
  markStandaloneContentConsumed: MarkStandaloneContentConsumedResponse;
  /**
   * Called whenever the user opens the mealbot channel. This calls a CS endpoint that triggers actions such as
   * sending a welcome message in the chat.
   * Using a boolean as a response, since GQL doesn't support void responses.
   */
  mealbotChatChannelOpened?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Processes a gamification action with the provided data
   * This can update the system state for various gamification elements like rewards or streaks, and return gamification celebrations to be displayed on the client.
   */
  processGamificationAction: GamificationActionResult;
  /**
   * Record progress to an active micro challenge instance for the user identified from the access code.
   * Returns the updated UserMicroChallenge with the recorded progress.
   */
  recordMicroChallengeProgress: RecordMicroChallengeProgressResponse;
  /** Processes the redemption of a list of products. */
  redeemProducts: ProductRedemptionResult;
  /** Store facial blood scan measurements */
  saveFacialBloodScanResults?: Maybe<Scalars['Boolean']['output']>;
  /** Stores the questionnaire data on the backend */
  saveQuestionnaire: Scalars['Boolean']['output'];
  /** Updates user body scan settings with provided mode to be used */
  setBodyScanModeSetting: SetBodyScanModeSettingResponse;
  /**
   * Enables or disables out-of-range blood glucose alerts for a user.
   * Returns the new state (true if enabled, false if disabled).
   */
  setOutOfRangeBloodGlucoseAlerts: Scalars['Boolean']['output'];
  /** Updates user show avatar settings with provided boolean value */
  setShowAvatarSetting: SetShowAvatarSettingResponse;
  /**
   * This method is no longer supported and should be removed, but we can't until we allow for exceptions to schema checks
   * @deprecated Use toolsState to patch the state of a tool
   */
  setToolPinState: ToolId;
  /**
   * Start a new micro challenge for the user. Optional userMicroChallengeId allows clients to supply
   * a deterministic identifier so they can optimistically wait for subscription updates.
   */
  startMicroChallenge: StartMicroChallengeResponse;
  submitConsent?: Maybe<Scalars['Boolean']['output']>;
  /** Submits a completed customer satisfaction survey on behalf of the user */
  submitCsatSurvey?: Maybe<CsatSurvey>;
  /** Records the user's response to the specified policy */
  submitPolicyOption: UserPolicyOption;
  /** Patches the new state for one or more tools, and returns the full state, updated, of all the tools of the user and program */
  toolsState: ToolList;
  /**
   * Notify the backend that the image has been uploaded and it can start processing.
   * GQL doesn’t support void responses, so returning an object in case we want to
   * extend it in the future
   */
  triggerFaceScanProcessing?: Maybe<TriggerFaceScanResponse>;
  /**
   * Updates an existing art gallery with partial data (PATCH operation).
   * Only provided fields will be updated, null or omitted fields will remain unchanged.
   * - `galleryId`: Unique identifier of the gallery to update
   * - `input`: Partial data to update the gallery
   */
  updateArtGallery?: Maybe<ArtGallery>;
  /**
   * Updates an existing art piece with partial data (PATCH operation).
   * Only provided fields will be updated, null or omitted fields will remain unchanged.
   * - `artPieceId`: Unique identifier of the art piece to update
   * - `input`: Partial data to update the art piece
   */
  updateArtPiece?: Maybe<ArtPiece>;
  updateCoachAnnouncement: CoachAnnouncement;
  updateCommunityHintInterstitialState: InterstitialState;
  /** Updates dynamic calorie goal settings for a user. */
  updateDynamicCalorieGoalSettingsState: DynamicCalorieGoalSettingsState;
  /** Updates the glucose forecasting feature state for a user identified by an access code */
  updateGlucoseForecastingFeatureState: GlucoseForecastingFeatureState;
  /** Updates a user's goal in GoalsAPI for a user and program. */
  updateGoal: UserGoal;
  updateInterstitial: InterstitialState;
  updateMacroMonitoringSettingsState: MacroMonitoringSettingsState;
  /**
   * Update the scheduled date for a prescription refill.
   * This proxies the request to the healthcare API to update the fill date
   * for a specific scheduled prescription refill.
   */
  updatePrescriptionRefillDate: PrescriptionRefill;
  /**
   * Update the foundation.
   * - `programConfidId`: Required id of this foundation's parent program
   * - `foundationId`: Required id of the foundation to update
   * - `foundation`: The input required to update the foundation
   * Returns the updated foundation
   */
  updateProgramFoundation: ProgramFoundation;
  /**
   * Update the ordering of Foundations within a Program. The order of the foundation IDs in the provided list
   * determines the order of the Foundations within the Program.
   * - `programConfigId`: the id of the program the foundations belong to
   * - `foundationIds`: an *ordered* list of foundation ids;
   * Returns true if the update succeeded.
   */
  updateProgramFoundationOrder?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Updates an existing scheduled content.
   * - `scheduledContentId`: The unique identifier of the scheduled content to update
   * - `input`: Updated data for the scheduled content
   */
  updateScheduledContent?: Maybe<ScheduledContent>;
  updateSuccessKitIntroInterstitialState: InterstitialState;
  /** Updates user birth date and returns it back on success. */
  updateUserDateOfBirth: Scalars['LocalDate']['output'];
  /**
   * Uploads an image for a specific art piece.
   * - `artPieceId`: Unique identifier of the art piece to upload image for
   * - `input`: Image upload data containing the image URL
   */
  uploadArtPieceImage: UploadArtPieceImageResponse;
  /** Stores a measurement by proxying the request to the measurement-api. */
  upsertMeasurement: MeasurementData;
  /** DEPRECATED: Stores a measurements by proxying the request to the measurement-api. */
  upsertMeasurements: MeasurementsData;
  /**  Create or update settings for a specific reminder */
  upsertReminderSettings: ReminderSettings;
};


export type MutationAcceptExternalCoachingTermsAndConditionsArgs = {
  accessCode: Scalars['String']['input'];
  externalCoachingTermsAndConditionsInput: ExternalCoachingTermsAndConditionsInput;
};


export type MutationAcknowledgeCoachUserAnnouncementArgs = {
  coachUserAnnouncementId: Scalars['String']['input'];
};


export type MutationApplyWorkflowActionArgs = {
  actionInput: CurriculumWorkflowActionInput;
};


export type MutationBatchMeasurementsArgs = {
  accessCode: Scalars['String']['input'];
  attribution?: InputMaybe<AttributionDataInput>;
  clientCivilDateTime: Scalars['LocalDateTime']['input'];
  data: BatchMeasurementsDataInput;
};


export type MutationCalculateSmartDoseArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  calculationInputs?: InputMaybe<CalculateSmartDoseInput>;
  clientDateTime: Scalars['LocalDateTime']['input'];
};


export type MutationCancelMicroChallengeArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  userMicroChallengeId: Scalars['UUID']['input'];
};


export type MutationCreateArtGalleryArgs = {
  input: CreateArtGalleryInput;
};


export type MutationCreateArtPieceArgs = {
  input: CreateArtPieceInput;
};


export type MutationCreateCoachAnnouncementArgs = {
  coachAnnouncementInput: CoachAnnouncementInput;
};


export type MutationCreateDecagonSignatureTokenArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationCreateMemberTrustAndSafetyEscalationArgs = {
  input: MemberTrustAndSafetyEscalationInput;
};


export type MutationCreateOrGetRelationByInviteCodeArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: CreateOrGetRelationByInviteCodeInput;
};


export type MutationCreatePartnerMappingIfNotExistsArgs = {
  accessCode: Scalars['String']['input'];
  partnerSlug: PartnerSlug;
};


export type MutationCreateProgramFoundationArgs = {
  foundation: ProgramFoundationInput;
  programConfigId: Scalars['UUID']['input'];
};


export type MutationCreateScheduledContentArgs = {
  input: CreateScheduledContentInput;
};


export type MutationCreateSupportRequestArgs = {
  input: SupportRequestInput;
};


export type MutationDeleteBodyScanArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  scanUuid: Scalars['UUID']['input'];
};


export type MutationDeleteCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type MutationDeleteProgramFoundationArgs = {
  foundationId: Scalars['UUID']['input'];
  programConfigId: Scalars['UUID']['input'];
};


export type MutationDeleteRelationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: DeleteRelationInput;
};


export type MutationDeleteScheduledContentArgs = {
  scheduledContentId: Scalars['UUID']['input'];
};


export type MutationDismissCsatSurveyArgs = {
  surveyInput: DismissCsatSurveyInput;
};


export type MutationEnsureHealthDataProviderUserArgs = {
  accessCode: Scalars['String']['input'];
  provider: HealthDataProvider;
};


export type MutationExpireCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type MutationExtendMicroChallengeArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  userMicroChallengeId: Scalars['UUID']['input'];
};


export type MutationGenerateApiTokenArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  tokenInput: FacialBloodScanTokenInput;
};


export type MutationGenerateFoodImageUploadUrlArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationGenerateInviteFriendLinkArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationInitializeBodyScanArgs = {
  accessCode: Scalars['String']['input'];
  clientCivilDatetime: Scalars['LocalDateTime']['input'];
  mode?: InputMaybe<BodyScanMode>;
  scanDevice: TargetPlatform;
  sex?: InputMaybe<Sex>;
  weightInKg: Scalars['Float']['input'];
};


export type MutationInitializeCoreExperienceArgs = {
  accessCode: Scalars['String']['input'];
  programUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationMarkCoachAnnouncementsViewArgs = {
  coachUserAnnouncementIds: Array<Scalars['String']['input']>;
};


export type MutationMarkContentItemCompletedArgs = {
  input: MarkContentItemCompletedInput;
};


export type MutationMarkStandaloneContentConsumedArgs = {
  input: MarkStandaloneContentConsumedInput;
};


export type MutationMealbotChatChannelOpenedArgs = {
  channelURL: Scalars['String']['input'];
  userAccessCode: Scalars['String']['input'];
};


export type MutationProcessGamificationActionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  data: GamificationActionDataInput;
};


export type MutationRecordMicroChallengeProgressArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  userMicroChallengeId: Scalars['UUID']['input'];
};


export type MutationRedeemProductsArgs = {
  accessCode: Scalars['String']['input'];
  productOrders: Array<ProductOrder>;
  targetDate: Scalars['LocalDate']['input'];
};


export type MutationSaveFacialBloodScanResultsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  input: SaveFacialBloodScanInput;
};


export type MutationSaveQuestionnaireArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: SaveFacialBloodScanQuestionnaireInput;
};


export type MutationSetBodyScanModeSettingArgs = {
  accessCode: Scalars['String']['input'];
  mode: BodyScanMode;
};


export type MutationSetOutOfRangeBloodGlucoseAlertsArgs = {
  accessCode: Scalars['String']['input'];
  alertsEnabled: Scalars['Boolean']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type MutationSetShowAvatarSettingArgs = {
  accessCode: Scalars['String']['input'];
  showAvatar: Scalars['Boolean']['input'];
};


export type MutationSetToolPinStateArgs = {
  accessCode: Scalars['String']['input'];
  pinStateInput: SetToolPinStateInput;
  programUuid: Scalars['UUID']['input'];
};


export type MutationStartMicroChallengeArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  clientTime: Scalars['LocalTime']['input'];
  microChallengeId: Scalars['String']['input'];
  userMicroChallengeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSubmitConsentArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  agreedToPolicies: Array<Policy>;
};


export type MutationSubmitCsatSurveyArgs = {
  surveyInput: SubmitCsatSurveyInput;
};


export type MutationSubmitPolicyOptionArgs = {
  accessCode: Scalars['String']['input'];
  consentStatus: PolicyOptionStatus;
  policy: Policy;
  signature?: InputMaybe<Scalars['String']['input']>;
};


export type MutationToolsStateArgs = {
  accessCode: Scalars['String']['input'];
  newToolsState: PatchToolsState;
  programUuid: Scalars['UUID']['input'];
};


export type MutationTriggerFaceScanProcessingArgs = {
  scanId: Scalars['UUID']['input'];
};


export type MutationUpdateArtGalleryArgs = {
  galleryId: Scalars['ID']['input'];
  input: UpdateArtGalleryInput;
};


export type MutationUpdateArtPieceArgs = {
  artPieceId: Scalars['ID']['input'];
  input: UpdateArtPieceInput;
};


export type MutationUpdateCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
  coachAnnouncementInput: CoachAnnouncementInput;
};


export type MutationUpdateCommunityHintInterstitialStateArgs = {
  accessCode: Scalars['String']['input'];
  displayDate: Scalars['LocalDate']['input'];
};


export type MutationUpdateDynamicCalorieGoalSettingsStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  activityLevelName?: InputMaybe<ActivityLevelName>;
  externalBmrEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  manualCalorieAdjustment?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateGlucoseForecastingFeatureStateArgs = {
  accessCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateGoalArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  goalPatch: UserGoalPatch;
  programUuid: Scalars['String']['input'];
  userGoalId: Scalars['String']['input'];
};


export type MutationUpdateInterstitialArgs = {
  accessCode: Scalars['String']['input'];
  interstitials: UpdateInterstitialInput;
};


export type MutationUpdateMacroMonitoringSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  macroTargets?: InputMaybe<CalorieBudgetMacroTargetsInput>;
};


export type MutationUpdatePrescriptionRefillDateArgs = {
  accessCode: Scalars['String']['input'];
  fillDate: Scalars['LocalDate']['input'];
  prescriptionRefillId: Scalars['Int']['input'];
};


export type MutationUpdateProgramFoundationArgs = {
  foundation: ProgramFoundationInput;
  foundationId: Scalars['UUID']['input'];
  programConfigId: Scalars['UUID']['input'];
};


export type MutationUpdateProgramFoundationOrderArgs = {
  foundationIds: Array<Scalars['UUID']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type MutationUpdateScheduledContentArgs = {
  input: UpdateScheduledContentInput;
  scheduledContentId: Scalars['UUID']['input'];
};


export type MutationUpdateSuccessKitIntroInterstitialStateArgs = {
  accessCode: Scalars['String']['input'];
  displayDate: Scalars['LocalDate']['input'];
};


export type MutationUpdateUserDateOfBirthArgs = {
  accessCode: Scalars['String']['input'];
  birthDate: Scalars['LocalDate']['input'];
  clientCivilDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationUploadArtPieceImageArgs = {
  artPieceId: Scalars['ID']['input'];
  input: UploadArtPieceImageInput;
};


export type MutationUpsertMeasurementArgs = {
  accessCode: Scalars['String']['input'];
  attribution?: InputMaybe<AttributionDataInput>;
  clientCivilDateTime: Scalars['LocalDateTime']['input'];
  data: MeasurementDataInput;
};


export type MutationUpsertMeasurementsArgs = {
  accessCode: Scalars['String']['input'];
  attribution?: InputMaybe<AttributionDataInput>;
  clientCivilDateTime: Scalars['LocalDateTime']['input'];
  data: MeasurementsDataInput;
};


export type MutationUpsertReminderSettingsArgs = {
  accessCode: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  reminderSubtype: Scalars['String']['input'];
  reminderTime: Scalars['LocalTime']['input'];
  reminderType: ReminderType;
  reminderUuid: Scalars['UUID']['input'];
};

/** Content for a button in the top nav. */
export type NavigationButtonContent = {
  __typename?: 'NavigationButtonContent';
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
};

export type NoomAppAttributionDataInput = {
  sourceIdentifier: Scalars['String']['input'];
};

export type NoomFlowConfiguration = {
  __typename?: 'NoomFlowConfiguration';
  /** When the flow configuration was archived */
  archivedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** A JSON string representing the configuration of the flow */
  configurationJsonAsString: Scalars['String']['output'];
  /** When the flow configuration was created */
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Who created the flow configuration (optional for now) */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The description of the flow */
  description?: Maybe<Scalars['String']['output']>;
  /** When the flow configuration was disabled */
  disabledAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** When the flow configuration was enabled */
  enabledAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /**
   * The group name of flow configurations that may be chosen based on criteria when
   * requested
   */
  flowGroupName?: Maybe<Scalars['String']['output']>;
  /** The identifier for the flow */
  identifier: Scalars['ID']['output'];
  /** The name of the flow */
  name: Scalars['String']['output'];
  /** The status of the flow configuration */
  status: NoomFlowStatus;
  /** When the flow configuration was last updated */
  updatedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type NoomFlowCriteriaInput = {
  /** The identifier for the flow you'd like to retrieve */
  identifier: Scalars['ID']['input'];
};

export enum NoomFlowStatus {
  /** The flow configuration is in approved by QA state */
  ApprovedByQa = 'APPROVED_BY_QA',
  /** The flow configuration is in approved by reviewer state */
  ApprovedByReviewer = 'APPROVED_BY_REVIEWER',
  /** The flow configuration is in archived state */
  Archived = 'ARCHIVED',
  /** The flow configuration is in deployed to dev state */
  DeployedToDev = 'DEPLOYED_TO_DEV',
  /** The flow configuration is in deployed to prod state */
  DeployedToProd = 'DEPLOYED_TO_PROD',
  /** The flow configuration is in deployed to stage state */
  DeployedToStage = 'DEPLOYED_TO_STAGE',
  /** The flow configuration is in disabled state */
  Disabled = 'DISABLED',
  /** The flow configuration failed QA */
  FailedQa = 'FAILED_QA',
  /** The flow configuration failed review */
  FailedReview = 'FAILED_REVIEW',
  /** The flow configuration is in progress state */
  InProgress = 'IN_PROGRESS',
  /** The flow configuration is in ready for QA state */
  ReadyForQa = 'READY_FOR_QA',
  /** The flow configuration is in ready to review state */
  ReadyForReview = 'READY_FOR_REVIEW'
}

/** A user's preview Noom profile */
export type NoomUserPreviewProfile = {
  __typename?: 'NoomUserPreviewProfile';
  /** User's access code */
  accessCode: Scalars['String']['output'];
  /** User's display name */
  name: Scalars['String']['output'];
  /** URL to user's profile picture */
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
};

/**
 *  These values should be aligned with:
 *  - macros.proto (NutritionBreakdownProto)
 */
export type NutritionBreakdown = {
  __typename?: 'NutritionBreakdown';
  carbohydrateMg?: Maybe<Scalars['Float']['output']>;
  dietaryFiberMg?: Maybe<Scalars['Float']['output']>;
  potassiumMg?: Maybe<Scalars['Float']['output']>;
  proteinMg?: Maybe<Scalars['Float']['output']>;
  sodiumMg?: Maybe<Scalars['Float']['output']>;
  totalFatMg?: Maybe<Scalars['Float']['output']>;
};

export type Pageable = {
  /** Metadata for fetching the next page of results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**  Encapsulates a partner + partner user id mapping for a user. */
export type PartnerMapping = {
  __typename?: 'PartnerMapping';
  partnerSlug: PartnerSlug;
  partnerUserId: Scalars['String']['output'];
};

/**
 *  Supported partners that we store external user ids for.
 *  Keep in sync with user_partner_mapping.proto
 */
export enum PartnerSlug {
  MdIntegrations = 'MD_INTEGRATIONS',
  Sendbird = 'SENDBIRD',
  Singular = 'SINGULAR',
  SteadyMd = 'STEADY_MD',
  Zumba = 'ZUMBA'
}

/** Partner user account details provided for providers stored in PartnerUserAccount. */
export type PartnerUserAccountDetails = {
  __typename?: 'PartnerUserAccountDetails';
  /** Unique identifier used to connect users to the partner mobile solution. */
  mobileToken?: Maybe<Scalars['String']['output']>;
  /** Noom's Organization ID in the partner system associated with the user. */
  orgId?: Maybe<Scalars['String']['output']>;
};

export type PastMedicationDose = {
  __typename?: 'PastMedicationDose';
  /** Dose strength */
  dose: Scalars['Float']['output'];
  /**
   * Whether the logged dose matches the calculated SmartDose at
   * the time that the medication was logged
   */
  isSmartDose?: Maybe<Scalars['Boolean']['output']>;
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
  /** Side-effects */
  sideEffects: Array<MedicationSideEffect>;
  /** When the medication was taken */
  takenOn: Scalars['LocalDateTime']['output'];
  /** Dose units */
  unit: DoseUnits;
};

/**  Past medication doses that user has taken */
export type PastMedicationDoseList = {
  __typename?: 'PastMedicationDoseList';
  /** Metadata for fetching the next page of past medication doses, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** List of past medication doses */
  pastDoses: Array<PastMedicationDose>;
};

export type PatchToolsState = {
  toolsStatesPatch: Array<ToolStatePatch>;
};

export type PatientDiagnosticReportList = {
  __typename?: 'PatientDiagnosticReportList';
  /** List of user's diagnostic reports, in reverse order of time collected */
  patientDiagnosticReports: Array<PatientDiagnosticReportMetadata>;
};

/** Encapsulates the data for a single diagnostic report */
export type PatientDiagnosticReportMetadata = {
  __typename?: 'PatientDiagnosticReportMetadata';
  /** AI summary of the diagnostic report result, only for the latest result */
  aiSummary?: Maybe<Scalars['String']['output']>;
  /** URL of the diagnostic report */
  diagnosticReportUrl: Scalars['String']['output'];
  /** Unique identifier of the diagnostic report */
  id: Scalars['String']['output'];
  /** Time at which the diagnostic was performed on the user */
  timeCollected: Scalars['LocalDateTime']['output'];
};

/** A resource in the plateau resources screen. */
export type PlateauResource = {
  __typename?: 'PlateauResource';
  /** Button associated with this resource. */
  button: Button;
  /** URL of the image for this resource. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Title of this plateau resource. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 *  Naming convention is the state/province (if applicable) underscore the
 *  recognized acronym for the act. Since the acronym can often be confusing,
 *  prefixing with the state makes it clearer where the policy is applicable.
 */
export enum Policy {
  /**  Ash at-home test consent */
  AshAtHomeTest = 'ASH_AT_HOME_TEST',
  CaCcpa = 'CA_CCPA',
  CoCpa = 'CO_CPA',
  /**
   *  Value representing the CTDPA before it was amended by S.B. 3 (below). The
   *  old value will still be returned by reads, but shouldn't be used in new
   *  policy option writes.
   */
  CtCtdpa = 'CT_CTDPA',
  /**
   *  Connecticut S.B. 3 amended the CTDPA, increasing its breadth and causing
   *  it to apply to an account rather than just an email address.
   */
  CtSb3 = 'CT_SB3',
  /**
   *  This handles users who have opted out, but for whatever reason we are not
   *  sure from where. Largely this will contain users from before we started
   *  keeping track.
   */
  General = 'GENERAL',
  /**  GINA / ADA authorization */
  GinaAda = 'GINA_ADA',
  NoomB2BPp = 'NOOM_B2B_PP',
  NoomB2CPp = 'NOOM_B2C_PP',
  NoomHipaaNotice = 'NOOM_HIPAA_NOTICE',
  NoomLiabilityWaiver = 'NOOM_LIABILITY_WAIVER',
  /**  Noom internal policies */
  NoomTos = 'NOOM_TOS',
  NvSb370 = 'NV_SB370',
  /**  SMS engagement message consent */
  SmsConsent = 'SMS_CONSENT',
  /**
   *  Patient Restriction on Medicare Claim Submition Terms. Allow us to keep
   *  track when patient is presented this terms to indicate he can't bill
   *  medicare (US Only)
   */
  UsPrmcst = 'US_PRMCST',
  UtUcpa = 'UT_UCPA',
  VaVcdpa = 'VA_VCDPA',
  WaMhmd = 'WA_MHMD'
}

/**  Please keep in-sync with StatusEnumProto */
export enum PolicyOptionStatus {
  Agree = 'AGREE',
  DidNotAgree = 'DID_NOT_AGREE',
  NotNeeded = 'NOT_NEEDED',
  OptInMayShare = 'OPT_IN_MAY_SHARE',
  OptOutDoNotShare = 'OPT_OUT_DO_NOT_SHARE'
}

/**
 *  These values should be aligned with:
 *  - food.proto (PortionProto)
 */
export type Portion = {
  __typename?: 'Portion';
  quantity: Scalars['Float']['output'];
  totalCalories?: Maybe<Scalars['Float']['output']>;
  unitName: Scalars['String']['output'];
  unitType: PortionUnitType;
};

export enum PortionUnitType {
  Easy = 'EASY',
  Precise = 'PRECISE',
  Unknown = 'UNKNOWN'
}

export enum PreferredWeightUnit {
  Kg = 'KG',
  Lb = 'LB',
  Stone = 'STONE'
}

/** Represents a prescription refill record */
export type PrescriptionRefill = {
  __typename?: 'PrescriptionRefill';
  /** The patient the refill belongs to */
  accessCode: Scalars['String']['output'];
  /** Unique identifier for the scheduled refill */
  id: Scalars['Int']['output'];
  /** Date on which the refill should be processed */
  refillDate: Scalars['LocalDate']['output'];
};

export type PrismBodyScanAttributionDataInput = {
  /** Prism body scan identifier. */
  bodyScanUuid: Scalars['String']['input'];
};

/** Represents the collection of product listings available to the user */
export type ProductListingCatalog = {
  __typename?: 'ProductListingCatalog';
  /** A list of available charitable donations */
  charitableDonations?: Maybe<Array<CharitableDonationProductListing>>;
  /** In-app action for repairing an engagement streak */
  engagementStreakRepair?: Maybe<EngagementStreakRepairProductListing>;
  /** A list of available gift cards */
  giftCards?: Maybe<Array<GiftCardProductListing>>;
};

export enum ProductListingValidationErrorReason {
  /** Balance is insufficient to redeem the list of products */
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  /** Provided target date is not valid for redemption */
  InvalidTargetDate = 'INVALID_TARGET_DATE',
  /** Requirements for product redemption not met */
  ProductNotEligible = 'PRODUCT_NOT_ELIGIBLE',
  /** Default value, we set this to avoid making assumptions the reason is undefined */
  Unknown = 'UNKNOWN'
}

/** Represents an individual product order */
export type ProductOrder = {
  /** Product identifier for redemption */
  productSlug: Scalars['String']['input'];
  /** Amount of the product for redemption */
  quantity: Scalars['Int']['input'];
};

/** Represents a failed product redemption state */
export type ProductRedemptionFailure = {
  __typename?: 'ProductRedemptionFailure';
  /** Reason why the redemption failed */
  reason: ProductListingValidationErrorReason;
};

/** Represents the union between the possible states when redeeming a product */
export type ProductRedemptionResult = ProductRedemptionFailure | ProductRedemptionSuccessful;

/** Represents a successful product redemption state */
export type ProductRedemptionSuccessful = {
  __typename?: 'ProductRedemptionSuccessful';
  /** List of successful product results */
  productResults?: Maybe<Array<ProductResult>>;
  /** Amount spent for the product redemption transaction */
  totalAmountSpent: RewardsMoney;
};

/** Result of a successful product redemption */
export type ProductResult = StreakRepairResult;

/** Definition of a Foundation within a program */
export type ProgramFoundation = {
  __typename?: 'ProgramFoundation';
  /** An optional description of the foundation */
  description?: Maybe<Scalars['String']['output']>;
  /** Which actions a curriculum editor can take on this object */
  editorActionDetails: CurriculumEditorActionsDetails;
  /** The id of the foundation */
  id: Scalars['UUID']['output'];
  /** Foundation metadata */
  metadata: ProgramFoundationMetadata;
  /** An ordered list of module objects. Only included if explicity requested */
  modules?: Maybe<Array<CurriculumModule>>;
  /** Foundation name */
  name: Scalars['String']['output'];
  /** The ID of the program this foundation belongs to */
  programConfigId: Scalars['UUID']['output'];
  /** The user segment ids that defines who this foundation applies to */
  userSegmentation?: Maybe<ProgramFoundationUserSegmentation>;
};

export type ProgramFoundationInput = {
  /** An optional description to give this foundation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ordered list of module IDs for this foundation */
  moduleIds: Array<Scalars['UUID']['input']>;
  /** The name to give the foundation */
  name: Scalars['String']['input'];
  /** User segmentation ids and operator defining membership to this foundation */
  userSegmentation?: InputMaybe<ProgramFoundationUserSegmentationInput>;
};

export type ProgramFoundationMetadata = {
  __typename?: 'ProgramFoundationMetadata';
  /** User details of the user that created this foundation */
  createdBy: ProgramFoundationUserDetails;
  /** The date and time this foundation was first created */
  createdOn: Scalars['LocalDateTime']['output'];
  /** Whether or not this foundation has unpublished (i.e. draft) changes */
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  /** Whether or not this foundation is in a published state */
  isLive: Scalars['Boolean']['output'];
  /** User details of the user that most recently modified the foundation */
  updatedBy: ProgramFoundationUserDetails;
  /** The date and time this foundation was most recently modified */
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type ProgramFoundationUserDetails = {
  __typename?: 'ProgramFoundationUserDetails';
  /** The first name of the user that created this foundation */
  firstName: Scalars['String']['output'];
  /** The last name of the user that created this foundation */
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The segment IDs and logical operator defining how to evaluate the user against those segments */
export type ProgramFoundationUserSegmentation = {
  __typename?: 'ProgramFoundationUserSegmentation';
  /** The segment ids */
  ids: Array<Scalars['ID']['output']>;
  /** The logical operator defining how the segment ids should be evaluated with eachother */
  operator: ProgramFoundationUserSegmentationOperator;
};

/** Inputs for defining the user segmentation for the foundation */
export type ProgramFoundationUserSegmentationInput = {
  /** The usermodel segment ids */
  ids: Array<Scalars['ID']['input']>;
  /** The operator/condition defining how the segment ids should be evaluated together */
  operator: ProgramFoundationUserSegmentationOperator;
};

/** User segmentation operators defining how segments should be evaluated together */
export enum ProgramFoundationUserSegmentationOperator {
  /** The user must belong to each segment represented in the list */
  And = 'AND',
  /** The user must belong to at least one of the segments in the list */
  Or = 'OR'
}

export type ProgramFoundations = {
  __typename?: 'ProgramFoundations';
  foundations: Array<ProgramFoundation>;
};

/** Represents the Progress screen presentation. */
export type ProgressScreen = {
  __typename?: 'ProgressScreen';
  /** Tabs are provided in display order. */
  tabs: Array<ProgressTab>;
};

/** A tab which may be displayed on the Progress screen */
export type ProgressTab = {
  __typename?: 'ProgressTab';
  /** Selected tab variant (exclusive union of supported tab types) */
  tab: ProgressTabVariant;
};

/** Union of supported tab variants */
export type ProgressTabVariant = CourseMapTab | HealthInsightsTab | TrendsTab;

/** This is a superclass for other possible future configurations */
export type ProviderConfiguration = AnuraConfiguration;

export type Query = {
  __typename?: 'Query';
  /**
   * Gets an AI meal insight for the user with their most recently logged meal as input.
   * @deprecated Use the mealInsight query instead.
   */
  aiMealInsight: AiMealInsight;
  /**
   * Returns the information needed by the client to draw a chart with the specified measurements and annotations.
   * - fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded
   * - Chronological or reverse chronological order is provided by the "from" and "to" dates: if "from" is earlier than "to",
   * then it will be in chronological order; and if "to" is earlier than "from", it will go in reverse chronological order
   * - You can also optionally limit by a maximum number of measurements and/or maximum number of annotations. Whatever
   * is reached earlier will set the limit of the graph, and no further measurements or annotations beyond those
   * will be provided (e.g. if we limit to 10 annotations, and the 10th annotation happens on a certain date, then no
   * annotations or measurements will be provided beyond that date, even if we still had a larger limit of
   * measurements). If not provided, they are each limited to 100. The maximum limit accepted is 500: if a higher
   * limit is provided, it will be ignored and 500 will be used. We still don't provide any mechanism for pagination,
   * so if you need more elements than that, please reach out to the Program Content team!
   */
  annotatedMeasurementTrendChart: AnnotatedMeasurementTrendChart;
  /**
   * Retrieves a specific art gallery by its unique id.
   * - `galleryId`: Unique identifier of the gallery to fetch
   */
  artGallery?: Maybe<ArtGallery>;
  /** Returns the applicable privacy policy for a health assessment */
  assessmentPrivacyPolicy: Policy;
  autocompleteAddress: AutocompleteAddressResponse;
  /** Returns the available target values for a specific user's goal. */
  availableTargets: AvailableTargetsResponse;
  /** Informs the client what all data points (if any) need to be gathered from the user when they enter the body scan feature */
  bodyScanIngress: BodyScanIngressChecks;
  /** Returns the applicable privacy policy for a user using the body scan feature */
  bodyScanPrivacyPolicy: Policy;
  /** Returns body scan settings for a given user */
  bodyScanSettings: BodyScanSettingsResponse;
  /** Returns the state of the user's active body scan at the given instant, or defaults to the current instant if none provided. */
  bodyScanTrackerState: BodyScanTrackerState;
  /** Returns a list of body scans for the user */
  bodyScans: BodyScanList;
  /** Queries a chat channel by id */
  chatChannel?: Maybe<ChatChannel>;
  /** Get the channel url for the clinician chat. */
  clinicianChannelUrl?: Maybe<Scalars['String']['output']>;
  /** Get one announcement */
  coachAnnouncement?: Maybe<CoachAnnouncement>;
  /** Get a list of announcements. The sorting order is the backend default */
  coachAnnouncements?: Maybe<CoachAnnouncementsResult>;
  coachAnnouncementsUserInteractions: CoachAnnouncementUserInteractionsPaged;
  coachAnnouncementsUserInteractionsInfo: CoachAnnouncementsUserInteractionInfo;
  /** Configs used by the coaching area */
  coachingConfig?: Maybe<CoachingConfig>;
  /** Configs that are user dependent */
  coachingConfigForUser?: Maybe<CoachingConfigForUser>;
  /** Checks if the user needs to (re)accept any agreements */
  consentCheck: UserConsentCheck;
  /** Returns content consumption state for a specific content type */
  contentConsumptionState: CurriculumContentConsumptionState;
  /** Returns modules that can be used to build a curriculum. */
  curriculumModules: CurriculumModules;
  /**
   * Returns all curricular programs with an optional list of modules that belong
   * to programs.
   *
   * Clients can control the results to be more or less granular using the provided filters.
   */
  curriculumPrograms: CurriculumPrograms;
  /** Returns the dynamic calorie goal settings for a user. */
  dynamicCalorieGoalSettingsState: DynamicCalorieGoalSettingsState;
  /** Returns whether the user is eligible to be displayed the WeightMedsSnapshot, depending on their med logging data */
  eligibleForWeightMedsSnapshot: Scalars['Boolean']['output'];
  /**
   * Returns whether the user is eligible to be displayed the WeightMedsSnapshot, depending on whether they have
   * the goal enabled for the appropriate Meds
   */
  eligibleForWeightMedsSnapshotBasedOnGoals: Scalars['Boolean']['output'];
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  /** This endpoint return all mandatory documents that are signed during NMC enrolment */
  externalCoachingTermsAndConditions: ExternalCoachingTermsAndConditionsInfo;
  /**
   * Returns the state of the user's face scan task.
   * Access code is optional to enable easier testing. If no access code is given it will be taken from AuthTokenProvider
   */
  faceScanTask: FaceScanTask;
  /** Gets metadata needed for the facial blood scan introduction flow. */
  facialBloodScanIntroMetadata: FacialBloodScanIntroMetadata;
  /** Retrieves the questionnaire for a specified provider if exists */
  facialBloodScanQuestionnaire: FacialBloodScanQuestionnaire;
  /** Gets sections of fixed content for a user */
  fixedContentSections: Array<FixedContentSection>;
  /**
   * Query used to retrieve state data for all features that are part of the food logging experience
   * (e.g., meal logging method selector, glucose forecasting, etc.).
   *
   * It was decided that food logging–related features should be grouped into a single query,
   * so this should be used instead of mealLoggingMethodSelectorFeatureState.
   */
  foodLoggingFeaturesStates: FoodLoggingFeaturesStates;
  /**
   * DEPRECATED - Use bloodGlucoseForecastingFeatureStateV2 instead.
   *
   * Generates a personalized glucose forecast for a user by analyzing their historical
   * blood glucose patterns and predicting the impact of specified food items on their
   * glucose levels. Returns time series data showing projected glucose values and spike
   * classifications for each food item.
   */
  generateGlucoseForecast: GenerateGlucoseForecastResponse;
  /**
   * Second version of generateGlucoseForecast query. It includes a updated response type
   * that treats forecast unavailability as possible outcome instead of an error.
   *
   * Generates a personalized glucose forecast for a user by analyzing their historical
   * blood glucose patterns and predicting the impact of specified food items on their
   * glucose levels. Returns time series data showing projected glucose values and spike
   * classifications for each food item.
   */
  generateGlucoseForecastV2: GenerateGlucoseForecastResponseV2;
  /** Returns the UserGoals for a user and program. */
  goalsForDate: UserGoalList;
  /** Retrieves health insights data, showing available scan types and actionable recommendations for health assessments. */
  healthInsights: HealthInsights;
  /** Retrieves health report data for a user based on the latest facial blood scan, body scan and lab result. */
  healthReport: HealthReport;
  homeScreenCarouselState: HomeScreenCarouselState;
  /** Returns home screen navigation configuration */
  homeScreenNavigation: HomeScreenNavigation;
  /** Request a presigned S3 link to upload the face image for further processing */
  initializeFaceScan: FaceScanInitializationInfo;
  interstitials: Interstitials;
  /** Lists all scheduled contents with cursor-based pagination */
  listScheduledContent: ScheduledContentList;
  macroMonitoringSettingsState: MacroMonitoringSettingsState;
  /** Gets an meal insight for the user with their most recently logged meal as input. */
  mealInsight?: Maybe<AiInsight>;
  /** Query for telling the client what meal logging method selector options are available */
  mealLoggingMethodSelectorFeatureState: MealLoggingMethodSelectorFeatureState;
  /**
   * Fetches the latest state of measurements for a given access code and measurement type, replicating what the
   * `measurementDataList` subscription, but as a one-time query.
   *
   * Similar to the subscription, this query returns data points within the given time range
   * (fromCivilDateTime to toCivilDateTime), if provided. If no range is specified, the query will return all
   * available data up to the maximum limit (default max is 1000). The 'limit' parameter restricts the number
   * of returned results and is useful for controlling payload size. Data is returned in ascending or descending
   * order based on the 'ascendingOrder' flag.
   *
   * Note: Pagination is not currently supported. If you require more than 1000 data points in a single request,
   * please reach out to TNG to discuss enabling pagination support.
   */
  measurementDataList: MeasurementDataList;
  /** List of medications that user needs to take for on the given date. */
  medicationList: MedicationList;
  /** Get the user's micro challenges library (may include locked or upcoming items) */
  microChallengeLibrary: MicroChallengeLibrary;
  /**
   * Get the current state of the user's micro challenges.
   * This is the query equivalent of the subscription, useful for initial load.
   */
  microChallengesTrackerState: MicroChallengesTrackerState;
  /** Get a flow configuration based on criteria */
  noomFlowConfiguration: NoomFlowConfiguration;
  /**
   * The current state of the out-of-range blood glucose alerts for a user.
   * True if the alerts are enabled, or false if they are disabled.
   */
  outOfRangeBloodGlucoseAlertsEnabled: Scalars['Boolean']['output'];
  /** Returns a list of past medication doses. */
  pastMedicationDoseList: PastMedicationDoseList;
  /** Returns the list of user's diagnostic reports, in reverse order of time collected */
  patientDiagnosticReports: PatientDiagnosticReportList;
  /** Returns available product listings to the user. */
  productListings: ProductListingCatalog;
  /**
   * Return a single foundation.
   * - `programConfigId`: Required id of the foundation's parent program
   * - `foundationId`: Required id of the foundation to fetch
   * Returns the foundation
   */
  programFoundation: ProgramFoundation;
  /**
   * Return all program foundations
   * - `programConfigId`: Required id of the program to fetch all foundations for
   * Returns the list of foundations
   */
  programFoundations: ProgramFoundations;
  /** Returns the presentation of the Progress screen */
  progressScreen: ProgressScreen;
  /** Returns partner specific set of parameters for initiating a facial blood scan */
  providerConfiguration: ProviderConfiguration;
  /** Get a recommended offer for a user going through the buyflow. Initially this will only be used for med plan reveal. */
  recommendedBuyflowOffers: RecommendedBuyflowOffersResponse;
  /**
   * Returns available redeemable rewards.
   * Called by the client when displaying the rewards page.
   */
  redeemableRewards: RedeemableRewards;
  /** Fetches which relation promotion to return based on the user's friends list status. */
  relationPromotion?: Maybe<RelationsPromotions>;
  /** Query the list of relations for a user. The server resolves `extra_data` lazily; if the client does not select extra fields, no extra computation occurs. */
  relationsList: RelationsList;
  /** Returns the data necessary to render the Relations Promo card. Return Null if feature is disabled, user is ineligible, etc. */
  relationsPromoCard?: Maybe<RelationsPromoCard>;
  /**  Return a list of all reminders for a given user and reminder type */
  reminderSettingsState: ReminderSettingsList;
  /**
   * Returns info on the user's rewards, e.g. current state, program configuration, etc.
   * Called by the client on app launch.
   */
  rewards: Rewards;
  /**
   * Returns a list of available rewards levels.
   * Called by the client when the Rewards screen is opened.
   */
  rewardsLevels: RewardsLevels;
  /** Retrieves a single scheduled content item by its unique identifier */
  scheduledContent?: Maybe<ScheduledContent>;
  /** Returns Shopify orders associated with a given email */
  shopifyOrders?: Maybe<ShopifyOrdersList>;
  /**
   * Fetches a user's current SmartDose for the user's prescribed medication.
   * May be null if the user hasn't logged medications before.
   */
  smartDose?: Maybe<SmartDose>;
  /** Returns the details of the streak */
  streakDetails?: Maybe<Streak>;
  streakFreeze?: Maybe<StreakFreeze>;
  /** Retrieves the support chat unread messages count for a user identified by their access code */
  supportChatUnreadMessages: SupportChatUnreadMessages;
  /** Returns successfully if x-noom-config-ref, x-noom-routing-id, and Accept-Language are successfully proxied */
  testHeaderProxying?: Maybe<Scalars['String']['output']>;
  /** Returns the access code parameter if present, otherwise attempts to determine the access code from the token. */
  testOptionalAccessCode: Scalars['String']['output'];
  /** Returns `Looking good!` */
  testSuccess?: Maybe<Scalars['String']['output']>;
  /** Returns an unauthorized API response */
  testUnauthorized?: Maybe<Scalars['String']['output']>;
  /** Returns a list of upcoming medication doses. */
  upcomingMedicationDoseList: UpcomingMedicationDoseList;
  /** Returns a list of data required by the client for upsell ad placement */
  upsellAdDataList: UpsellAdDataList;
  /**
   * Search for user model segments using any of the supported search fields.
   *
   * The query exposes pagination via CursorPagination, but the only implemented
   * field is 'first'. You can specify how many search results you want, but
   * you can't sort them or define which page you want to retrieve.
   *
   * All fields except for 'first' are unsupported now, but might be supported in
   * the future. So, if you're using pagination, use sensible values even for
   * unsupported fields to avoid unwanted behavior if and when EC-API rolls
   * out full pagination support.
   */
  userModelSegments?: Maybe<UserModelSegments>;
  /** Get multiple user preview profiles in a single batch request */
  userPreviewProfilesBatch: UserPreviewProfilesBatchResponse;
  /** Validates a user address and returns the status of the address and the corrected address if applicable */
  validateAddress: ValidateAddressResponse;
  /**
   * Returns a specific version of the AnnotatedMeasurementTrendChart using Weight as measurement and Meds as annotation.
   * The response also includes some information specific to this chart. The limits are determined by the product
   * requirements - we should return all weight measurements occurring within the last three med logs for
   * semaglutide users. For other med users this endpoint should return no data.
   */
  weightMedsSnapshot: WeightMedsSnapshot;
};


export type QueryAiMealInsightArgs = {
  analyticsConversationId?: InputMaybe<Scalars['String']['input']>;
  loggedMealInput: LoggedMealInput;
};


export type QueryAnnotatedMeasurementTrendChartArgs = {
  accessCode: Scalars['String']['input'];
  annotationType?: InputMaybe<TrendChartAnnotationType>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limitAnnotations?: InputMaybe<Scalars['Int']['input']>;
  limitMeasurements?: InputMaybe<Scalars['Int']['input']>;
  measurementType: TrendChartMeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type QueryArtGalleryArgs = {
  galleryId: Scalars['ID']['input'];
};


export type QueryAssessmentPrivacyPolicyArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  assessmentType: HealthMetricSource;
};


export type QueryAutocompleteAddressArgs = {
  autocompleteService?: InputMaybe<AutocompleteService>;
  countryCode: Scalars['String']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  queryString: Scalars['String']['input'];
};


export type QueryAvailableTargetsArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  goalId: GoalId;
  programUuid: Scalars['String']['input'];
};


export type QueryBodyScanIngressArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryBodyScanPrivacyPolicyArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBodyScanSettingsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryBodyScanTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


export type QueryBodyScansArgs = {
  accessCode: Scalars['String']['input'];
  filters?: InputMaybe<BodyScansListFilters>;
  pagination?: InputMaybe<CursorPagination>;
};


export type QueryChatChannelArgs = {
  channelId: Scalars['String']['input'];
};


export type QueryClinicianChannelUrlArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryCoachAnnouncementArgs = {
  announcementId: Scalars['String']['input'];
};


export type QueryCoachAnnouncementsArgs = {
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryCoachAnnouncementsUserInteractionsArgs = {
  cursorPagination: CursorPagination;
};


export type QueryCoachingConfigForUserArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryConsentCheckArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentConsumptionStateArgs = {
  accessCode: Scalars['String']['input'];
  contentType: CurriculumContentType;
  tasksRequestedAtDatetime: Scalars['DateTime']['input'];
  tasksRequestedForDatetime: Scalars['DateTime']['input'];
};


export type QueryCurriculumModulesArgs = {
  filters?: InputMaybe<CurriculumModulesFilters>;
};


export type QueryDynamicCalorieGoalSettingsStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEligibleForWeightMedsSnapshotArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryEligibleForWeightMedsSnapshotBasedOnGoalsArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryExternalCoachingTermsAndConditionsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFaceScanTaskArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDate: Scalars['LocalDate']['input'];
  selectedClientDate: Scalars['LocalDate']['input'];
};


export type QueryFacialBloodScanIntroMetadataArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFacialBloodScanQuestionnaireArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  provider: FacialBloodScanProvider;
};


export type QueryFixedContentSectionsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFoodLoggingFeaturesStatesArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerateGlucoseForecastArgs = {
  accessCode: Scalars['String']['input'];
  foodItems: Array<GlucoseForecastFoodItemInput>;
};


export type QueryGenerateGlucoseForecastV2Args = {
  accessCode: Scalars['String']['input'];
  foodItems: Array<GlucoseForecastFoodItemInput>;
};


export type QueryGoalsForDateArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  programUuid: Scalars['String']['input'];
};


export type QueryHealthInsightsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHealthReportArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHomeScreenCarouselStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryInitializeFaceScanArgs = {
  age?: InputMaybe<Scalars['Int']['input']>;
  clientDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  scanId: Scalars['UUID']['input'];
};


export type QueryInterstitialsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryListScheduledContentArgs = {
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryMacroMonitoringSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryMealInsightArgs = {
  analyticsConversationId?: InputMaybe<Scalars['String']['input']>;
  loggedMealInput: LoggedMealInput;
};


export type QueryMealLoggingMethodSelectorFeatureStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type QueryMedicationListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryMicroChallengeLibraryArgs = {
  accessCode: Scalars['String']['input'];
  clientDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type QueryMicroChallengesTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  selectedClientDate: Scalars['LocalDate']['input'];
};


export type QueryNoomFlowConfigurationArgs = {
  input: NoomFlowCriteriaInput;
};


export type QueryOutOfRangeBloodGlucoseAlertsEnabledArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryPastMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type QueryPatientDiagnosticReportsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryProductListingsArgs = {
  accessCode: Scalars['String']['input'];
  eligibleOnly?: InputMaybe<Scalars['Boolean']['input']>;
  targetDate: Scalars['LocalDate']['input'];
};


export type QueryProgramFoundationArgs = {
  foundationId: Scalars['UUID']['input'];
  live?: InputMaybe<Scalars['Boolean']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type QueryProgramFoundationsArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
  programConfigId: Scalars['UUID']['input'];
};


export type QueryProgressScreenArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProviderConfigurationArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  provider: FacialBloodScanProvider;
};


export type QueryRecommendedBuyflowOffersArgs = {
  input: RecommendedBuyflowOffersInput;
};


export type QueryRedeemableRewardsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryRelationPromotionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: RelationsPromotionInput;
};


export type QueryRelationsListArgs = {
  cursorPagination?: InputMaybe<CursorPagination>;
  relationType: RelationType;
  userAccessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRelationsPromoCardArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: RelationsPromoCardInput;
};


export type QueryReminderSettingsStateArgs = {
  accessCode: Scalars['String']['input'];
  reminderType: ReminderType;
};


export type QueryRewardsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryRewardsLevelsArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryScheduledContentArgs = {
  scheduledContentId: Scalars['UUID']['input'];
};


export type QueryShopifyOrdersArgs = {
  email: Scalars['String']['input'];
};


export type QuerySmartDoseArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDateTime: Scalars['LocalDateTime']['input'];
};


export type QueryStreakDetailsArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  dataDateRange: LocalDateRangeInput;
  type: StreakType;
  userCurrentDate: Scalars['LocalDate']['input'];
};


export type QueryStreakFreezeArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupportChatUnreadMessagesArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryTestOptionalAccessCodeArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
  programUuid: Scalars['String']['input'];
};


export type QueryUpsellAdDataListArgs = {
  accessCode: Scalars['String']['input'];
  adLocation?: InputMaybe<UpsellAdLocation>;
};


export type QueryUserModelSegmentsArgs = {
  createdAfter?: InputMaybe<Scalars['LocalDateTime']['input']>;
  creator?: InputMaybe<Scalars['String']['input']>;
  creatorsToExclude?: InputMaybe<CreatorsToExclude>;
  cursorPagination?: InputMaybe<CursorPagination>;
  id?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPreviewProfilesBatchArgs = {
  accessCodes: Array<Scalars['String']['input']>;
};


export type QueryValidateAddressArgs = {
  address: ValidationAddressInput;
  validationService?: InputMaybe<ValidationService>;
};


export type QueryWeightMedsSnapshotArgs = {
  accessCode: Scalars['String']['input'];
  preferredWeightUnit?: InputMaybe<PreferredWeightUnit>;
};

/** Feedback with just a rating */
export type RatingOnlyInsightFeedback = InsightFeedback & {
  __typename?: 'RatingOnlyInsightFeedback';
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
};

/** Feedback with a rating and further comments */
export type RationaleInsightFeedback = InsightFeedback & {
  __typename?: 'RationaleInsightFeedback';
  /** The user's rating for the insight */
  rating?: Maybe<InsightFeedbackRating>;
  /** Comments from the user on why they selected the rating they did */
  rationale?: Maybe<Scalars['String']['output']>;
};

/** The reason an address validation failed. */
export enum Reason {
  /**
   * The input address has a missing or unknown secondary address number.
   * It is marked as not required by the validator.
   */
  IncorrectSecondaryAddressNotRequired = 'INCORRECT_SECONDARY_ADDRESS_NOT_REQUIRED',
  /**
   * The input address has a missing or unknown secondary address number.
   * It is marked as required by the validator.
   */
  IncorrectSecondaryAddressRequired = 'INCORRECT_SECONDARY_ADDRESS_REQUIRED',
  /** The input address could not find any matches in our validation service. */
  NoAddressMatch = 'NO_ADDRESS_MATCH',
  /** The input address is a PO Box, which we do not accept. */
  PoBox = 'PO_BOX'
}

/** Input for getting recommended offers */
export type RecommendedBuyflowOffersInput = {
  /**
   * A list of products the user is eligible to be offered.
   * Long term this will be determined by the backend, but initially we
   * send these from the FE.
   */
  eligibleSKUsForRecommendation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of contexts the user has encountered with experiment arms and SHAs */
  experiments?: InputMaybe<Array<MeristemExperimentInfo>>;
  /** The type of recommendation we're doing */
  recommendationType: Scalars['String']['input'];
  /** All of the survey answers the user has stored */
  surveyAnswers?: InputMaybe<Array<BuyflowSurveyAnswer>>;
  /** Tracking parameters the user used (ie from the url) */
  trackingParams?: InputMaybe<TrackingParams>;
  /** userId string - matches buyflow db's userdata_userdata.id */
  userId: Scalars['String']['input'];
};

/** Response containing recommended offers */
export type RecommendedBuyflowOffersResponse = {
  __typename?: 'RecommendedBuyflowOffersResponse';
  /** Ordered list of the offers to display; the first one will be displayed on the plans results page, the whole list will be displayed if the user clicks 'See More' */
  offers: Array<Scalars['String']['output']>;
  /** Correlation id of this request */
  recommendationId: Scalars['String']['output'];
};

/**
 * Response that indicates that the micro challenge progress was successfully recorded.
 * Contains the updated user micro challenge instance with new progress.
 */
export type RecordMicroChallengeProgressResponse = {
  __typename?: 'RecordMicroChallengeProgressResponse';
  /** The updated user micro challenge instance with new progress */
  userMicroChallenge: UserMicroChallenge;
};

/** Represents a redeemable charitable donation reward */
export type RedeemableRewardCharitableDonation = {
  __typename?: 'RedeemableRewardCharitableDonation';
  /** Display image for the reward */
  image: RewardImage;
  /** Minimal amount of currency units (seeds) required to make a donation */
  minimalCurrencyAmount: Scalars['Int']['output'];
  /** WebView URL for redeeming the charitable donation reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Display subtitle for the reward */
  subtitle: Scalars['String']['output'];
  /** Display title for the reward */
  title: Scalars['String']['output'];
};

/** Represents a redeemable gift card reward */
export type RedeemableRewardGiftCard = {
  __typename?: 'RedeemableRewardGiftCard';
  /** Required amount of currency units (seeds) to redeem the gift card */
  currencyAmount: Scalars['Int']['output'];
  /** WebView URL for redeeming the gift card reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Monetary value of the gift card */
  value: Money;
};

/** Represents the collection of redeemable rewards available to the user */
export type RedeemableRewards = {
  __typename?: 'RedeemableRewards';
  /** A list of available charitable donations */
  charitableDonations: Array<RedeemableRewardCharitableDonation>;
  /** A list of available gift cards */
  giftCards: Array<RedeemableRewardGiftCard>;
};

/** Represents a directed relation between two users. */
export type Relation = {
  __typename?: 'Relation';
  /** Server time when the relation was created (Unix timestamp in seconds). */
  effectiveDateFrom: Scalars['LocalDateTime']['output'];
  /** Stable identifier of the relation record. */
  id: Scalars['ID']['output'];
  /** Type of relation between the users (e.g., friendship). */
  relationType: RelationType;
  /** Source user access code - the main user from whose perspective this relation is materialized. */
  sourceUserAccessCode: Scalars['String']['output'];
  /** Target user access code - the user related to the source in this directed projection. */
  targetUserAccessCode: Scalars['String']['output'];
};

/** Relation activities list delivered via subscription. */
export type RelationActivitiesList = {
  __typename?: 'RelationActivitiesList';
  /** Relations enriched with optional extra data activities (e.g., steps, green calories). */
  relationsInfo: Array<RelationInfo>;
};

/** Details about a specific reward available for creating a relation. */
export type RelationAvailableReward = {
  __typename?: 'RelationAvailableReward';
  /** The amount of currency earned for this specific reward */
  amountEarned: Scalars['Int']['output'];
  /** The reason for earning this currency reward. */
  earningReason?: Maybe<CurrencyEarnedReason>;
};

/** Enumeration of specific error reasons for relations API errors. */
export enum RelationErrorReason {
  /** Feature is disabled for the user */
  FeatureIsDisabled = 'FEATURE_IS_DISABLED',
  /** Feature requires a subscription upgrade to be accessed */
  FeatureRequiresSubscriptionUpgrade = 'FEATURE_REQUIRES_SUBSCRIPTION_UPGRADE',
  /** Feature is disabled for B2B users */
  FriendshipB2BForbidden = 'FRIENDSHIP_B2B_FORBIDDEN',
  /** Feature is disabled for users with no DPP entitlement */
  FriendshipDppForbidden = 'FRIENDSHIP_DPP_FORBIDDEN',
  /** Feature is disabled for users due to presence of specific entitlement */
  FriendshipForSpecificEntitlementForbidden = 'FRIENDSHIP_FOR_SPECIFIC_ENTITLEMENT_FORBIDDEN',
  /** Initiator already has too many friends */
  InitiatorTooManyFriends = 'INITIATOR_TOO_MANY_FRIENDS',
  /** Invitation to upgrade subscription to FREEMIUM is disabled (with feature flag) */
  PaidToFreemiumInviteFlowDisabled = 'PAID_TO_FREEMIUM_INVITE_FLOW_DISABLED',
  /** Target user profile has been deleted */
  TargetUserProfileDeleted = 'TARGET_USER_PROFILE_DELETED',
  /** Unknown or unspecified error reason */
  Unknown = 'UNKNOWN',
  /** Unsupported business type for this operation */
  UnsupportedBusinessTypeForOperation = 'UNSUPPORTED_BUSINESS_TYPE_FOR_OPERATION',
  /** Feature requires a subscription upgrade to FREEMIUM for B2C users */
  UpgradeB2CToFreemiumRequired = 'UPGRADE_B2C_TO_FREEMIUM_REQUIRED'
}

/** Optional, computed add-ons for a relation. Omitted (null) if not requested or unavailable. */
export type RelationExtraData = {
  __typename?: 'RelationExtraData';
  /** Profile data for the related user in a relation. */
  profile?: Maybe<NoomUserPreviewProfile>;
};

/** Wrapper that couples the base relation with optional extra data. */
export type RelationInfo = {
  __typename?: 'RelationInfo';
  /** Optional extra data. May be null if not selected or not available. */
  extraData?: Maybe<RelationExtraData>;
  /** The base relation entity. */
  relation: Relation;
};

/** Enumerates the types of relations between users. */
export enum RelationType {
  /** Friendship relation between two users. */
  Friendship = 'FRIENDSHIP'
}

/** Relation wrapper containing list of relations and paging info. */
export type RelationsList = Pageable & {
  __typename?: 'RelationsList';
  /** Metadata for fetching the next page of results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** Relations enriched with optional extra data. */
  relationsInfo: Array<RelationInfo>;
  /** The total number of results that match the filtering criteria for the returned list */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** The data necessary to render the Relations Promo card. */
export type RelationsPromoCard = {
  __typename?: 'RelationsPromoCard';
  /** Single available reward to highlight for the user, if any. */
  availableReward?: Maybe<RelationAvailableReward>;
  /** Friends list to show on the home tab. Returns an empty list [] when there are no friends (user has 0 friends). */
  relationsInfo: Array<RelationInfo>;
  /** Number of remaining friend slots available (out of configurable total slots). */
  slotsRemaining: Scalars['Int']['output'];
};

/** Input for the query fetching the Relations Promo card. */
export type RelationsPromoCardInput = {
  /** Client's date and time, with time zone offset. Used to evaluate reward eligibility. */
  clientDateTime: Scalars['OffsetDateTime']['input'];
  /** Last time the promo was hidden by the user (client time). */
  lastHiddenAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  /** The type of relation for which to compute friends and rewards. */
  relationType: RelationType;
  /** Last time the rewards screen was shown (client time). */
  rewardsScreenLastViewedAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

/** Input for fetching which promotion to return. */
export type RelationsPromotionInput = {
  /** Civil date and time when the request is made. Optional; if not provided, server time will be used. */
  civilDateTime?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  /** The type of relation. */
  relationType: RelationType;
};

/** Enumerates the available promotion types for relations rewards. */
export enum RelationsPromotions {
  /** Promotion for users with an empty friends list. */
  EmptyFriendsListPromotion = 'EMPTY_FRIENDS_LIST_PROMOTION',
  /** Promotion for users with a non-empty friends list. */
  NonEmptyFriendsListPromotion = 'NON_EMPTY_FRIENDS_LIST_PROMOTION'
}

export type ReminderSettings = {
  __typename?: 'ReminderSettings';
  enabled: Scalars['Boolean']['output'];
  reminderSubtype: Scalars['String']['output'];
  reminderTime: Scalars['LocalTime']['output'];
  reminderType: ReminderType;
  reminderUuid: Scalars['UUID']['output'];
};

export type ReminderSettingsList = {
  __typename?: 'ReminderSettingsList';
  reminderSettings: Array<ReminderSettings>;
};

/**
 *  These values must be aligned with:
 *  - reminder_settings.proto (ReminderTypeProto.Value)
 */
export enum ReminderType {
  Medication = 'MEDICATION',
  Unknown = 'UNKNOWN'
}

/** Represents an image for a reward */
export type RewardImage = {
  __typename?: 'RewardImage';
  /** Type of image */
  image: RewardImageType;
};

/** Reward image asset - this is a wrapper for enum because union types don't allow enums */
export type RewardImageAsset = {
  __typename?: 'RewardImageAsset';
  /** Type of image asset */
  type: RewardImageAssetType;
};

/**
 * Represents available image assets for rewards.
 * In older versions of the app that do not recognize the image asset type, the image will not be shown.
 */
export enum RewardImageAssetType {
  BlueGemstone = 'BLUE_GEMSTONE',
  GreenGemstone = 'GREEN_GEMSTONE',
  PinkGemstone = 'PINK_GEMSTONE',
  PurpleGemstone = 'PURPLE_GEMSTONE',
  RedGemstone = 'RED_GEMSTONE',
  RedGemstoneHeart = 'RED_GEMSTONE_HEART'
}

/** Represents a reward image with a URL source */
export type RewardImageRemote = {
  __typename?: 'RewardImageRemote';
  /** URL of the image to be displayed for the reward */
  url: Scalars['String']['output'];
};

/**
 * Union of available types of reward images.
 * Currently, we only support local image assets, however, this can be expanded with other types, including URLs for images hosted on the backend.
 * In older versions of the app that do not recognize the image type, depending on where the image is used:
 *     - CurrencyEarnedReward: the reward image will not be shown in the currency earned modal.
 *     - RewardsLevel: the reward level list item will not be shown.
 */
export type RewardImageType = RewardImageAsset | RewardImageRemote;

/** Contains data on rewards shared via the friend reward sharing feature */
export type RewardSharingData = {
  __typename?: 'RewardSharingData';
  /** The amount of currency shared to each friend */
  amountShared: Scalars['Int']['output'];
};

export type Rewards = {
  __typename?: 'Rewards';
  /** Current state of user's rewards. */
  state: RewardsState;
};

/** Represents a single reward level */
export type RewardsLevel = {
  __typename?: 'RewardsLevel';
  /** Image for the reward level */
  image: RewardImage;
  /** Reward level is permanently unlocked once user reached the required amount */
  isUnlocked: Scalars['Boolean']['output'];
  /** Identifies a specific reward level */
  level: Scalars['Int']['output'];
  /** Required amount of currency to unlock the reward */
  requiredCurrencyAmount: Scalars['Int']['output'];
  /** Type of rewards level */
  type: RewardsLevelType;
};

/** Represents a charity reward level */
export type RewardsLevelCharity = {
  __typename?: 'RewardsLevelCharity';
  /** WebView URL for redeeming the reward */
  redeemWebViewUrl: Scalars['String']['output'];
};

/** Represents a gift card reward level */
export type RewardsLevelGiftCard = {
  __typename?: 'RewardsLevelGiftCard';
  /** WebView URL for redeeming the reward */
  redeemWebViewUrl: Scalars['String']['output'];
  /** Monetary amount of gift card */
  value: Money;
};

/**
 * Union representing the different types of rewards levels.
 * In older versions of the app that do not recognize the reward level type (or the reward image), the reward level will not be shown.
 */
export type RewardsLevelType = RewardsLevelCharity | RewardsLevelGiftCard;

/** Represents the different rewards levels available to users */
export type RewardsLevels = {
  __typename?: 'RewardsLevels';
  /** Contains info for displaying How to earn currency screen */
  howToEarnCurrency: HowToEarnCurrencyType;
  /** A list of available rewards levels */
  levels: Array<RewardsLevel>;
  /**
   * A list of available methods to earn rewards currency
   * @deprecated Methods are not needed any more
   */
  methods: Array<Maybe<EarnCurrencyMethod>>;
};

/**
 * Represents a monetary value used for custom currencies created in the Rewards
 * System
 */
export type RewardsMoney = {
  __typename?: 'RewardsMoney';
  /** Mapped currency types supported on Rewards API. */
  currency: CurrencyCode;
  /**
   * The whole units of the amount.
   * For example if currency is SEEDS, then 10 units represents 10
   * seeds.
   */
  units: Scalars['Int']['output'];
};

/**
 * Union representing the different types of rewards states.
 * In older versions of the app that do not recognize the reward state type, the state update will be ignored.
 */
export type RewardsState = EnrolledRewardsState | UnenrolledRewardsState;

export type SHealthAttributionDataInput = {
  /** Package name of the app inserting data. */
  packageName: Scalars['String']['input'];
  /** Unique identifier for the data point in SHealth. */
  uuid: Scalars['String']['input'];
};

export type SaveAnuraScanInput = {
  /** Any signals Anura failed to calculate */
  error?: InputMaybe<AnuraMeasurementError>;
  /** Anura unique identifier of the scan (measurement) */
  faceScanId: Scalars['String']['input'];
  /** Unique identifier (across the organization) of the user in Anura */
  partnerId: Scalars['String']['input'];
  /** Successful point signals */
  results: Array<AnuraMeasurement>;
};

export type SaveFacialBloodScanInput = {
  anuraInput?: InputMaybe<SaveAnuraScanInput>;
};

export type SaveFacialBloodScanQuestionnaireInput = {
  anuraQuestionnaireInput?: InputMaybe<AnuraQuestionnaireInput>;
};

/** Interface for content that can be scheduled */
export type SchedulableContent = {
  /** Unique identifier for the content */
  id: Scalars['ID']['output'];
  /** Title or name of the content */
  title: Scalars['String']['output'];
};

/** A piece of scheduled content */
export type ScheduledContent = {
  __typename?: 'ScheduledContent';
  /** The content to be displayed in the scheduled slot */
  content: SchedulableContent;
  /** End date and time of the scheduled content */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** Start date and time of the scheduled content */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** Current status of the scheduled content */
  status?: Maybe<ContentStatus>;
  /** Unique Identifier for scheduled content */
  uuid: Scalars['ID']['output'];
};

/** A list of scheduled contents with pagination support */
export type ScheduledContentList = Pageable & {
  __typename?: 'ScheduledContentList';
  /** The list of scheduled content items */
  items: Array<ScheduledContent>;
  /** Metadata for fetching the next page of results, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** The total number of results that match the filtering criteria */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Enum for different types of schedulable content */
export enum ScheduledContentType {
  /** Art break content type */
  ArtBreak = 'ART_BREAK',
  /** Unspecified content type (default) */
  ContentTypeUnspecified = 'CONTENT_TYPE_UNSPECIFIED'
}

/** A wrapper for the seeds string Content Item description */
export type SeedsString = {
  __typename?: 'SeedsString';
  /** Simple string value */
  value: Scalars['String']['output'];
};

/** Response from a successfully updated body scan mode setting */
export type SetBodyScanModeSettingResponse = {
  __typename?: 'SetBodyScanModeSettingResponse';
  mode: BodyScanMode;
};

/** Response from a successfully updated show avatar setting */
export type SetShowAvatarSettingResponse = {
  __typename?: 'SetShowAvatarSettingResponse';
  showAvatar: Scalars['Boolean']['output'];
};

export type SetToolPinStateInput = {
  pinned: Scalars['Boolean']['input'];
  toolId: ToolId;
};

/** Represents biological sex */
export enum Sex {
  Female = 'FEMALE',
  Intersex = 'INTERSEX',
  Male = 'MALE',
  Unspecified = 'UNSPECIFIED'
}

export type ShareableImage = {
  __typename?: 'ShareableImage';
  mediaUrl: Scalars['String']['output'];
};

export type ShareableMedia = {
  __typename?: 'ShareableMedia';
  /** The actual item (image, video, etc) to share */
  item: ShareableMediaItem;
  /** The default string that the user will use as 'subject' if they choose to share through email */
  subject?: Maybe<Scalars['String']['output']>;
  /** The default string that the user will share in social media together with whatever media item they're sharing */
  text?: Maybe<Scalars['String']['output']>;
  /** The type of the template that generated this shareable, so that we can send events to analytics */
  type: Scalars['String']['output'];
};

export type ShareableMediaItem = ShareableImage | ShareableToggleImage | ShareableVideo;

export type ShareableToggleImage = {
  __typename?: 'ShareableToggleImage';
  mediaUrl1: Scalars['String']['output'];
  mediaUrl2: Scalars['String']['output'];
  toggleButtonTitle1: Scalars['String']['output'];
  toggleButtonTitle2: Scalars['String']['output'];
};

export type ShareableVideo = {
  __typename?: 'ShareableVideo';
  mediaUrl: Scalars['String']['output'];
};

/**
 * Currently only listing the properties that we use,
 * see: https://shopify.dev/docs/api/admin-rest/2024-10/resources/order
 */
export type ShopifyOrder = {
  __typename?: 'ShopifyOrder';
  /** ISO 4217 currency code for the order */
  currency?: Maybe<Scalars['String']['output']>;
  /** The ID of the order */
  id?: Maybe<Scalars['String']['output']>;
  /** The line items in the order */
  lineItems?: Maybe<Array<ShopifyOrderLineItem>>;
  /** Human-friendly order name/number */
  name?: Maybe<Scalars['String']['output']>;
  /** Arbitrary key/value attributes captured on the order */
  noteAttributes?: Maybe<Array<ShopifyOrderNoteAttribute>>;
  /** When the order was processed */
  processedAt?: Maybe<Scalars['String']['output']>;
  /** Refund records associated with the order */
  refunds?: Maybe<Array<ShopifyOrderRefund>>;
  /** Comma-separated list of tags on the order */
  tags?: Maybe<Scalars['String']['output']>;
  /** Total price for the order in shop currency (stringified decimal) */
  totalPrice?: Maybe<Scalars['String']['output']>;
  /** Total tax charged on the order (stringified decimal) */
  totalTax?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrderLineItem = {
  __typename?: 'ShopifyOrderLineItem';
  /** Line item title (product/variant name) */
  name?: Maybe<Scalars['String']['output']>;
  /** Line item price (stringified decimal, in order currency) */
  price?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrderNoteAttribute = {
  __typename?: 'ShopifyOrderNoteAttribute';
  /** Attribute key/name */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute value */
  value?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrderRefund = {
  __typename?: 'ShopifyOrderRefund';
  /** The ID of the refund */
  id?: Maybe<Scalars['String']['output']>;
  /** When the refund was processed */
  processedAt?: Maybe<Scalars['String']['output']>;
  /** Transactions created as part of this refund */
  transactions?: Maybe<Array<ShopifyOrderTransaction>>;
};

export type ShopifyOrderTransaction = {
  __typename?: 'ShopifyOrderTransaction';
  /** Refunded amount (stringified decimal, in order currency) */
  amount?: Maybe<Scalars['String']['output']>;
};

export type ShopifyOrdersList = {
  __typename?: 'ShopifyOrdersList';
  /** Shopify orders */
  orders?: Maybe<Array<ShopifyOrder>>;
};

export type SideEffect = {
  __typename?: 'SideEffect';
  ctaDeepLink: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  sideEffectId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SideEffectsSection = {
  __typename?: 'SideEffectsSection';
  ctaDeepLink: Scalars['String']['output'];
  ctaTitle: Scalars['String']['output'];
  footer: Scalars['String']['output'];
  sideEffects: Array<SideEffect>;
  title: Scalars['String']['output'];
};

/** Content for an small ad in the hamburger menu. */
export type SideNavMenuSmallContent = {
  __typename?: 'SideNavMenuSmallContent';
  /** The text of the CTA button. */
  buttonText: Scalars['String']['output'];
  /** The url of the image to show. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The url that should be opened when the ad is tapped. */
  targetUrl: Scalars['String']['output'];
  /** The title of this content. */
  title?: Maybe<Scalars['String']['output']>;
};

export type SimpleMealItem = {
  __typename?: 'SimpleMealItem';
  calories?: Maybe<Scalars['Float']['output']>;
  foodColor?: Maybe<FoodColor>;
  greenScore?: Maybe<Scalars['Float']['output']>;
  loggedUuid: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  nutritionBreakdown?: Maybe<NutritionBreakdown>;
  originUuid?: Maybe<Scalars['UUID']['output']>;
  portion?: Maybe<Portion>;
};

/** Required fields for client to recommend a SmartDose */
export type SmartDose = {
  __typename?: 'SmartDose';
  /** List of items appearing in the 'About your SmartDose' card */
  aboutSmartDoseFacts: Array<LabeledValue>;
  /** Descriptive text about user's weight/SmartDose trends */
  aboutYourSmartdoseMarkdown?: Maybe<Scalars['String']['output']>;
  /** The user's personalized dosage amount */
  dose: Scalars['Float']['output'];
  /** The units their personalized dosage is measured in */
  doseUnits: DoseUnits;
  /** URL of example syringe image showing correct dose amount */
  exampleSyringeImageUrl?: Maybe<Scalars['String']['output']>;
  /** URL for a website with injection instructions */
  injectionInstructionsUrl?: Maybe<Scalars['String']['output']>;
  /** The internal id of the drug they are prescribed */
  internalDrugId: Scalars['ID']['output'];
  /** Task card text shown when SmartDose is calculated but med not logged */
  smartDoseCalculatedTaskCardMarkdown?: Maybe<Scalars['String']['output']>;
};

/**
 * Enumerated error reasons whose names will appear in `errors[].extensions.code`
 * in the response to [Mutation.calculateSmartDose].
 * An accompanying user-facing message should also appear at
 * `.extensions.userMessage`, to be displayed to the user.
 */
export enum SmartDoseMutationErrorCodes {
  /**
   * It is not safe to continue taking the medication.
   * Clients should show a CTA to contact their clinician.
   */
  DiscontinueMedication = 'DISCONTINUE_MEDICATION'
}

/** Defines the sorting implementation for a list */
export type Sort = {
  /** The key that the list will be sorted by. If not set, the backend will select a default sort key */
  sortKey?: InputMaybe<Scalars['String']['input']>;
  /** The order in which the results are returned */
  sortOrder?: SortOrder;
};

/** Defines the sorting order for a list */
export enum SortOrder {
  /** Ascending order. Ex: A->Z, 1->9 */
  Ascending = 'ASCENDING',
  /** Use the natural sorting order as defined by the backend */
  Default = 'DEFAULT',
  /** Descending order. Ex: Z->A, 9->1 */
  Descending = 'DESCENDING'
}

/** Classification of glucose spike potential for a specific food item */
export enum SpikeClassification {
  /** Food item is predicted to cause a moderate increase in blood glucose levels */
  Elevated = 'ELEVATED',
  /** Food item is predicted to cause a significant spike in blood glucose levels */
  Spike = 'SPIKE',
  /** Food item is predicted to have minimal impact on blood glucose levels */
  Stable = 'STABLE',
  /** Classification could not be determined due to insufficient data or analysis failure */
  Unknown = 'UNKNOWN'
}

/** Standalone content (e.g. static articles) served by url */
export type StandaloneContent = {
  __typename?: 'StandaloneContent';
  /** Analytics properties filled on the backend and forwarded by the mobile client in the analytics events */
  analyticsProperties?: Maybe<Array<AnalyticsProperty>>;
  /** Url for audio version of the content */
  audioSourceUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the user has completed this content */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** Opaque payload for tracking content consumption state */
  contentConsumedPayload?: Maybe<Scalars['String']['output']>;
  /** Id for content analytics */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Url for standalone content */
  contentUrl: Scalars['String']['output'];
  /** Optional format of content - used with rewards toast */
  format?: Maybe<Scalars['String']['output']>;
  /** Image URL */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Optional label for the content (e.g. 'video', 'story', 'quiz') */
  label?: Maybe<Scalars['String']['output']>;
  /** ID of the recommendation from the Recommender system */
  recommendationId?: Maybe<Scalars['String']['output']>;
  /** Display title */
  title: Scalars['String']['output'];
};

/** Groups standalone content into titled sections */
export type StandaloneContentSection = {
  __typename?: 'StandaloneContentSection';
  /** Optional label for refresh timing or status (e.g. 'Next in 12h') */
  refreshLabel?: Maybe<Scalars['String']['output']>;
  /** List of standalone content in the section */
  standaloneContentList: Array<StandaloneContent>;
  /** Section Title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Task List assignment for the Home screen Standalone Content section. */
export type StandaloneContentSectionAssignment = {
  __typename?: 'StandaloneContentSectionAssignment';
  /** Section with a list of standalone content. */
  section: StandaloneContentSection;
};

export type StartMicroChallengeResponse = {
  __typename?: 'StartMicroChallengeResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userMicroChallengeId?: Maybe<Scalars['UUID']['output']>;
};

export type StepGoalMetadata = {
  __typename?: 'StepGoalMetadata';
  minStepCount?: Maybe<Scalars['Int']['output']>;
};

export type StepTarget = {
  minStepCount?: InputMaybe<Scalars['Int']['input']>;
};

export type StepsData = {
  __typename?: 'StepsData';
  measurementCivilDate?: Maybe<Scalars['LocalDate']['output']>;
  stepCount: Scalars['Int']['output'];
};

export type StepsDataInput = {
  measurementCivilDate: Scalars['LocalDate']['input'];
  stepCount: Scalars['Int']['input'];
};

export type Streak = {
  __typename?: 'Streak';
  /** The list of days with states representing the state history of this streak */
  dayHistory?: Maybe<Array<StreakDay>>;
};

/**
 * The animation type to show the user.
 * The backend determines if a user's streak has reached a milestone (e.g., 7 or 30 days)
 * and sets the appropriate animation type. Clients use this value to select a random
 * animation from the corresponding set.
 */
export enum StreakAnimationType {
  /** Default animation type */
  Default = 'DEFAULT',
  /** Milestone animation type */
  Milestone = 'MILESTONE'
}

export enum StreakDailyStatus {
  /** Indicates the streak was frozen */
  Frozen = 'FROZEN',
  /** Indicates that the streak was increased */
  Incremented = 'INCREMENTED',
  /** Indicates that the streak was not increased or frozen */
  Missed = 'MISSED',
  /** Indicates that the day is still in progress */
  Pending = 'PENDING'
}

export type StreakDay = {
  __typename?: 'StreakDay';
  /** The date of the StreakDay state */
  date: Scalars['LocalDate']['output'];
  /** The length of the streak on the current day */
  length: Scalars['Int']['output'];
  /** The status for the given date */
  status: StreakDailyStatus;
};

export type StreakFreeze = {
  __typename?: 'StreakFreeze';
  /** The number of streak freezes available */
  count: Scalars['Int']['output'];
};

/**
 * Reason for the streak increase.
 * Used on clients to display different Welli animations and for analytics.
 */
export enum StreakIncreaseReason {
  /** User performed an art break */
  ArtBreak = 'ART_BREAK',
  /** User performed a body scan */
  BodyScan = 'BODY_SCAN',
  /** User read curriculum content */
  CurriculumContent = 'CURRICULUM_CONTENT',
  /** User performed a face scan */
  FaceScan = 'FACE_SCAN',
  /** User performed a facial blood scan. */
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /** User logged food */
  FoodLogging = 'FOOD_LOGGING',
  /** User logged medicine ingestion */
  MedLogging = 'MED_LOGGING',
  /** User logged mood */
  MoodLogging = 'MOOD_LOGGING',
  /** User logged movement */
  MoveLogging = 'MOVE_LOGGING',
  /** User read standalone content */
  StandaloneContent = 'STANDALONE_CONTENT',
  /** User banked steps */
  StepBanking = 'STEP_BANKING',
  /** User logged stress status */
  StressLogging = 'STRESS_LOGGING',
  /** User logged water ingestion */
  WaterLogging = 'WATER_LOGGING',
  /** User logged weight */
  WeightLogging = 'WEIGHT_LOGGING'
}

export type StreakIncreasedCelebration = {
  __typename?: 'StreakIncreasedCelebration';
  /** The animation type to show the user. */
  animationType?: Maybe<StreakAnimationType>;
  /** The streak data for the last 7 days, today inclusive */
  history?: Maybe<Array<StreakDay>>;
  /** Optional configuration for the intro experience */
  intro?: Maybe<StreakIncreasedIntroExperience>;
  /** Reason for the streak increase. */
  reason?: Maybe<StreakIncreaseReason>;
  /** The current value of the streak */
  streakAmount: Scalars['Int']['output'];
  /** The type of the streak */
  streakType: StreakType;
};

export type StreakIncreasedIntroExperience = {
  __typename?: 'StreakIncreasedIntroExperience';
  /** List of possible commitment lengths in days */
  commitmentLengths?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Union of streaks specific processing results */
export type StreakProcessingResult = GamificationActionStreakFailure | GamificationActionStreakUpdated;

/** Result metadata of a successful Streak Repair */
export type StreakRepairResult = {
  __typename?: 'StreakRepairResult';
  /** The list of days with states representing the state history of the repaired streak */
  dayHistory: Array<StreakDay>;
  /** Length of the streak after the repair */
  streakLength: Scalars['Int']['output'];
  /** Type of the repaired streak */
  streakType: StreakType;
};

export enum StreakType {
  EngagementActionStreak = 'ENGAGEMENT_ACTION_STREAK'
}

/** Input for submitting a customer satisfaction survey */
export type SubmitCsatSurveyInput = {
  rating: Scalars['Int']['input'];
  submittedBy: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
  textFeedback?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Returns new state of an aggregated measurement on subscription and on any change detected by measurements-api.
   * fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded. Limit corresponds to pageSize, but we aren't enabling full pagination over
   * subscriptions yet. Most use-cases should provide a fromCivilDateTime with reasonable scope, a toCivilDateTime
   * of the present, and keep expected measurement count in the low-hundreds, well short of the max limit of 1000.
   * If you need more than 1000 data points at once, reach out to TNG to make pagination available externally!
   */
  aggregatedMeasurementDataList: AggregatedMeasurementDataList;
  /**
   * Returns the information needed by the client to draw a chart with the specified measurements and annotations.
   * - fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   *     future measurements) are unbounded
   * - Chronological or reverse chronological order is provided by the "from" and "to" dates: if "from" is earlier than "to",
   *     then it will be in chronological order; and if "to" is earlier than "from", it will go in reverse chronological order
   * - You can also optionally limit by a maximum number of measurements and/or maximum number of annotations. Whatever
   *     is reached earlier will set the limit of the graph, and no further measurements or annotations beyond those
   *     will be provided (e.g. if we limit to 10 annotations, and the 10th annotation happens on a certain date, then no
   *     annotations or measurements will be provided beyond that date, even if we still had a larger limit of
   *     measurements). If not provided, they are each limited to 100. The maximum limit accepted is 500: if a higher
   *     limit is provided, it will be ignored and 500 will be used. We still don't provide any mechanism for pagination,
   *     so if you need more elements than that, please reach out to the Program Content team!
   */
  annotatedMeasurementTrendChart: AnnotatedMeasurementTrendChart;
  /**
   * DEPRECATED (use bloodGlucoseOverviewDataV2 instead) Provides an overview of a user's blood
   * glucose data for a specified time period, starting from a given date and extending backward
   * to cover the defined period. For example, if the specified period is 'WEEK' and the date is
   * '2025-01-01', the overview data will cover the period from '2024-12-26' to '2025-01-01'
   */
  bloodGlucoseOverviewData: BloodGlucoseOverviewData;
  /**
   * Provides an overview of a user's blood glucose data for a specified time period, starting
   * from a given date and extending backward to cover the defined period. For example, if the
   * specified period is 'WEEK' and the date is '2025-01-01', the overview data will cover the
   * period from '2024-12-26' to '2025-01-01'.
   *
   * Deprecates bloodGlucoseOverviewData: Users with 1k+ blood glucose logs in a week/month
   * (mainly CGM users) may see incomplete chart data due to a 1k cap in the backend aggregation
   * logic. Fixing it requires backend and client breaking changes, so a new version of the endpoint
   * is necessary.
   */
  bloodGlucoseOverviewDataV2: BloodGlucoseOverviewData;
  /** Returns any changes to the user's current body scan status */
  bodyScanTrackerState: BodyScanTrackerState;
  /**
   * Returns events when users earn rewards currency.
   * This triggers UI on the client to notify the user of the currency earned.
   */
  currencyEarned: CurrencyEarnedEvent;
  /** Placeholder field */
  empty?: Maybe<Scalars['ID']['output']>;
  /**
   * Returns the state of the user's face scan task.
   * Access code is optional to enable easier testing. If no access code is given it will be taken from AuthTokenProvider
   */
  faceScanTask: FaceScanTask;
  /** Returns state of the home screen carousel */
  homeScreenCarouselState: HomeScreenCarouselState;
  /**
   * Returns new state of a given measurement on new subscription and on any change detected by measurements-api.
   * fromCivilDateTime and toCivilDateTime restrict the scope of the request if provided, otherwise scope (including
   * future measurements) are unbounded. Limit corresponds to pageSize, but we aren't enabling full pagination over
   * subscriptions yet. Most use-cases should provide a fromCivilDateTime with reasonable scope, a toCivilDateTime
   * of the present, and keep expected measurement count in the low-hundreds, well short of the max limit of 1000.
   * If you need more than 1000 data points at once, reach out to TNG to make pagination available externally!
   */
  measurementDataList: MeasurementDataList;
  /**
   * Subscribe to real-time updates of the user's micro challenges state.
   * This subscription will push updates whenever:
   * - A micro challenge is started
   * - Progress is made on a micro challenge
   * - A micro challenge is completed
   * - A micro challenge expires
   * - The tracker state changes (HIDDEN <-> INTRO <-> INACTIVE <-> ACTIVE)
   */
  microChallengesTrackerState: MicroChallengesTrackerState;
  /** Returns a list of past medication doses. */
  pastMedicationDoseList: PastMedicationDoseList;
  /**
   * Used to preview the result of processing a gamification action - this will not make any updates to the state of the system.
   * It will immediately emit a value, and if the state of the system changes, a new result will be emitted to ensure clients always have the live state.
   */
  previewGamificationAction: GamificationActionResult;
  /** Listen for processing updates of the scanId */
  processingState: FaceScanImageProcessingState;
  /** Stream the list of relations and their activities (e.g., steps, green calories) for a user. The server resolves `extra_data` lazily; if the client does not select extra fields, no extra computation occurs." */
  relationActivitiesList: RelationActivitiesList;
  /**
   * Returns any changes to the user's rewards state.
   * This triggers a display update on the client to reflect the new rewards amount.
   */
  rewardsState: RewardsState;
  /** Returns the state of the streak for the currentDate */
  streakState?: Maybe<StreakDay>;
  /** Returns new state of SuccessKit on new subscription and on any change detected by tools-api */
  successKit: SuccessKit;
  /** Returns new state of tasks on subscription and on any change detected by task generators */
  taskList: TaskList;
  /** Returns successfully if x-noom-config-ref, x-noom-routing-id, and Accept-Language are successfully proxied */
  testHeaderProxying?: Maybe<Scalars['String']['output']>;
  /** Returns the message from TestMessageForGraphqlTriggeredProto every time it's fired for the specified access code */
  testSubscription: Scalars['String']['output'];
  /** Successfully returns three times before failing with an unauthorized API response */
  testUnauthorizedDuringConnection?: Maybe<Scalars['String']['output']>;
  /** Returns new state of tools on new subscription and on any change detected by tools-api */
  toolList: ToolList;
  /** Returns a list of upcoming medication doses. */
  upcomingMedicationDoseList: UpcomingMedicationDoseList;
};


export type SubscriptionAggregatedMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  datapointAggregation: MeasurementAggregationGrouping;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionAnnotatedMeasurementTrendChartArgs = {
  accessCode: Scalars['String']['input'];
  annotationType?: InputMaybe<TrendChartAnnotationType>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limitAnnotations?: InputMaybe<Scalars['Int']['input']>;
  limitMeasurements?: InputMaybe<Scalars['Int']['input']>;
  measurementType: TrendChartMeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionBloodGlucoseOverviewDataArgs = {
  accessCode: Scalars['String']['input'];
  period: BloodGlucoseOverviewPeriod;
  periodEndDate: Scalars['LocalDate']['input'];
};


export type SubscriptionBloodGlucoseOverviewDataV2Args = {
  accessCode: Scalars['String']['input'];
  period: BloodGlucoseOverviewPeriod;
  periodEndDate: Scalars['LocalDate']['input'];
};


export type SubscriptionBodyScanTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionCurrencyEarnedArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionFaceScanTaskArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  clientDate: Scalars['LocalDate']['input'];
  selectedClientDate: Scalars['LocalDate']['input'];
};


export type SubscriptionHomeScreenCarouselStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionMeasurementDataListArgs = {
  accessCode: Scalars['String']['input'];
  ascendingOrder?: InputMaybe<Scalars['Boolean']['input']>;
  fromCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measurementType: MeasurementType;
  toCivilDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type SubscriptionMicroChallengesTrackerStateArgs = {
  accessCode: Scalars['String']['input'];
  clientDate: Scalars['LocalDate']['input'];
  selectedClientDate: Scalars['LocalDate']['input'];
};


export type SubscriptionPastMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
};


export type SubscriptionPreviewGamificationActionArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  data: GamificationActionDataInput;
};


export type SubscriptionProcessingStateArgs = {
  scanId: Scalars['UUID']['input'];
};


export type SubscriptionRelationActivitiesListArgs = {
  relationType: RelationType;
  userAccessCode?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionRewardsStateArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionStreakStateArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  type: StreakType;
  userCurrentDate: Scalars['LocalDate']['input'];
};


export type SubscriptionSuccessKitArgs = {
  accessCode: Scalars['String']['input'];
  programUuid: Scalars['UUID']['input'];
};


export type SubscriptionTaskListArgs = {
  accessCode: Scalars['String']['input'];
  taskListInput?: InputMaybe<TaskListSubscriptionInput>;
};


export type SubscriptionTestSubscriptionArgs = {
  accessCode: Scalars['String']['input'];
};


export type SubscriptionToolListArgs = {
  accessCode: Scalars['String']['input'];
  programUuid: Scalars['UUID']['input'];
};


export type SubscriptionUpcomingMedicationDoseListArgs = {
  accessCode: Scalars['String']['input'];
  clientDateTime: Scalars['LocalDateTime']['input'];
  cursorPagination?: InputMaybe<CursorPagination>;
  programUuid: Scalars['String']['input'];
};

/** Specifies the user subscription tier - FREE or PAID */
export enum SubscriptionTier {
  Free = 'FREE',
  Paid = 'PAID'
}

/** Contains the information to present the SuccessKit in the UI */
export type SuccessKit = {
  __typename?: 'SuccessKit';
  /** List of Sections sorted in order to be displayed */
  sections: Array<SuccessKitSection>;
};

export type SuccessKitArticle = SuccessKitSectionItem & {
  __typename?: 'SuccessKitArticle';
  /** Analytics tag tracked when Article item is clicked */
  analyticsTag?: Maybe<Scalars['String']['output']>;
  /** Article URL to be opened in the Web view */
  contentUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  subhead?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SuccessKitMetadata = {
  __typename?: 'SuccessKitMetadata';
  imageUrl?: Maybe<Scalars['String']['output']>;
  subheader?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SuccessKitSection = {
  __typename?: 'SuccessKitSection';
  /** Section ID */
  id: Scalars['String']['output'];
  /** Section items of various types, sorted in order to be displayed */
  sectionItems: Array<SuccessKitSectionItem>;
  /** Subtitle for the Section on the UI */
  subhead?: Maybe<Scalars['String']['output']>;
  /** Title for the Section on the UI */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * DEPRECATED in favor of sectionItems
   * @deprecated Use `sectionItems` instead.
   */
  tools: Array<SuccessKitTool>;
};

export type SuccessKitSectionItem = {
  /** URL of the thumbnail image displayed as part of the item's UI */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Subtitle for the item on the UI */
  subhead?: Maybe<Scalars['String']['output']>;
  /** Title for the item on the UI */
  title?: Maybe<Scalars['String']['output']>;
};

export type SuccessKitTool = SuccessKitSectionItem & {
  __typename?: 'SuccessKitTool';
  /**
   * DEPRECATED Used only in legacy clients for Article Tools, no longer needed.
   * @deprecated Here for legacy clients, no longer needed.
   */
  contentUrl?: Maybe<Scalars['String']['output']>;
  /** Tool ID */
  id: ToolId;
  imageUrl?: Maybe<Scalars['String']['output']>;
  subhead?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SupportChatUnreadMessages = {
  __typename?: 'SupportChatUnreadMessages';
  /** Number of unread messages count with support chat */
  unreadMessagesCount: Scalars['Int']['output'];
};

/** Payload for a dashboard support request ticket. */
export type SupportRequestInput = {
  /** Optional attachments such as screenshots */
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Category used to route the ticket to the right queue */
  category: Scalars['String']['input'];
  /** Detailed description from the dashboard user */
  description: Scalars['String']['input'];
  /** Member issue that best matches the scenario */
  memberIssue: Scalars['String']['input'];
  /** User access code for the affected member */
  userAccessCode: Scalars['String']['input'];
  /** Email address for the affected member */
  userEmail: Scalars['String']['input'];
};

export enum TargetPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Task = {
  __typename?: 'Task';
  assignment?: Maybe<Assignment>;
  programUuid?: Maybe<Scalars['UUID']['output']>;
  taskCompletedEventMetadata?: Maybe<Scalars['String']['output']>;
};

export type TaskList = {
  __typename?: 'TaskList';
  additionalMetadata?: Maybe<ClientHints>;
  tasks: Array<Maybe<Task>>;
};

/**
 * Input parameters for the taskList subscription.
 *
 * These parameters are intended to replace the (now deprecated) clientDate and isForPast parameters.
 *   - selectedDate replaces clientDate. Both are LocalDates, but selectedDate is named to more accurately
 *     reflect that it depends on user selection.
 *   - isForPast is derived from (selectedDate < currentDateTime.date), and no longer needs to be set explicitly.
 */
export type TaskListSubscriptionInput = {
  /**
   * The current civil date and time on the user's device.
   * For debugging, this may also involve an offset to simulate the past or future
   */
  currentDateTime: Scalars['LocalDateTime']['input'];
  /** LocalDate that represents what day's tasks the user is requesting */
  selectedDate: Scalars['LocalDate']['input'];
};

export type Tool = {
  __typename?: 'Tool';
  awardsNoomcoin: Scalars['Boolean']['output'];
  contentUrl: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: ToolId;
  metadata?: Maybe<ToolMetadata>;
  pinned: Scalars['Boolean']['output'];
};

/** Graph provided by a specific tool */
export type ToolGraph = {
  __typename?: 'ToolGraph';
  /** Identifier of the tool that provides the graph */
  toolId: ToolId;
};

/** Header provided by a specific tool */
export type ToolHeader = {
  __typename?: 'ToolHeader';
  /** Identifier of the tool that provides the header */
  toolId: ToolId;
};

/**
 *  These values should be aligned with:
 *  - tool_configuration.proto (ToolConfigurationProto.Widget.Id)
 *  - tool_id_enum.proto (ToolIdEnumProto.Value)
 */
export enum ToolId {
  ActivityBrainDump = 'ACTIVITY_BRAIN_DUMP',
  ActivityCreatePositiveExperiences = 'ACTIVITY_CREATE_POSITIVE_EXPERIENCES',
  ActivityCreateSpace = 'ACTIVITY_CREATE_SPACE',
  ActivityDefuseThoughts = 'ACTIVITY_DEFUSE_THOUGHTS',
  ActivityFeelFeelings = 'ACTIVITY_FEEL_FEELINGS',
  ActivityFreeFeelings = 'ACTIVITY_FREE_FEELINGS',
  ActivityGametime = 'ACTIVITY_GAMETIME',
  ActivityGetGrounded = 'ACTIVITY_GET_GROUNDED',
  ActivityGratitudeRemix = 'ACTIVITY_GRATITUDE_REMIX',
  ActivityMove = 'ACTIVITY_MOVE',
  ActivityReframe = 'ACTIVITY_REFRAME',
  ActivityRideWaves = 'ACTIVITY_RIDE_WAVES',
  ActivitySelfCompassionBreak = 'ACTIVITY_SELF_COMPASSION_BREAK',
  ActivitySharpenToolkit = 'ACTIVITY_SHARPEN_TOOLKIT',
  ActivitySleep = 'ACTIVITY_SLEEP',
  ActivitySoothe = 'ACTIVITY_SOOTHE',
  ArticleConstipation = 'ARTICLE_CONSTIPATION',
  ArticleDiarrhea = 'ARTICLE_DIARRHEA',
  ArticleFatigue = 'ARTICLE_FATIGUE',
  ArticleHeadaches = 'ARTICLE_HEADACHES',
  ArticleHotFlashes = 'ARTICLE_HOT_FLASHES',
  ArticleIndigestion = 'ARTICLE_INDIGESTION',
  ArticleInjection = 'ARTICLE_INJECTION',
  ArticleMaintenanceHabits = 'ARTICLE_MAINTENANCE_HABITS',
  ArticleNausea = 'ARTICLE_NAUSEA',
  ArticleProteinGuide = 'ARTICLE_PROTEIN_GUIDE',
  ArticleScienceAm = 'ARTICLE_SCIENCE_AM',
  ArticleSleepCheatSheet = 'ARTICLE_SLEEP_CHEAT_SHEET',
  ArticleTaperingBestPractices = 'ARTICLE_TAPERING_BEST_PRACTICES',
  ArticleWorkoutsFitStrong = 'ARTICLE_WORKOUTS_FIT_STRONG',
  ArtBreak = 'ART_BREAK',
  Biomarkers = 'BIOMARKERS',
  BloodGlucose = 'BLOOD_GLUCOSE',
  BloodGlucoseTracking = 'BLOOD_GLUCOSE_TRACKING',
  BloodPressure = 'BLOOD_PRESSURE',
  BodyScan = 'BODY_SCAN',
  BreathingExercises = 'BREATHING_EXERCISES',
  CreateSpace = 'CREATE_SPACE',
  DailySteps = 'DAILY_STEPS',
  FitnessWorkouts = 'FITNESS_WORKOUTS',
  FoodColorLookUp = 'FOOD_COLOR_LOOK_UP',
  GroceryPlanner = 'GROCERY_PLANNER',
  Lessons = 'LESSONS',
  LogMeals = 'LOG_MEALS',
  Medication = 'MEDICATION',
  Meditation = 'MEDITATION',
  /**
   * Used to implement the Micro Challenges tool.
   * See TechDoc https://docs.google.com/document/d/1jff4LP18c-IwH5hXMpbqK42rQlB9a7WUz_UkKsR2E4I/edit?usp=sharing
   */
  MicroChallenges = 'MICRO_CHALLENGES',
  Mood = 'MOOD',
  Move = 'MOVE',
  MuscleDefense = 'MUSCLE_DEFENSE',
  PremiumMealPlans = 'PREMIUM_MEAL_PLANS',
  RapidRelief = 'RAPID_RELIEF',
  Recipes = 'RECIPES',
  Reframe = 'REFRAME',
  RideTheWave = 'RIDE_THE_WAVE',
  SelfCare = 'SELF_CARE',
  Sleep = 'SLEEP',
  Stress = 'STRESS',
  VideoMeditation = 'VIDEO_MEDITATION',
  WaterLogging = 'WATER_LOGGING',
  WeighIn = 'WEIGH_IN',
  Zumba = 'ZUMBA'
}

export type ToolList = {
  __typename?: 'ToolList';
  tools: Array<Tool>;
};

export type ToolMetadata = {
  __typename?: 'ToolMetadata';
  successKitMetadata?: Maybe<SuccessKitMetadata>;
};

export type ToolStatePatch = {
  newAwardsNoomcoin?: InputMaybe<Scalars['Boolean']['input']>;
  newEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  newIsInSuccessKit?: InputMaybe<Scalars['Boolean']['input']>;
  newPinned?: InputMaybe<Scalars['Boolean']['input']>;
  toolId: ToolId;
};

export type TrackerAssignment = {
  __typename?: 'TrackerAssignment';
  enabledOn?: Maybe<Scalars['LocalDate']['output']>;
  multiDayAssignment?: Maybe<MultiDayAssignment>;
  payload?: Maybe<TrackerAssignmentPayload>;
  title: Scalars['String']['output'];
  titleCompleted?: Maybe<Scalars['String']['output']>;
  type: TrackerTypes;
};

export type TrackerAssignmentPayload = ActivityDefaultPayload | BiomarkersTrackerPayload | BloodGlucoseTrackerPayload | DailyStepsPayload | FacialBloodScanTrackerPayload | LogMealsTrackerPayload | MedicationPayload | MedicationTrackerPayload | MicroChallengesTrackerPayload | WaterLoggingPayload;

export enum TrackerTypes {
  ActivityBrainDump = 'ACTIVITY_BRAIN_DUMP',
  ActivityCreatePositiveExperiences = 'ACTIVITY_CREATE_POSITIVE_EXPERIENCES',
  ActivityCreateSpace = 'ACTIVITY_CREATE_SPACE',
  ActivityDefuseThoughts = 'ACTIVITY_DEFUSE_THOUGHTS',
  ActivityFeelFeelings = 'ACTIVITY_FEEL_FEELINGS',
  ActivityFreeFeelings = 'ACTIVITY_FREE_FEELINGS',
  ActivityGametime = 'ACTIVITY_GAMETIME',
  ActivityGetGrounded = 'ACTIVITY_GET_GROUNDED',
  ActivityGratitudeRemix = 'ACTIVITY_GRATITUDE_REMIX',
  ActivityMove = 'ACTIVITY_MOVE',
  ActivityReframe = 'ACTIVITY_REFRAME',
  ActivityRideWaves = 'ACTIVITY_RIDE_WAVES',
  ActivitySelfCompassionBreak = 'ACTIVITY_SELF_COMPASSION_BREAK',
  ActivitySharpenToolkit = 'ACTIVITY_SHARPEN_TOOLKIT',
  ActivitySleep = 'ACTIVITY_SLEEP',
  ActivitySoothe = 'ACTIVITY_SOOTHE',
  /**  Used to implement the new "Biomarkers Tracker" tool for lab test results. */
  BiomarkersTracker = 'BIOMARKERS_TRACKER',
  BloodGlucose = 'BLOOD_GLUCOSE',
  /**
   *  Used to implement the new "Blood Glucose Tracker" tool.
   *  See TechDoc https://docs.google.com/document/d/1mLjt1JYdjBeAY3aN7jSjH4O9pEv3zCsJFnVeYAls1rQ/edit?usp=sharing.
   */
  BloodGlucoseTracker = 'BLOOD_GLUCOSE_TRACKER',
  BloodPressure = 'BLOOD_PRESSURE',
  BodyScan = 'BODY_SCAN',
  DailySteps = 'DAILY_STEPS',
  FacialBloodScan = 'FACIAL_BLOOD_SCAN',
  /**
   * Used to implement the new "Future Me" task.
   * See Tech Note https://docs.google.com/document/d/1bA6IprqRmhm5JO8IInTS6s3eqVm5a4Tm_OeBCDWZFwk/edit?tab=t.0
   */
  FutureMe = 'FUTURE_ME',
  LogMeals = 'LOG_MEALS',
  Medication = 'MEDICATION',
  /**
   *  Used to implement the new "Med Tracker" tool.
   *  See TechDoc https://docs.google.com/document/d/1wNlCuGib9WphyjZKDxrUgIr-VA_wzdK9Syzllh-vS20/edit.
   */
  MedicationTracker = 'MEDICATION_TRACKER',
  /**
   * Used to implement the Micro Challenges tracker.
   * See TechDoc https://docs.google.com/document/d/1jff4LP18c-IwH5hXMpbqK42rQlB9a7WUz_UkKsR2E4I/edit?usp=sharing
   */
  MicroChallenges = 'MICRO_CHALLENGES',
  Mood = 'MOOD',
  Sleep = 'SLEEP',
  Stress = 'STRESS',
  WaterLogging = 'WATER_LOGGING',
  WeighIn = 'WEIGH_IN'
}

/** URL tracking parameters */
export type TrackingParams = {
  /** Buyflow features enabled by parameter */
  feature: Array<Scalars['String']['input']>;
  /** Initial URL */
  initialUrl?: InputMaybe<Scalars['String']['input']>;
  /** Referrer string */
  referrer?: InputMaybe<Scalars['String']['input']>;
  /** The campaign of the link */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** What was clicked */
  utmContent?: InputMaybe<Scalars['String']['input']>;
  /** What medium the link came from */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** Identifies which site sent the traffic */
  utmSource?: InputMaybe<Scalars['String']['input']>;
  /** Search terms related to the link */
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

/** Trend information comparing current value to a previous measurement. */
export type Trend = {
  __typename?: 'Trend';
  /** Numerical change between measurements. */
  delta?: Maybe<Scalars['Float']['output']>;
  /** Direction of the trend. */
  direction: TrendDirection;
};

export type TrendChartAnnotation = {
  __typename?: 'TrendChartAnnotation';
  date: Scalars['LocalDate']['output'];
  style: MeasurementSnapshotStyle;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** All supported annotations */
export enum TrendChartAnnotationType {
  Medication = 'MEDICATION'
}

export type TrendChartEntry = TrendChartAnnotation | TrendChartMeasurement;

export type TrendChartMeasurement = {
  __typename?: 'TrendChartMeasurement';
  date: Scalars['LocalDate']['output'];
  value: Scalars['Float']['output'];
};

/** All supported measurements */
export enum TrendChartMeasurementType {
  Weight = 'WEIGHT'
}

/**
 * Direction of trend change. Note that "improving" or "worsening"
 * depends on the specific metric context.
 */
export enum TrendDirection {
  /** Trend indicates improvement in health metric. */
  Improving = 'IMPROVING',
  /** Trend shows no significant change. */
  Stable = 'STABLE',
  /** Trend indicates worsening in health metric. */
  Worsening = 'WORSENING'
}

/** Trends tab presentation */
export type TrendsTab = {
  __typename?: 'TrendsTab';
  /** Graph widgets to display in the Trends surface. */
  graphs: Array<GraphWidget>;
  /** Header widgets to display at the top of the Trends surface. */
  headers: Array<HeaderWidget>;
};

export type TriggerFaceScanResponse = {
  __typename?: 'TriggerFaceScanResponse';
  scanId?: Maybe<Scalars['UUID']['output']>;
};

/** These values should be aligned with ufc types from noom-contracts/coaching/CoachUfcTypeEnumProto */
export enum UfcType {
  Careteam = 'CARETEAM',
  Clinician = 'CLINICIAN',
  CoachOnDemand = 'COACH_ON_DEMAND',
  Guide = 'GUIDE',
  MhtClinician = 'MHT_CLINICIAN',
  Nmc = 'NMC',
  Premium = 'PREMIUM',
  SeniorNmc = 'SENIOR_NMC',
  Unknown = 'UNKNOWN'
}

/** User is not enrolled in rewards program, e.g. before earning the first Noomcoin. */
export type UnenrolledRewardsState = {
  __typename?: 'UnenrolledRewardsState';
  /** Dummy field, needed since GraphQL doesn't support empty types: https://github.com/graphql/graphql-spec/issues/568 */
  dummy?: Maybe<Scalars['Boolean']['output']>;
};

export type UpcomingMedicationDose = {
  __typename?: 'UpcomingMedicationDose';
  /** Date the dose should be taken on */
  dueDate: Scalars['LocalDate']['output'];
  /** Medication info: external_id, name, image_url */
  medication: MedicationInfo;
};

/**  Upcoming medication doses that user should take */
export type UpcomingMedicationDoseList = {
  __typename?: 'UpcomingMedicationDoseList';
  /** Metadata for fetching the next page of upcoming doses, if applicable */
  pageInfo?: Maybe<CursorPageInfo>;
  /** List of upcoming doses */
  upcomingDoses: Array<UpcomingMedicationDose>;
};

/** Input type for updating an art gallery (all fields optional for PATCH operations). */
export type UpdateArtGalleryInput = {
  /** The list of art piece IDs to associate with this gallery */
  artPieceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Updated URL to background music for the gallery experience */
  backgroundMusicUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated URL to the cover photo for the gallery */
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated reflection question associated with the gallery */
  reflectionQuestion?: InputMaybe<Scalars['String']['input']>;
  /** Updated URL to the thumbnail image for the gallery */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated title of the art gallery */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating an art piece (all fields optional for PATCH operations). */
export type UpdateArtPieceInput = {
  /** Updated names of the artists who created this piece */
  artistNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Updated description of the art piece */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated display time period for the art piece */
  displayTimePeriod?: InputMaybe<Scalars['String']['input']>;
  /** Updated location hosting the art */
  hostedAt?: InputMaybe<Scalars['String']['input']>;
  /** Updated URL to the image of the art piece */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated medium/type of the artwork */
  medium?: InputMaybe<ArtPieceMedium>;
  /** Updated title of the art piece */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Updated year the art piece was created */
  yearCreated?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateInterstitialInput = {
  communityHint?: InputMaybe<Scalars['LocalDate']['input']>;
  communityIntroAnnouncement?: InputMaybe<Scalars['LocalDate']['input']>;
  successKitIntro?: InputMaybe<Scalars['LocalDate']['input']>;
};

/**
 * Input type for updating an existing scheduled content.
 * All fields are optional to support partial updates.
 */
export type UpdateScheduledContentInput = {
  /** Updated ID of the content to be scheduled (e.g., art gallery ID) */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** Updated type of content being scheduled */
  contentType?: InputMaybe<ScheduledContentType>;
  /** Updated end date and time of the scheduled content */
  endDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Updated start date and time of the scheduled content */
  startDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  /** Updated status of the scheduled content */
  status?: InputMaybe<ContentStatus>;
};

/** Input type for uploading an art piece image. */
export type UploadArtPieceImageInput = {
  /** URL to the image to be uploaded (required) */
  imageUrl: Scalars['String']['input'];
};

/** Response type for art piece image upload. */
export type UploadArtPieceImageResponse = {
  __typename?: 'UploadArtPieceImageResponse';
  /** URL to the uploaded image */
  imageUrl: Scalars['String']['output'];
};

/** Union type for different upsell ad content types. */
export type UpsellAdContent = HealthReportUpsellContent | HomeLargeContent | HomeScreenCarouselTileContent | MealFeedbackScreenContent | NavigationButtonContent | SideNavMenuSmallContent | UserportalHomePageContent | WeightGraphContent | WeightGraphInlineContent;

/** Payload for a location's ad placement. */
export type UpsellAdData = {
  __typename?: 'UpsellAdData';
  /** The content of the upsell ad. */
  content?: Maybe<UpsellAdContent>;
  upsellAdIdentifier: Scalars['String']['output'];
  upsellAdLocation: UpsellAdLocation;
  upsellAdType: UpsellAdType;
};

export type UpsellAdDataList = {
  __typename?: 'UpsellAdDataList';
  upsellAdData: Array<UpsellAdData>;
};

export enum UpsellAdLocation {
  /** Large Ad placement in Body Scan */
  BodyscanLarge = 'BODYSCAN_LARGE',
  /** Small Ad placement in Body Scan */
  BodyscanSmall = 'BODYSCAN_SMALL',
  /** Ad placement in chat lobby */
  ChatLobby = 'CHAT_LOBBY',
  /** Ad that can be present in the coach chat (mostly at the top) */
  CoachChat = 'COACH_CHAT',
  /** Ad that can be present on the coach's profile page. */
  CoachProfilePage = 'COACH_PROFILE_PAGE',
  /** Ad placement in FitOn */
  Fiton = 'FITON',
  /** Ad placement in the hamburger menu */
  Hamburger = 'HAMBURGER',
  /** Ad placement for home screen carousel */
  HomeCarousel = 'HOME_CAROUSEL',
  /** Large Ad placement in Home */
  HomeLarge = 'HOME_LARGE',
  /** Ad placement during in-app face scan for health report upsells. */
  InAppHealthReport = 'IN_APP_HEALTH_REPORT',
  /** Ad placement in the meal feedback screen. */
  MealFeedback = 'MEAL_FEEDBACK',
  /** Ad placement in the meal feedback screen content. */
  MealFeedbackContent = 'MEAL_FEEDBACK_CONTENT',
  /** Upsell that is automatically triggered when meal logging is completed. */
  MealLoggingCompletionAutomatic = 'MEAL_LOGGING_COMPLETION_AUTOMATIC',
  /**
   * Ad placement in the meal logging method selector.
   * @deprecated Never used. Use button-specific locations below.
   */
  MealLoggingMethodSelector = 'MEAL_LOGGING_METHOD_SELECTOR',
  /** Ad placement in the meal logging method selector barcode button. */
  MealLoggingMethodSelectorBarcode = 'MEAL_LOGGING_METHOD_SELECTOR_BARCODE',
  /** Ad placement in the meal logging method selector history button. */
  MealLoggingMethodSelectorHistory = 'MEAL_LOGGING_METHOD_SELECTOR_HISTORY',
  /** Ad placement in the meal logging method selector search button. */
  MealLoggingMethodSelectorSearch = 'MEAL_LOGGING_METHOD_SELECTOR_SEARCH',
  /** No known location. */
  None = 'NONE',
  /** Ad placement during onboarding face scan for health report upsells. */
  OnboardingHealthReport = 'ONBOARDING_HEALTH_REPORT',
  /** Upsell that is automatically triggered on step completion. */
  StepGoalCompletionAutomatic = 'STEP_GOAL_COMPLETION_AUTOMATIC',
  /** Ad placement with a button in the topnav */
  TopnavButton = 'TOPNAV_BUTTON',
  /** Default status for enums. */
  Uknown = 'UKNOWN',
  /** Ad placement in the user portal homepage. */
  UserportalHomepage = 'USERPORTAL_HOMEPAGE',
  /** Ad placement in weight graph (after weigh in is recorded) */
  WeightGraph = 'WEIGHT_GRAPH',
  /** Ad placement in the weight graph screen. */
  WeightGraphInline = 'WEIGHT_GRAPH_INLINE',
  /** Ad placement in the Welli meal insight component. */
  WelliMealInsight = 'WELLI_MEAL_INSIGHT'
}

/** Content for an ad testimonial. */
export type UpsellAdTestimonial = {
  __typename?: 'UpsellAdTestimonial';
  /** The author to attribute the testimonial to. */
  author?: Maybe<Scalars['String']['output']>;
  /** The url of the image to show. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The text of the testimony. */
  testimony?: Maybe<Scalars['String']['output']>;
  /** The amount of weight lost. */
  weightLostInKg?: Maybe<Scalars['Int']['output']>;
};

export enum UpsellAdType {
  /** Used for ads to purchase the baseline Healthy Weight program */
  HealthyWeight = 'HEALTHY_WEIGHT',
  /** Used for advertising ads to purchase med */
  Med = 'MED',
  /** No upsell ad id. */
  None = 'NONE',
  /** Used for advertising ads to purchase premium */
  Premium = 'PREMIUM',
  /** Used for advertising ads to purchase premium plus is user is eligible for premium plus */
  PremiumPlus = 'PREMIUM_PLUS',
  /** Default status for enums. */
  Uknown = 'UKNOWN'
}

/** Tracks the user's challenge capacity and restrictions. */
export type Usage = {
  __typename?: 'Usage';
  /** Current number of active challenges the user has */
  activeCount: Scalars['Int']['output'];
  /**
   * Whether the user can start a new challenge.
   * False if they've reached the maximum number of active challenges or other restrictions apply.
   */
  canStartNewChallenge: Scalars['Boolean']['output'];
  /** Maximum number of active challenges allowed */
  maxCount: Scalars['Int']['output'];
};

/** Enumerates the policies that must be consented to */
export type UserConsentCheck = {
  __typename?: 'UserConsentCheck';
  /** Will be null if user consents are up-to-date */
  prompt?: Maybe<UserConsentInterstitial>;
  /** Will be empty if consents are up-to-date */
  requiredConsents: Array<Policy>;
};

/** Backend-driven content for home screen interstitial */
export type UserConsentInterstitial = {
  __typename?: 'UserConsentInterstitial';
  /** Markdown-formatted string containing links to the relevant policies */
  body: Scalars['String']['output'];
  positiveButtonText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type UserGoal = {
  __typename?: 'UserGoal';
  enabled: Scalars['Boolean']['output'];
  goalId: GoalId;
  metadata?: Maybe<GoalMetadata>;
  userGoalId: Scalars['String']['output'];
};

export type UserGoalList = {
  __typename?: 'UserGoalList';
  userGoalList: Array<UserGoal>;
};

export type UserGoalPatch = {
  /** The source of user steps goal upsert action. If empty, then the action source will be empty in noom events */
  actionSource?: InputMaybe<UserGoalUpsertActionSource>;
  /** If true, then enable the tool; if false, then disable it. If empty, the enablement of the tool won't be affected */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The updated list of days of the week on which the goal is scheduled */
  scheduleDaysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  /** The new value that the goal target should have. If empty, then the target won't be affected */
  target?: InputMaybe<GoalTarget>;
};

/**
 *  These values should be aligned with:
 *  - shared.proto (GoalsEnumsProto.UserGoalUpsertActionSourceEnumProto.ActionSource)
 */
export enum UserGoalUpsertActionSource {
  Automated = 'AUTOMATED',
  Default = 'DEFAULT',
  Manual = 'MANUAL',
  Unknown = 'UNKNOWN'
}

/**
 * Represents a user's instance of a micro challenge.
 * This is a user-specific instance linking to the challenge definition.
 */
export type UserMicroChallenge = {
  __typename?: 'UserMicroChallenge';
  /**
   * Whether the user can record progress for the currently selected date.
   * False if the user has already recorded progress for that date or if the challenge is not active.
   * Used to enable/disable the "Did it" button in the UI.
   * @deprecated Use microChallenge.availableActions.start.isEnabled instead
   */
  canRecordProgress: Scalars['Boolean']['output'];
  /** Current progress value (e.g., number of days completed) */
  currentProgress: Scalars['Int']['output'];
  /**
   * When the challenge ends (user's local date)
   * Used to calculate days remaining
   */
  endDate: Scalars['LocalDate']['output'];
  /** The micro challenge definition (template) that this instance is based on */
  microChallenge: MicroChallenge;
  /** Current status of the challenge */
  status: MicroChallengeStatus;
  /**
   * Target progress needed for completion (e.g., number of required success days).
   * @deprecated Use microChallenge.targetProgress instead. This field is duplicated here for backwards compatibility.
   * @deprecated Use microChallenge.targetProgress instead
   */
  targetProgress: Scalars['Int']['output'];
  /** Unique identifier for this user's challenge instance */
  userMicroChallengeId: Scalars['UUID']['output'];
};

export type UserModelSegment = {
  __typename?: 'UserModelSegment';
  /** User who created the segment */
  creator: Scalars['String']['output'];
  /** Segment's description */
  description?: Maybe<Scalars['String']['output']>;
  /** Segment ID */
  id: Scalars['ID']['output'];
  /** Whether the segment has been archived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the segment is locked for editing */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Segment name */
  name: Scalars['String']['output'];
  /** Server time created */
  serverTimeCreated?: Maybe<Scalars['LocalDateTime']['output']>;
  /** Server time updated */
  serverTimeUpdated?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type UserModelSegments = {
  __typename?: 'UserModelSegments';
  segments: Array<UserModelSegment>;
};

/**  A record of the user's decision for a given policy */
export type UserPolicyOption = {
  __typename?: 'UserPolicyOption';
  accessCode: Scalars['String']['output'];
  /**  The specific policy the user acted upon */
  policy: Policy;
  /**  The user's response for the policy */
  status: PolicyOptionStatus;
};

/** Response containing multiple user preview profiles */
export type UserPreviewProfilesBatchResponse = {
  __typename?: 'UserPreviewProfilesBatchResponse';
  /** List of user preview profiles */
  profiles: Array<NoomUserPreviewProfile>;
};

/** Content for a single tile in the user portal homepage ad placement. */
export type UserportalHomePageContent = {
  __typename?: 'UserportalHomePageContent';
  /** The CTA button for the content block. */
  button?: Maybe<Button>;
  /** The text of the disclaimer, if applicable. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** The text of the header pill. */
  heading?: Maybe<Scalars['String']['output']>;
  /** The url of the image to show in the header pill. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The text content of the banner. */
  subtitle: Scalars['String']['output'];
  /** The title of the content block. */
  title: Scalars['String']['output'];
};

/** The response from an address validation request. */
export type ValidateAddressResponse = {
  __typename?: 'ValidateAddressResponse';
  /**
   * The validated address, potentially corrected. If invalid,
   * this returned address may not be populated and should not
   * be used.
   */
  address: ValidationAddress;
  /**
   * If the ValidationStatus is RECOMMENDED_FIX or INVALID, this
   * will be populated with the reason(s) that the validation failed.
   * This will not be populated if the address is VALID or CORRECTED.
   */
  errorReasons?: Maybe<Array<ValidationErrorReason>>;
  /** The validation status of the input address. */
  status: ValidationStatus;
  /** The validation service that was used for this request. */
  validationService: ValidationService;
};

/** A postal address used for validation purposes. */
export type ValidationAddress = {
  __typename?: 'ValidationAddress';
  /** The first address line, typically street number and street. */
  addressLine1: Scalars['String']['output'];
  /** The second address line, often for an apartment or house number. */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** The city or town */
  city: Scalars['String']['output'];
  /** A 2-character country code using ISO 3166-1 alpha-2 */
  countryCode: Scalars['String']['output'];
  /** The zip code in the U.S. or other postal code */
  postalCode: Scalars['String']['output'];
  /** The state, region, or province */
  zoneCode: Scalars['String']['output'];
};

/** The postal address input for validation purposes. */
export type ValidationAddressInput = {
  /** The first address line, typically street number and street. */
  addressLine1: Scalars['String']['input'];
  /** The second address line, often for an apartment or house number. */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city or town */
  city: Scalars['String']['input'];
  /** A 2-character country code using ISO 3166-1 alpha-2 */
  countryCode: Scalars['String']['input'];
  /** The zip code in the U.S. or other postal code */
  postalCode: Scalars['String']['input'];
  /** The state, region, or province */
  zoneCode: Scalars['String']['input'];
};

/** The reason an address validation failed. */
export type ValidationErrorReason = {
  __typename?: 'ValidationErrorReason';
  /** The reason. */
  reason?: Maybe<Reason>;
};

/** The external service used to perform the validation. */
export enum ValidationService {
  /**
   * Legacy USA address validation service. Also known as Thomson Reuters,
   * which acquired Sabrix.
   */
  Sabrix = 'SABRIX',
  /**
   * Legacy CA and International address validation service.
   * https://www.serviceobjects.com/
   */
  ServiceObjects = 'SERVICE_OBJECTS',
  /** https://www.smarty.com/docs/cloud/us-street-api */
  SmartyUsStreetApi = 'SMARTY_US_STREET_API'
}

/** The status of the validated address. */
export enum ValidationStatus {
  /**
   * The address passed in was automatically corrected by our validation
   * service, and the resulting address is valid.
   */
  Corrected = 'CORRECTED',
  /**
   * This address passed in was invalid and the user must input a valid
   * address. The user is blocked from proceeding.
   */
  Invalid = 'INVALID',
  /**
   * The address passed in had some issues with our validation, but the
   * address may still be valid. We will provide some recommended fixes that
   * the user can apply, but do not block the user from proceeding.
   */
  RecommendedFix = 'RECOMMENDED_FIX',
  /** The address passed in was completely valid. */
  Valid = 'VALID'
}

export type ValidicAttributionDataInput = {
  /** Identifier of the device. */
  sourceIdentifier: Scalars['String']['input'];
  /** Human-readable name of the source. */
  sourceName: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type ValidicV2AttributionDataInput = {
  /** Identifier of the device. */
  sourceIdentifier: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

/** Represents a value proposition for the health report upsell. */
export type ValueProps = {
  __typename?: 'ValueProps';
  /** Represents the image to be shown as part of the value proposition. */
  imageUrl: Scalars['String']['output'];
  /** Text explaining the value proposition. */
  text: Scalars['String']['output'];
};

export type WaterData = {
  __typename?: 'WaterData';
  measurementCivilDate: Scalars['LocalDate']['output'];
  waterInLiters: Scalars['Float']['output'];
};

export type WaterDataInput = {
  measurementCivilDate: Scalars['LocalDate']['input'];
  waterInLiters: Scalars['Float']['input'];
};

export type WaterGoalMetadata = {
  __typename?: 'WaterGoalMetadata';
  minWaterInLiters?: Maybe<Scalars['Float']['output']>;
};

export type WaterLoggingPayload = {
  __typename?: 'WaterLoggingPayload';
  targetInLiters: Scalars['Float']['output'];
};

export type WaterTarget = {
  minWaterInLiters?: InputMaybe<Scalars['Float']['input']>;
};

export type WeightData = {
  __typename?: 'WeightData';
  loggedInSignupFlow?: Maybe<Scalars['Boolean']['output']>;
  measurementCivilDate: Scalars['LocalDate']['output'];
  weightInKg: Scalars['Float']['output'];
};

export type WeightDataInput = {
  loggedInSignupFlow?: InputMaybe<Scalars['Boolean']['input']>;
  measurementCivilDate: Scalars['LocalDate']['input'];
  weightInKg: Scalars['Float']['input'];
};

/** Content for the bottom screen in weight graph flow. */
export type WeightGraphBottomScreen = {
  __typename?: 'WeightGraphBottomScreen';
  /** Primary button to respond to the bottom screen. */
  buttonFirst?: Maybe<Button>;
  /** Optional second button for the bottom screen. */
  buttonSecond?: Maybe<Button>;
  /** Text to display on the bottom screen. */
  text?: Maybe<Scalars['String']['output']>;
  /** Title of the bottom screen. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Content for an ad that appears after the user logs a weigh in. */
export type WeightGraphContent = {
  __typename?: 'WeightGraphContent';
  /** The initial screen to show to the user. */
  initialScreenId: Scalars['String']['output'];
  /** A list of screens that can be navigated by the user. */
  screens: Array<WeightGraphContentScreen>;
};

/** A screen in the weight graph content flow. */
export type WeightGraphContentScreen = {
  __typename?: 'WeightGraphContentScreen';
  /** The content of this screen. */
  content: WeightGraphContentScreenContent;
  /** Id for this screen. */
  screenId: Scalars['String']['output'];
};

/** Union type for different weight graph screen content types. */
export type WeightGraphContentScreenContent = WeightGraphBottomScreen | WeightGraphPlateauAd | WeightGraphResourcesScreen;

/** Content for displaying a meal feedback screen upsell ad. */
export type WeightGraphInlineContent = {
  __typename?: 'WeightGraphInlineContent';
  /** Button configuration for the weight graph screen upsell ad. */
  button?: Maybe<Button>;
  /** Heading to display on the weight graph screen upsell ad. */
  heading: Scalars['String']['output'];
  /** URL of the image to display on the weight graph screen upsell ad. */
  imageUrl: Scalars['String']['output'];
  /** Text to display on the weight graph screen upsell ad. */
  text: Scalars['String']['output'];
};

/** Content for the plateau ad in weight graph flow. */
export type WeightGraphPlateauAd = {
  __typename?: 'WeightGraphPlateauAd';
  /** Button on the bottom left of the plateau ad. */
  buttonLeft?: Maybe<Button>;
  /** Button on the bottom right of the plateau ad. */
  buttonRight?: Maybe<Button>;
  /** Heading to display on the plateau ad. */
  heading?: Maybe<Scalars['String']['output']>;
  /** URL of the image for the plateau ad. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Date we advertise the medication weight can be achieved on. */
  medWeightDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Weight we advertise the user can achieve with medication. */
  medWeightInKg?: Maybe<Scalars['Float']['output']>;
  /** Text to place on the plateau ad. */
  text?: Maybe<Scalars['String']['output']>;
  /** Title to place on the plateau ad. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Content for the resources screen in weight graph flow. */
export type WeightGraphResourcesScreen = {
  __typename?: 'WeightGraphResourcesScreen';
  /** List of plateau resources available. */
  resources: Array<PlateauResource>;
  /** Subtitle of the resources screen. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title of the resources screen. */
  title?: Maybe<Scalars['String']['output']>;
};

export type WeightMedsSnapshot = {
  __typename?: 'WeightMedsSnapshot';
  body?: Maybe<Scalars['String']['output']>;
  ctaTitle: Scalars['String']['output'];
  /** Encouragement text should be sent as markdown. Deep Links use supported. */
  encouragementMarkdown?: Maybe<Scalars['String']['output']>;
  graph: AnnotatedMeasurementTrendChart;
  headerAnimation: HeaderAnimation;
  sideEffectsSection?: Maybe<SideEffectsSection>;
  title: Scalars['String']['output'];
};

export type AssessmentPrivacyPolicyQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  assessmentType: HealthMetricSource;
}>;


export type AssessmentPrivacyPolicyQuery = { __typename?: 'Query', assessmentPrivacyPolicy: Policy };

export type FacialBloodScanIntroMetadataQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type FacialBloodScanIntroMetadataQuery = { __typename?: 'Query', facialBloodScanIntroMetadata: { __typename?: 'FacialBloodScanIntroMetadata', facialBloodScanCount: number, hasDateOfBirth: boolean, hasCompletedQuestionnaire?: boolean | null } };

export type GenerateInviteFriendLinkMutationVariables = Exact<{
  accessCode: Scalars['String']['input'];
}>;


export type GenerateInviteFriendLinkMutation = { __typename?: 'Mutation', generateInviteFriendLink: { __typename?: 'InviteFriendLink', code: string, link: string } };

export type HealthReportQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type HealthReportQuery = { __typename?: 'Query', healthReport: { __typename?: 'HealthReport', dateOfLastAssessment: string, assessments?: Array<{ __typename?: 'Assessment', assessmentId?: string | null, assessmentType?: HealthMetricSource | null }> | null, heartHealth?: { __typename?: 'HealthPillarReport', name: HealthPillarName, status?: HealthStatus | null, sections: Array<{ __typename?: 'HealthPillarSection', name: HealthPillarSectionName, metrics: Array<{ __typename?: 'HealthMetric', name: HealthMetricName, latestMetricValue: { __typename?: 'HealthMetricValue', value?: number | null, unit?: HealthMetricUnit | null, status?: HealthStatus | null, timestamp: string }, detail: { __typename?: 'HealthMetricDetail', source?: HealthMetricSource | null, weight?: number | null, healthLabels: Array<{ __typename?: 'HealthLabelRange', status: HealthStatus, min?: number | null, max?: number | null, unit?: HealthMetricUnit | null }> } }> }> } | null, metabolicHealth?: { __typename?: 'HealthPillarReport', name: HealthPillarName, status?: HealthStatus | null, sections: Array<{ __typename?: 'HealthPillarSection', name: HealthPillarSectionName, metrics: Array<{ __typename?: 'HealthMetric', name: HealthMetricName, latestMetricValue: { __typename?: 'HealthMetricValue', value?: number | null, unit?: HealthMetricUnit | null, status?: HealthStatus | null, timestamp: string }, detail: { __typename?: 'HealthMetricDetail', source?: HealthMetricSource | null, weight?: number | null, healthLabels: Array<{ __typename?: 'HealthLabelRange', status: HealthStatus, min?: number | null, max?: number | null, unit?: HealthMetricUnit | null }> } }> }> } | null, bodyAgeReport?: { __typename?: 'BodyAgeReport', bodyAge: number, realAge: number, trendSinceLastScan?: { __typename?: 'Trend', direction: TrendDirection, delta?: number | null } | null } | null } };

export type UpsellAdDataListQueryVariables = Exact<{
  accessCode: Scalars['String']['input'];
  adLocation?: InputMaybe<UpsellAdLocation>;
}>;


export type UpsellAdDataListQuery = { __typename?: 'Query', upsellAdDataList: { __typename?: 'UpsellAdDataList', upsellAdData: Array<{ __typename?: 'UpsellAdData', upsellAdType: UpsellAdType, upsellAdLocation: UpsellAdLocation, upsellAdIdentifier: string, content?: { __typename: 'HealthReportUpsellContent', productName: string, startsAtPriceText: string, disclaimers: Array<string>, healthReportUpsellPageTitle?: string | null, healthReportUpsellPageSubtitle?: string | null, headerImageUrl?: string | null, learnMorePageTitle: string, upsellAdUrl?: string | null, appendixText?: string | null, primaryButton?: { __typename?: 'Button', text: string, target: string, style?: ButtonStyle | null, size?: ButtonSize | null } | null, secondaryButton?: { __typename?: 'Button', text: string, target: string, style?: ButtonStyle | null, size?: ButtonSize | null } | null, biologicalAgeInfo?: { __typename?: 'HealthMetricUpsellBiologicalAge', currentAge: number, healthyBmiAge: number, faceScanAge?: number | null } | null, valueProps: Array<{ __typename?: 'ValueProps', imageUrl: string, text: string }>, healthMetricsOverview: Array<{ __typename?: 'HealthMetricOverviewContent', metricClaimFraming: string, arrowImageUrl: string }>, healthMetricUpsellContentGroups: Array<{ __typename?: 'HealthMetricUpsellLearnMoreContentGroup', subtitle: string, metrics: Array<{ __typename?: 'HealthMetricUpsellLearnMoreContent', metricType: HealthMetricName, label: HealthStatus, metricTitle: string, metricDescription: string, footnotes: string, labelDescription: string }> }> } | { __typename: 'HomeLargeContent' } | { __typename: 'HomeScreenCarouselTileContent' } | { __typename: 'MealFeedbackScreenContent' } | { __typename: 'NavigationButtonContent' } | { __typename: 'SideNavMenuSmallContent' } | { __typename: 'UserportalHomePageContent' } | { __typename: 'WeightGraphContent' } | { __typename: 'WeightGraphInlineContent' } | null }> } };

export type RecommendedBuyflowOffersQueryVariables = Exact<{
  input: RecommendedBuyflowOffersInput;
}>;


export type RecommendedBuyflowOffersQuery = { __typename?: 'Query', recommendedBuyflowOffers: { __typename?: 'RecommendedBuyflowOffersResponse', offers: Array<string>, recommendationId: string } };

export type SaveFacialBloodScanQuestionnaireMutationVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  input: SaveFacialBloodScanQuestionnaireInput;
}>;


export type SaveFacialBloodScanQuestionnaireMutation = { __typename?: 'Mutation', saveQuestionnaire: boolean };

export type SubmitConsentMutationVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  agreedToPolicies: Array<Policy> | Policy;
}>;


export type SubmitConsentMutation = { __typename?: 'Mutation', submitConsent?: boolean | null };

export type ValidateAddressQueryVariables = Exact<{
  address: ValidationAddressInput;
  validationService?: InputMaybe<ValidationService>;
}>;


export type ValidateAddressQuery = { __typename?: 'Query', validateAddress: { __typename?: 'ValidateAddressResponse', status: ValidationStatus, validationService: ValidationService, address: { __typename?: 'ValidationAddress', addressLine1: string, addressLine2?: string | null, city: string, zoneCode: string, postalCode: string, countryCode: string }, errorReasons?: Array<{ __typename?: 'ValidationErrorReason', reason?: Reason | null }> | null } };

export type AutocompleteAddressQueryVariables = Exact<{
  queryString: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  autocompleteService?: InputMaybe<AutocompleteService>;
}>;


export type AutocompleteAddressQuery = { __typename?: 'Query', autocompleteAddress: { __typename?: 'AutocompleteAddressResponse', autocompleteService: AutocompleteService, addresses: Array<{ __typename?: 'AutocompleteAddress', fullAddress: string, addressLine1: string, addressLine2?: string | null, city: string, zoneCode: string, fullZoneCode: string, postalCode: string, countryCode: string }> } };


export const AssessmentPrivacyPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssessmentPrivacyPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assessmentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HealthMetricSource"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentPrivacyPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"assessmentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assessmentType"}}}]}]}}]} as unknown as DocumentNode<AssessmentPrivacyPolicyQuery, AssessmentPrivacyPolicyQueryVariables>;
export const FacialBloodScanIntroMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacialBloodScanIntroMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facialBloodScanIntroMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facialBloodScanCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasDateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedQuestionnaire"}}]}}]}}]} as unknown as DocumentNode<FacialBloodScanIntroMetadataQuery, FacialBloodScanIntroMetadataQueryVariables>;
export const GenerateInviteFriendLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateInviteFriendLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateInviteFriendLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<GenerateInviteFriendLinkMutation, GenerateInviteFriendLinkMutationVariables>;
export const HealthReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HealthReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"healthReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateOfLastAssessment"}},{"kind":"Field","name":{"kind":"Name","value":"assessments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assessmentId"}},{"kind":"Field","name":{"kind":"Name","value":"assessmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heartHealth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latestMetricValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"healthLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metabolicHealth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latestMetricValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"healthLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bodyAgeReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bodyAge"}},{"kind":"Field","name":{"kind":"Name","value":"realAge"}},{"kind":"Field","name":{"kind":"Name","value":"trendSinceLastScan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HealthReportQuery, HealthReportQueryVariables>;
export const UpsellAdDataListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpsellAdDataList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adLocation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsellAdLocation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsellAdDataList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"adLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adLocation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsellAdData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsellAdType"}},{"kind":"Field","name":{"kind":"Name","value":"upsellAdLocation"}},{"kind":"Field","name":{"kind":"Name","value":"upsellAdIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HealthReportUpsellContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"startsAtPriceText"}},{"kind":"Field","name":{"kind":"Name","value":"disclaimers"}},{"kind":"Field","name":{"kind":"Name","value":"healthReportUpsellPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"healthReportUpsellPageSubtitle"}},{"kind":"Field","name":{"kind":"Name","value":"headerImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"learnMorePageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"upsellAdUrl"}},{"kind":"Field","name":{"kind":"Name","value":"appendixText"}},{"kind":"Field","name":{"kind":"Name","value":"primaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"style"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"biologicalAgeInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentAge"}},{"kind":"Field","name":{"kind":"Name","value":"healthyBmiAge"}},{"kind":"Field","name":{"kind":"Name","value":"faceScanAge"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valueProps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthMetricsOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricClaimFraming"}},{"kind":"Field","name":{"kind":"Name","value":"arrowImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthMetricUpsellContentGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metricType"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"metricTitle"}},{"kind":"Field","name":{"kind":"Name","value":"metricDescription"}},{"kind":"Field","name":{"kind":"Name","value":"footnotes"}},{"kind":"Field","name":{"kind":"Name","value":"labelDescription"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsellAdDataListQuery, UpsellAdDataListQueryVariables>;
export const RecommendedBuyflowOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecommendedBuyflowOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendedBuyflowOffersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendedBuyflowOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"}},{"kind":"Field","name":{"kind":"Name","value":"recommendationId"}}]}}]}}]} as unknown as DocumentNode<RecommendedBuyflowOffersQuery, RecommendedBuyflowOffersQueryVariables>;
export const SaveFacialBloodScanQuestionnaireDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveFacialBloodScanQuestionnaire"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveFacialBloodScanQuestionnaireInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveQuestionnaire"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SaveFacialBloodScanQuestionnaireMutation, SaveFacialBloodScanQuestionnaireMutationVariables>;
export const SubmitConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitConsent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreedToPolicies"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Policy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitConsent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"agreedToPolicies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreedToPolicies"}}}]}]}}]} as unknown as DocumentNode<SubmitConsentMutation, SubmitConsentMutationVariables>;
export const ValidateAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationAddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validationService"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"validationService"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validationService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zoneCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validationService"}}]}}]}}]} as unknown as DocumentNode<ValidateAddressQuery, ValidateAddressQueryVariables>;
export const AutocompleteAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutocompleteAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autocompleteService"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AutocompleteService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autocompleteAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"queryString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryString"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxResults"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxResults"}}},{"kind":"Argument","name":{"kind":"Name","value":"autocompleteService"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autocompleteService"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zoneCode"}},{"kind":"Field","name":{"kind":"Name","value":"fullZoneCode"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"autocompleteService"}}]}}]}}]} as unknown as DocumentNode<AutocompleteAddressQuery, AutocompleteAddressQueryVariables>;